/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseClasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="register.types.ts" />

module Meevo.Plugins.Register {
    "use strict";

    interface ISelfPayTippyEligibility {
        pre: boolean,
        post: boolean,
        isUnauthorized: boolean,
        continueWithSelfPay: boolean //continue with Self Pay process even if it is unauthorized (invalid Account Token)
    }

    export class RegisterContext {
        // temporary until we can move this into DI
        get $translate() { return this.registerController.$translate; }
        get $filter() { return this.registerController.$filter; }
        get $location() { return this.registerController.$location; }
        get $anchorScroll() { return this.registerController.$anchorScroll; }
        get $q() { return this.registerController.$q; }
        get $timeout() { return this.registerController.$timeout; }
        get $scope() { return this.registerController.$scope; }
        get $rootScope() { return this.registerController.$rootScope; }
        get $mdDialog() { return this.registerController.$mdDialog; }
        get $mdToast() { return this.registerController.$mdToast; }
        get $http() { return this.registerController.$http; }
        get lotUtil() { return Meevo.Components.Common.LotAllocationUtil; }

        get appSettings() { return this.registerController.appSettings; }
        get dataService() { return this.registerController.dataService; }
        get identityService() { return this.registerController.identityService; }
        get securityService() { return this.registerController.securityService; }
        get modalService() { return this.registerController.modalService; }
        get busyService() { return this.registerController.busyService; }
        get printService() { return this.registerController.printService; }
        get clientMemberDataService() { return this.registerController.clientMemberDataService; }
        get hostedPageService() { return this.registerController.hostedPageService; }
        get rebookService() { return this.registerController.rebookService; }
        get roundingService() { return this.registerController.roundingService; }

        get registerTipService() { return this.registerController.registerTipService; }
        get registerNotesService() { return this.registerController.registerNotesService; }
        get registerDiscountService() { return this.registerController.registerDiscountService; }
        get registerGiftCardService() { return this.registerController.registerGiftCardService; }
        get registerCareCreditService() { return this.registerController.registerCareCreditService; }
        get registerTicketService() { return this.registerController.registerTicketService; }
        get paymentPlanService() { return this.registerController.paymentPlanService; }
        get registerClientAccountService() { return this.registerController.registerClientAccountService; }
        get tippyService() { return this.registerController.tippyService; }

        clientContext: Meevo.Plugins.Register.SpecifyClientSection;
        private productContext: Meevo.Plugins.Register.ProductsSection;
        public giftCardSection: Meevo.Plugins.Register.GiftCardSection;
        private buttonsSection: Meevo.Plugins.Register.ButtonsSection;
        private refundOptionsSection: RefundOptionsSection;
        payingClient: Model.SaleClient;
        payingClientType: Model.ClientTypeEnum;
        selectedClient: Model.SaleClient;
        returnStateClient: Model.SaleClient;
        returnStateSection: string;
        selectedClientType: Model.ClientTypeEnum;
        selectedEmployee: Model.EmployeeListItem;
        selectedTeacher: Model.EmployeeListItem;
        selectedClientAppointmentId: string;
        sale: Model.Sale;
        tempSaleLines: Model.SaleLine[] = [];
        // ClientMembership_TIds whose pre-finalize membership form has already been "sent now"
        membershipFormsSentNow: string[] = [];
        selectedSection: RegisterSectionBase;
        previouslySelectedSection: RegisterSectionBase;
        sectionTemplatePath = "app/plugins/register/";
        sections: RegisterSectionBase[] = [];
        giftCardPaymentsSection: GiftCardPaymentsSection;
        clientPointsPaymentsSection: ClientPointsPaymentsSection;
        cardOnFilePaymentsSection: CreditPaymentsSection;
        paymentPlanPaymentsSection: PaymentPlanPaymentsSection;
        paymentTypes: Model.PaymentTypeListItem[];
        paymentCats: RegisterPaymentCat[];
        allUniqueClients: RegisterClient[] = [];
        editSelectedClient: boolean = false;
        allUniqueServices: any = {};
        showToday: boolean = false;
        selectedDrawer: Meevo.Model.Drawer = { displayName: "Unassigned Drawer", cashAmount: 0 };
        selectedPrinter: Meevo.Model.Device;
        selectedTerminal: Meevo.Model.MerchantTerminal;
        selectedMerchantAccount: Meevo.Model.MerchantAccount;
        isMerchantAccountLoading: boolean = false;
        defaultMerchantAccount: Meevo.Model.MerchantAccount;
        showDrawerManager: boolean = false;
        saleId: string;
        firstClientEmailAddress: string;
        multipleClients: boolean = false;
        firstClientId: string;
        transactionDateTime: string;
        transactionId: string;
        receiptPreference: Model.RegisterReceiptTypeEnum = 0;
        creditCardProcessingEnabled: boolean = false;
        hasNonLiabilityPromoGiftCardType: boolean = false;
        allowProductRefundingResell: boolean = null;
        allowTipRefunding: boolean = false;
        autoGenerateMembershipNumber: boolean = false;
        showProductRecommendations: boolean = false;
        showAnonymousClient: boolean = true;
        allowGiftCardReload: boolean = false;
        allowGiftCardReuse: boolean = false;
        showRebookPrompt: number;
        visitNoteServicePrompt: boolean = false;
        cancelNoShowNumberOfDaysBack: number = 7;
        appointmentNoShowFeePercentage: number = null;
        applyNoShowFeeToAddOns: boolean = false;
        setChangeDueAsCash: boolean = false;

        explicitHoldAdded: boolean = false;

        isIncludeGiftReceipt: boolean = false;
        showGiftReceiptPrintOption: boolean = true;

        canAddAmountOffDiscount: boolean = false;
        canAddPercentOffDiscount: boolean = false;
        canAddSpecificPriceDiscount: boolean = false;
        canAddPredefinedDiscount: boolean = false;

        hideCheckoutButtons: boolean = false;
        isStandard: boolean = true;
        viewHeightClass: any;

        sellServicePermission: boolean = false;
        sellProductPermission: boolean = false;
        sellMembershipPermission: boolean = false;
        sellPackagePermission: boolean = false;
        sellGiftCardPermission: boolean = false;
        giftCardPriceKey: string;

        refundAccountCreditPermission: boolean = false;

        applyDiscountGiftCardPermission: boolean = false;
        applyDiscountMembershipPermission: boolean = false;
        showGiftCardLiabilityIndicator: boolean = true;
        canViewStudentTeacherModule: boolean = true;

        defaultTipType: Model.TipAmountTypeEnum;
        percentageTipValues: number[] = null;
        amountTipValues: number[] = null;
        selfPayDefaultTipPercentage: number = 0;
        includeProductsInTips: boolean = false;
        enableClientAccountSpendingLimit: boolean = false;
        clientAccountSpendingLimit: number=1;
        clientCCFileMissingZipCode: boolean = false;
        disablePrintingOfMerchantCreditCardReceipt: boolean = false;
        autoGenerateGiftCardNumberButton: boolean = false;
        defaultClientSortOrder: Meevo.Model.DefaultSortTypeEnum;
        defaultTipCalculationsDiscountedPrice: boolean = true;
        appointmentServiceIdsExcludedFromTeacherAssignment: any[];
        meevoCurrency: any;
        forcePaymentOptions: boolean;

        financialInfo: Meevo.Model.Tax;
        allowSharedRedemptionOfPointsWithinFamily: boolean = false;
        clientFamilyMembers: any[] = [];
        numberOfWeeksGFExpiresAfterPurchase: number = 0;
        switchToPaymentPlanRefund: boolean = false;

        promptToPrintHoldReceipt: boolean = false;

        restrictCashRefundsWhenCreditCardPaymentExists: any;

        requireEmployeeSelectionForRetail: boolean = false;
        allowCustomPackageRedemptionAtAnyLocation: boolean = false;
        redeemExpiredPackagesSecurityItem: Model.SecurityItem = null;
        hasMeevoPaySplitFundingEnabled: boolean = false;

        public openedPaymentAccordion: any;
        public openedPaymentAccordionIndex: number;
        public showRefundStatus: boolean = false;
        public showTicketStatus: boolean;
        public isDrawerPopped: boolean = false;

        public HouseEmployee: Model.EmployeeListItem = {
            id: Guid.empty.toString(),
            displayName: "HOUSE: House",
            lastName: "House",
            firstName: "House",
            code: "HOUSE",
            isEmployee: false,
            allowSales: true,
            allowTips: true
        };

        public UnspecifiedEmployee: Model.EmployeeListItem = {
            id: Guid.empty.toString(),
            displayName: "Unspecified"
        };

        public AnonymousOther: Model.ClientListItem = {
            id: undefined,
            displayName: this.$translate.instant("LABEL_ANONYMOUS_OTHER")
        };

        public AnonymousGiftCardPurchasedFor: Model.ClientListItem = {
            id: undefined,
            displayName: this.$translate.instant("LABEL_GIFTCARD_PURCHASED_FOR_ANONYMOUS")
        };

        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
        private noSalePermission: boolean;

        public isRefundMode: boolean = false;
        public isCreditMode: boolean = false;
        public isEmailEnabled: boolean = true;

        public maxPoleMessageLength = 20;

        public clientsForReferralExclude: any[] = [];
        public paymentPlan: Model.PaymentPlan;
        paymentPlansEnabled: boolean = false;

        clientAlertMsg = [
            this.$translate.instant("CLIENT_ALERT_MISSINGPHONENUMBER"),
            this.$translate.instant("CLIENT_ALERT_MISSINGEMAILADDRESS"),
            this.$translate.instant("CLIENT_ALERT_MISSINGCONTACTINFO"),
            this.$translate.instant("CLIENT_ALERT_MISSINGREFERRAL")
        ];

        public isPopulatingTicketFromAppointmentServices = false;
        public refundPackageRedemptionPackageItems: RefundPackageRedemptionPackageItem[] = [];

        public paymentRequestsBasedOnRefundItems: any[] = [];
        isProductUsageTrackingEnabled: boolean = false;
        hasProductUsageVariantsToAdd: boolean = true;
        private hasProductUsageVariantsToAddRequested: boolean = false;

        constructor(public registerController: Meevo.Plugins.Register.RegisterController) {
            this.checkForNoSalePermission();
            this.checkForItemSellPermission();

            this.meevoCurrency = this.$filter("meevoCurrency") as any;
            registerController.$scope.$on('vAccordion:onCollapseAnimationEnd', () => {
                _(this.sale.saleLines).where({ needsCollapsing: true }).forEach((saleLine) => {
                    saleLine.isDetailExpanded = false;
                    saleLine.needsCollapsing = false;
                });
            });

            this.loadPaymentTypes();
        }

        scrollToLastClient(scrollLocation: string) {

            let that = this;
            setTimeout(function () {
                that.$location.hash(scrollLocation);
                that.$anchorScroll();
            });

        }

        // check if a child element is visible in a parent element who's overflow-y = auto
        // currently only works for elements BELOW the view of parent element
        scrollToElementOutOfView(parentSelector: string, childSelector: string) {

            let parentElement: HTMLElement;
            let parentRect: ClientRect;

            let childElement: Element;
            let childRect: ClientRect;

            setTimeout(function () {
                // grab the parent element
                parentElement = document.getElementById(parentSelector);
                parentRect = parentElement.getBoundingClientRect();
                // find the child element
                childElement = parentElement.querySelector(childSelector);
                childRect = childElement.getBoundingClientRect();

                // if the bottom of the child element is more pixels from the top of the window than the bottom of parent element
                // then the child element is out of view
                if (childRect.bottom > parentRect.bottom) {
                    // scroll the hidden child element into view of parent element
                    parentElement.scrollTop = (childRect.bottom - parentRect.bottom);
                }
                // check if the child element is above the current view of parent element
                // to do in future

            });

        }

        toggleAlerts() {

            this.allUniqueClients.forEach((registerClient) => {

                if (registerClient.clientType != Model.ClientTypeEnum.AnonymousOther &&
                    registerClient.clientType != Model.ClientTypeEnum.AnonymousFemale &&
                    registerClient.clientType != Model.ClientTypeEnum.AnonymousMale) {

                    let isClientSelected: boolean = this.showManipulation(registerClient);

                    // set expandAlerts false to all clients other than selected
                    if (!isClientSelected) {
                        if (!_.isUndefined(registerClient.expandAlerts)) {
                            registerClient.expandAlerts = false;
                        }
                    }
                    else {
                        // selected client show expandAlerts
                        if (!_.isUndefined(registerClient.expandAlerts)) {
                            registerClient.expandAlerts = !registerClient.expandAlerts;
                        }
                        else {
                            // first time client is being added
                            registerClient.expandAlerts = true;
                        }
                    }
                }
            });
        }

        initialize() {
            return this.$q.all([
                this.registerDiscountService.getDiscountLabels()
                , this.getSecurityValues()
                , this.initializeRegisterSections().then(() => {
                    this.reset(false);
                })
                , this.getDefaultMerchantAccount()
                , this.registerCareCreditService.getCareCreditMerchantAccount(this)
            ]);
        }

        setMerchantAccount(drawer: Model.Drawer) {
            if (drawer && drawer.merchantAccountId) {
                this.isMerchantAccountLoading = true;
                return this.dataService.customMethodData(`api/merchantAccount/${drawer.merchantAccountId}`, "GET", null)
                    .then((response) => {
                        if (response && response.data) {
                            this.selectedMerchantAccount = response.data;

                            // if payment categories was already cached, refresh it
                            if (this.paymentCats) {
                                this.paymentCats = null;
                                this.loadPaymentCategories();
                            }
                        }
                    })
                    .finally(() => {
                        this.isMerchantAccountLoading = false;
                    });
            } else {
                return this.$q.resolve();
            }
        }

        setSelectedTerminal(terminal, printServiceTerminal = null) {
            this.selectedTerminal = terminal;
            this.printService.setSelectedTerminal(printServiceTerminal || terminal);
        }

        setCreditCardTerminal(creditCardTerminalId?): ng.IPromise<any> {
            var promise: ng.IPromise<any> = null;

            this.setSelectedTerminal({}, null);

            if (this.selectedDrawer.merchantAccountId) {
                if (!creditCardTerminalId) {
                    if (this.getMerchantAccountIsHostedPageEnabled()) {
                        return promise;
                    }

                    promise = this.dataService.getSectionById("merchantaccount", this.selectedDrawer.merchantAccountId, "devices/list").then((terminals: any) => {
                        if (terminals.length > 0) {
                            this.setSelectedTerminal(terminals[0]);
                        }
                    });
                }
                else {
                    const url = `api/merchantTerminal/${creditCardTerminalId}`;
                    const request = {
                        merchantAccountId: this.selectedDrawer.merchantAccountId
                    };
                    promise = this.dataService.customMethodData(url, "post", request).then((response: any) => {
                        this.setSelectedTerminal(response.data);
                    });
                }
            }

            if (!promise) {
                promise = this.$q.resolve();
            }

            return promise;
        }

        isValidSale(): boolean {
            return _(this.sale.saleLines).all(x => x.saleType !== Meevo.Model.SalesTypeEnum.AssociatedClient && angular.isNumber(x.basePrice) && angular.isNumber(x.finalPrice));
        }

        isPopDrawerDisabled(): boolean {
            return this.registerTicketService.isPastTransactionMode;
        }

        isTipButtonDisabled(): boolean {
            return !this.isSelectedDrawerOpen() || (this.sale && this.sale.recalculateTipInProgress);
        }

        isApplyDiscountButtonVisible(): boolean {
            return this.sale && this.sale.saleLines.length > 0 && this.isValidSale();
        }

        isApplyDiscountButtonDisabled(): boolean {
            return this.paymentPlanService.showPaymentPaymentPlanTicketView(this);
        }

        isApplyPromotionalGiftCardButtonVisible(): boolean {
            return this.hasNonLiabilityPromoGiftCardType && this.isApplyDiscountButtonVisible();
        }

        isApplyPromotionalGiftCardButtonDisabled(): boolean {
            return this.isApplyDiscountButtonDisabled();
        }
        
        isTipButtonVisible(): boolean {
            return (this.sale && this.sale.tipLines.length > 0) || (this.allUniqueClients && this.allUniqueClients.length > 0);
        }
        
        isAutomaticDiscountsButtonVisible(): boolean {
            return this.isSelectedDrawerOpen() && this.sale && this.sale.containsAvailableAutomaticDiscounts;
        }

        isFee(saleType: Model.SalesTypeEnum): boolean {
            return saleType === Model.SalesTypeEnum.ServiceCancellationFee || saleType === Model.SalesTypeEnum.ServiceNoShowFee;
        }

        showAutomaticDiscounts() {
            this.selectSection(RegisterSectionTypeEnum.AutomaticDiscounts);
        }

        isSelectedDrawerOpen(): boolean {
            // act as if drawer is open in history mode
            if (this.registerTicketService.isPastTransactionMode) {
                return true;
            }

            return (this.selectedDrawer.id
                && this.selectedDrawer.drawerState === Meevo.Model.DrawerStateEnum.Open
                && (!this.selectedDrawer.privateUserId || this.selectedDrawer.privateUserId == this.identityService.current().userId));
        }

        getDrawerId() {
            return this.selectedDrawer && this.selectedDrawer.id;
        }

        private getLatestDrawerSession(drawerId): ng.IPromise<Model.DrawerSession> {
            return this.dataService.getItem("drawer", drawerId, "session/latest?includeDetails=false");
        }

        private getPastTransactionDrawerSession(): ng.IPromise<Model.DrawerSession> {
            const context = this.registerTicketService.getPastTransactionContext();
            const drawerId = context.pastTransactionContext.drawerId;
            const drawerSessionId = context.pastTransactionContext.drawerSessionId;

            return this.dataService
                .customMethodData(`api/drawer/${drawerId}/session/${drawerSessionId}?includeDetails=false`, 'GET', null)
                .then(response => response.data);
        }

        getSelectedDrawerName() {
            return this.selectedDrawer && this.selectedDrawer.displayName;
        }

        checkForNoSalePermission() {
            return this.securityService.checkSecurityKey(this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_NOSALE).then(result => {
                this.noSalePermission = result === Meevo.Model.SecurityAccessEnum.Grant;
            });
        }

        getCreditCardRefundSecurityKey() {
            const singleCardKey = this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_PAYMENTCATSINGLECARD;
            const multiCardKey = this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_PAYMENTCAT2219;

            let keysToCheck: string[] = [
                singleCardKey,
                multiCardKey,
            ];

            return this.securityService.checkAndCache(keysToCheck).then((response) => {
                let singleCard = _(response).findWhere({ key: this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_PAYMENTCATSINGLECARD });
                let multiCard = _(response).findWhere({ key: this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_PAYMENTCAT2219 });

                if (singleCard.securityAccess === Meevo.Model.SecurityAccessEnum.Grant) {
                    return singleCardKey;
                }
                if (multiCard.securityAccess === Meevo.Model.SecurityAccessEnum.Grant) {
                    return multiCardKey;
                }
                if (singleCard.securityAccess === Meevo.Model.SecurityAccessEnum.Deny) {
                    return singleCardKey;
                }
                if (multiCard.securityAccess === Meevo.Model.SecurityAccessEnum.Deny) {
                    return multiCardKey;
                }
                if (singleCard.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                    return singleCardKey;
                }
                if (multiCard.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                    return multiCardKey;
                }
            });
        }

        getSecurityValues() {

            let keysToCheck: string[] = [
                this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_DISCOUNTAMOUNTOFF,
                this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_DISCOUNTPERCENTOFF,
                this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_DISCOUNTSPECIFICPRICE,
                this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_DISCOUNTPREDEFINED,
                this.meevoSecurityKeys.REGISTER_REGISTER_GIFTCARDS_APPLYDISCOUNT + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                this.meevoSecurityKeys.REGISTER_REGISTER_MEMBERSHIP_APPLYDISCOUNT + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                this.meevoSecurityKeys.DATA_GIFTCARDTYPE_ACTION_GIFTCARDLIABILITYINDICATOR,
                this.meevoSecurityKeys.DATA_STUDENTTEACHERMODULE + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_REDEEMEXPIREDPACKAGE,
                this.meevoSecurityKeys.MEEVOPAYSPLITFUNDING_READ_INTERNAL,
            ];
            return this.securityService.checkAndCache(keysToCheck).then((response) => {
                let securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_DISCOUNTAMOUNTOFF });
                if (securityItem) {
                    this.canAddAmountOffDiscount = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_DISCOUNTPERCENTOFF });
                if (securityItem) {
                    this.canAddPercentOffDiscount = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_DISCOUNTSPECIFICPRICE });
                if (securityItem) {
                    this.canAddSpecificPriceDiscount = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_DISCOUNTPREDEFINED });
                if (securityItem) {
                    this.canAddPredefinedDiscount = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_GIFTCARDS_APPLYDISCOUNT + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                if (securityItem) {
                    this.applyDiscountGiftCardPermission = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_MEMBERSHIP_APPLYDISCOUNT + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                if (securityItem) {
                    this.applyDiscountMembershipPermission = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.DATA_GIFTCARDTYPE_ACTION_GIFTCARDLIABILITYINDICATOR });
                if (securityItem) {
                    this.showGiftCardLiabilityIndicator = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.DATA_STUDENTTEACHERMODULE + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                if (securityItem) {
                    this.canViewStudentTeacherModule = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_REDEEMEXPIREDPACKAGE });
                if (securityItem) {
                    this.redeemExpiredPackagesSecurityItem = securityItem;
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.MEEVOPAYSPLITFUNDING_READ_INTERNAL });
                if (securityItem) {
                    this.hasMeevoPaySplitFundingEnabled = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }

                this.getGiftCardPriceKey(response);

                return {
                    canAddAmountOffDiscount: this.canAddAmountOffDiscount,
                    canAddPercentOffDiscount: this.canAddPercentOffDiscount,
                    canAddSpecificPriceDiscount: this.canAddSpecificPriceDiscount,
                    canAddPredefinedDiscount: this.canAddPredefinedDiscount
                };
            });
        }

        getGiftCardPriceKey(allSecurityItems) {
            let giftCardPricKeysToCheck: string[] = [
                Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_ALTERPRICINGWITHOUTDISCOUNT,
                Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_GIFTCARDS_APPLYDISCOUNT + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            ];

            let giftCardPriceItems = allSecurityItems.filter(item => {
                return giftCardPricKeysToCheck.indexOf(item.key) != -1;
            });
            let hideKey = _(giftCardPriceItems).findWhere({ securityAccess: Meevo.Model.SecurityAccessEnum.Hide })
            if (hideKey) {
                this.giftCardPriceKey = hideKey.key;
                return;
            }
            let denyKey = _(giftCardPriceItems).findWhere({ securityAccess: Meevo.Model.SecurityAccessEnum.Deny })
            if (denyKey) {
                this.giftCardPriceKey = denyKey.key;
                return;
            }

            this.giftCardPriceKey = giftCardPricKeysToCheck[0];
        }

        isHostedPage(): boolean {
            return this.creditCardProcessingEnabled &&
                this.getMerchantAccountIsHostedPageEnabled() &&
                this.selectedTerminal &&
                this.selectedTerminal.merchantTerminalType === Meevo.Model.MerchantTerminalTypeEnum.Hosted;
        }

        isDeviceTipAvailable(ignoreDeviceTipBypass: boolean = false): boolean {
            return this.registerTipService.isDeviceTipAvailable(this, this.sale, this.selectedTerminal, this.creditCardProcessingEnabled, this.isCreditMode, ignoreDeviceTipBypass);
        }

        deviceTip(modalType: RegisterModalTypeEnum = RegisterModalTypeEnum.TipCreditCard, sectionType: RegisterSectionTypeEnum = null) {
            return this.registerTipService.deviceTip(this, this.sale, modalType, sectionType);
        }

        checkSectionIsDirty(newSection?: RegisterSectionTypeEnum, reset: boolean = false) {
            let defer = this.$q.defer();

            if (this.allUniqueClients
                && this.allUniqueClients.length > 0
                && (angular.isUndefined(newSection) || (newSection !== RegisterSectionTypeEnum.Employee && reset))
                && this.selectedSection
                && (this.selectedSection.sectionType === RegisterSectionTypeEnum.Employee ? this.previouslySelectedSection : this.selectedSection).isDirty()
            ) {
                const message = this.selectedSection.sectionType === RegisterSectionTypeEnum.ProductUsage
                    ? "MESSAGE_REGISTER_SECTION_PRODUCT_USAGE_DIRTY"
                    : "MESSAGE_REGISTER_SECTION_DIRTY";

                this.modalService
                    .confirmHandler(message)
                    .then((response) => { response ? defer.resolve() : defer.reject(); })
                    .catch(() => { defer.reject(); });
            }
            else {
                defer.resolve();
            }
            return defer.promise;
        }

        selectTicketSection(fallbackToServices: boolean = false) {
            if ((device.mobile() || (device.tablet() && device.portrait() && !device.largeTablet()))) {
                this.selectSectionTicket();
            } else if (fallbackToServices) {
                this.selectSectionServices(false);
            }
        }

        isSectionServices(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.Services;
        }

        isSectionProducts(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.Products;
        }

        isSectionMemberships(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.Memberships;
        }

        isSectionPackages(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.Package;
        }

        isSectionGiftCards(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.GiftCard;
        }

        isSectionClientAccounts(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.ClientAccounts;
        }

        selectSectionServices(overrideSecurity: boolean = true) {
            this.selectSection(RegisterSectionTypeEnum.Services, true, false, overrideSecurity);
        }

        selectSectionProducts() {
            this.selectSection(RegisterSectionTypeEnum.Products, true, false, true);
        }

        selectSectionMemberships() {
            this.selectSection(RegisterSectionTypeEnum.Memberships);
        }

        selectSectionPackages() {
            this.selectSection(RegisterSectionTypeEnum.Package, true, false, true);
        }

        selectSectionGiftCards() {
            this.selectSection(RegisterSectionTypeEnum.GiftCard, true, false, true);
        }

        selectSectionClientAccounts() {
            this.selectSection(RegisterSectionTypeEnum.ClientAccounts);
        }

        selectSectionTips() {
            this.selectSection(RegisterSectionTypeEnum.Tips);
        }

        selectSectionDrawer() {
            this.selectSection(RegisterSectionTypeEnum.Drawer);
        }

        selectSectionButtons() {
            this.selectSection(RegisterSectionTypeEnum.Buttons);
        }

        selectSectionTicket() {
            this.selectSection(RegisterSectionTypeEnum.Ticket);
        }

        editDrawer() {
            if (this.hasPendingPayment()) {
                this.modalService.alert("MESSAGE_PENDING_CREDIT_CARD_PAYMENT");
                return;
            }

            this.selectSectionDrawer();
        }

        isSectionTypeCredit(sectionType): boolean {
            if (!sectionType) {
                return false;
            }

            return sectionType === RegisterSectionTypeEnum.CreditMultiCard ||
                sectionType === RegisterSectionTypeEnum.CreditSingleCard;
        }

        selectSection(sectionType: RegisterSectionTypeEnum, reset: boolean = true, switchToRefund: boolean = false, isOverrideSecurity: boolean = false) {
            let originalPermission: boolean;

            const setChangeDueAsCashInitialize = () => {
                if (this.hasChangeDueWithRefunds()
                    && this.selectedSection
                    && (this.selectedSection.sectionType === RegisterSectionTypeEnum.ChangeOptions ||
                        this.isSectionTypeCredit(this.selectedSection.sectionType) ||
                        this.selectedSection.sectionType === RegisterSectionTypeEnum.Cash ||
                        this.selectedSection.sectionType === RegisterSectionTypeEnum.Check ||
                        this.selectedSection.sectionType === RegisterSectionTypeEnum.Other)
                    && sectionType !== RegisterSectionTypeEnum.ChangeOptions
                    && !this.isSectionTypeCredit(sectionType)
                    && sectionType !== RegisterSectionTypeEnum.Cash
                    && sectionType !== RegisterSectionTypeEnum.Check
                    && sectionType !== RegisterSectionTypeEnum.Other
                ) {
                    this.setChangeDueAsCash = false;
                }
            }

            const isRefundModeInitialize = () => {
                if (switchToRefund) {
                    this.isRefundMode = true;
                }

                if (this.isRefundMode) {
                    if (sectionType !== RegisterSectionTypeEnum.Services &&
                        sectionType !== RegisterSectionTypeEnum.Products &&
                        sectionType !== RegisterSectionTypeEnum.Memberships &&
                        sectionType !== RegisterSectionTypeEnum.Package &&
                        sectionType !== RegisterSectionTypeEnum.GiftCard &&
                        sectionType !== RegisterSectionTypeEnum.Employee &&
                        sectionType !== RegisterSectionTypeEnum.Tips &&
                        sectionType !== RegisterSectionTypeEnum.Buttons &&
                        sectionType !== RegisterSectionTypeEnum.Empty &&
                        sectionType !== RegisterSectionTypeEnum.RefundOptions &&
                        sectionType !== RegisterSectionTypeEnum.ClientAccounts &&
                        sectionType !== RegisterSectionTypeEnum.PaymentPlan &&
                        sectionType !== RegisterSectionTypeEnum.LotSelection
                    ) {
                        this.isRefundMode = false;
                    }
                }
            }

            const hideCheckoutButtonsInitialize = () => {
                this.hideCheckoutButtons = false;

                //section types that should keep the register checkout button hidden upon back button navigation
                if (sectionType === RegisterSectionTypeEnum.Discounts ||
                    sectionType === RegisterSectionTypeEnum.PromotionalGiftCard ||
                    sectionType === RegisterSectionTypeEnum.PackageRedemption ||
                    sectionType === RegisterSectionTypeEnum.AutomaticDiscounts ||
                    sectionType === RegisterSectionTypeEnum.GiftCard ||
                    sectionType === RegisterSectionTypeEnum.Memberships ||
                    sectionType === RegisterSectionTypeEnum.Package ||
                    this.isSectionTypeCredit(sectionType) ||
                    sectionType === RegisterSectionTypeEnum.ClientAccounts ||
                    this.isRefundMode
                ) {
                    //keeps checkout buttons hidden
                    this.hideCheckoutButtons = true;
                }
            }

            const overrideSecurity = () => {
                if (!isOverrideSecurity) {
                    return;
                }

                switch (sectionType) {
                    case RegisterSectionTypeEnum.Services:
                        originalPermission = this.sellServicePermission;
                        this.sellServicePermission = true;
                        break;
                    case RegisterSectionTypeEnum.Products:
                        originalPermission = this.sellProductPermission;
                        this.sellProductPermission = true;
                        break;
                    case RegisterSectionTypeEnum.Package:
                        originalPermission = this.sellPackagePermission;
                        this.sellPackagePermission = true;
                        break;
                    case RegisterSectionTypeEnum.GiftCard:
                        originalPermission = this.sellGiftCardPermission;
                        this.sellGiftCardPermission = true;
                        break;
                }
            }

            const reapplySecurity = () => {
                if (!isOverrideSecurity) {
                    return;
                }

                switch (sectionType) {
                    case RegisterSectionTypeEnum.Services:
                        this.sellServicePermission = originalPermission;
                        break;
                    case RegisterSectionTypeEnum.Products:
                        this.sellProductPermission = originalPermission;
                        break;
                    case RegisterSectionTypeEnum.Package:
                        this.sellPackagePermission = originalPermission;
                        break;
                    case RegisterSectionTypeEnum.GiftCard:
                        this.sellGiftCardPermission = originalPermission;
                        break;
                }
            }

            const checkPastTransactionMode = (newSection: RegisterSectionBase): boolean => {
                if (!newSection || !this.registerTicketService.isPastTransactionMode) {
                    return true;
                }

                let itemType = null;

                switch (newSection.sectionType) {
                    case RegisterSectionTypeEnum.Products:
                        itemType = 'HEADER_PRODUCTS';
                        break;
                    case RegisterSectionTypeEnum.Memberships:
                        itemType = 'HEADER_MEMBERSHIPS';
                        break;
                    case RegisterSectionTypeEnum.Package:
                        itemType = 'LABEL_PACKAGE';
                        break;
                    case RegisterSectionTypeEnum.GiftCard:
                        itemType = 'LABEL_GIFT_CARD';
                        break;
                    case RegisterSectionTypeEnum.ClientAccounts:
                        itemType = 'LABEL_ACCOUNT';
                        break;
                }

                if (itemType) {
                    const message = this.$translate.instant("MESSAGE_INVALID_FOR_HISTORY_MODE",
                        { itemType: this.$translate.instant(itemType) });
                    this.modalService.alert(message);
                    return false;
                }

                return true;
            };

            setChangeDueAsCashInitialize();

            return this.checkSectionIsDirty(sectionType, reset)
                .then(() => {
                    if (this.isSectionTypeCredit(sectionType) && !this.hasChangeDueWithRefunds()) {
                        return this.deviceTip(RegisterModalTypeEnum.TipCreditCard, sectionType);
                    }
                })
                .then(() => {
                    isRefundModeInitialize();

                    let newSection = _.findWhere(this.sections, { sectionType: sectionType });

                    if (newSection && newSection.sectionType === RegisterSectionTypeEnum.Other) {
                        (<OtherPaymentsSection>newSection).assignSurcharges();
                    }

                    if (!checkPastTransactionMode(newSection)) {
                        return;
                    }

                    if (this.selectedSection
                        && (this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Sale ||
                            this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Other)
                        && this.selectedSection.sectionType !== RegisterSectionTypeEnum.RefundReason
                        && newSection
                        && newSection.sectionCatType === RegisterSectionCatTypeEnum.Payment
                        && newSection.sectionType !== RegisterSectionTypeEnum.PaymentPlan
                        && this.isRefundReasonVisible()
                    ) {
                        sectionType = RegisterSectionTypeEnum.RefundReason;
                        newSection = _.findWhere(this.sections, { sectionType: RegisterSectionTypeEnum.RefundReason });
                    }

                    if (this.selectedSection
                        && this.selectedSection.sectionType === RegisterSectionTypeEnum.ProductUsage) {
                        this.hideCheckoutButtons = false;
                        this.selectedSection.reset();
                    }

                    if (this.productContext
                        && this.productContext.selectionMode == ProductSelectionMode.Recommended
                        && sectionType !== RegisterSectionTypeEnum.Employee
                        && sectionType !== RegisterSectionTypeEnum.Products) {

                        this.productContext.selectionMode = ProductSelectionMode.Cats;
                    }

                    if (sectionType === RegisterSectionTypeEnum.Memberships && !this.sellMembershipPermission) {
                        this.modalService.alert("ERROR_HTTP_403");
                        return;
                    }

                    overrideSecurity();
                    if (!this.isRefundMode) {
                        if (
                            (sectionType === RegisterSectionTypeEnum.Services && !this.sellServicePermission) ||
                            (sectionType === RegisterSectionTypeEnum.Products && !this.sellProductPermission) ||
                            (sectionType === RegisterSectionTypeEnum.Package && !this.sellPackagePermission) ||
                            (sectionType === RegisterSectionTypeEnum.GiftCard && !this.sellGiftCardPermission)
                        ) {
                            this.showEmptySection();
                            return;
                        }
                    }

                    if (sectionType === RegisterSectionTypeEnum.Drawer) {
                        this.previouslySelectedSection = this.selectedSection;
                        this.openDrawerManager();
                    }
                    else if (this.isSelectedDrawerOpen()) {
                        hideCheckoutButtonsInitialize();

                        if (!this.selectedSection || this.selectedSection.sectionType != sectionType || this.isRefundMode) {
                            // The lot screen is a transient capture step in the manual refund flow.
                            // Don't let it become the "previous" section, so adding the refund (via the
                            // employee step) returns to the manual mode product screen, not the lot screen.
                            if (!this.selectedSection || this.selectedSection.sectionType !== RegisterSectionTypeEnum.LotSelection) {
                                this.previouslySelectedSection = this.selectedSection;
                            }
                        }

                        this.selectedSection = newSection;

                        if (newSection.sectionCatType === Register.RegisterSectionCatTypeEnum.Payment) {
                            this.sale.saleStage = Model.SaleStageEnum.Payment
                        }

                        if ((reset && this.selectedSection) || this.isSectionTypeCredit(sectionType)) {
                            switch (sectionType) {
                                case RegisterSectionTypeEnum.Products:
                                    (<ProductsSection>this.selectedSection).reset(true);
                                    break;
                                default:
                                    this.selectedSection.reset();
                                    break;
                            }
                        }

                        if (this.isCreditMode && this.selectedSection instanceof CreditPaymentsSection) {
                            this.selectedSection.setCardPaymentList(this.paymentRequestsBasedOnRefundItems);
                        }
                                                
                        if (sectionType === RegisterSectionTypeEnum.CreditSingleCard) {
                            console.log('automatic credit card prompt due to Payment Type of "Credit Card (Single Card)"')
                            // need this to run after the current tip process completes
                            this.$timeout(() => {
                                this.recalculateTip().then(() => {
                                    (<CreditPaymentsSection>this.selectedSection).processSingleCard();
                                });
                            });
                        }

                        if (sectionType === RegisterSectionTypeEnum.CareCreditPayment) {
                            console.log('automatic credit card prompt due to Payment Type of "CareCredit"')
                            // need this to run after the current tip process completes
                            this.$timeout(() => {
                                this.recalculateTip().then(() => {
                                    (<CareCreditPaymentsSection>this.selectedSection).processCareCredit();
                                });
                            });
                        }

                        if (sectionType === RegisterSectionTypeEnum.Client && (this.payingClient || ((this.selectedClientType === Model.ClientTypeEnum.Client || this.selectedClientType == undefined) && !this.editSelectedClient))) {
                            this.$timeout(() => {
                                angular.element('meevo-type-ahead#clientHeaderTypeahead').find('input').focus();
                            }, 500);
                        }

                        this.closeDrawerManager();
                    }
                    reapplySecurity();

                    if (this.isDirty() &&
                        this.previouslySelectedSection &&
                        sectionType !== RegisterSectionTypeEnum.PackageRedemption &&
                        this.previouslySelectedSection.sectionType === RegisterSectionTypeEnum.PackageRedemption) {
                        (<PackageRedemptionSection>this.previouslySelectedSection).cleanupClientPackageRedemptionPath();
                    }
                });
        }

        showEmptySection() {
            this.selectSection(RegisterSectionTypeEnum.Empty);
        }

        getSelectedSectionType(): RegisterSectionTypeEnum {
            if (this.showDrawerManager || this.selectedSection == null) {
                return RegisterSectionTypeEnum.Drawer;
            }
            else {
                return this.selectedSection ? this.selectedSection.sectionType : RegisterSectionTypeEnum.Ticket;
            }
        }

        showAddPayment() {
            if (!this.selectedSection) {
                return false;
            }

            if (this.selectedSection.sectionCatType !== RegisterSectionCatTypeEnum.Payment &&
                this.selectedSection.sectionType !== RegisterSectionTypeEnum.PaymentPlan) {
                return false;
            }

            if (this.isSectionTypeCredit(this.selectedSection.sectionType) ||
                this.selectedSection.sectionType === RegisterSectionTypeEnum.CareCreditPayment) {
                return false;
            }

            switch (this.selectedSection.sectionType) {
                case RegisterSectionTypeEnum.ChangeOptions:
                case RegisterSectionTypeEnum.PaymentOptions:
                    return false;
            }

            if (this.isCreditMode) {
                if (this.selectedSection.sectionType === RegisterSectionTypeEnum.CardOnFile) {
                    return false;
                }
            }

            return true;
        }

        private isInRestrictedSubFlow(): boolean {
            if (this.isRefundMode) {
                return true;
            }

            if (!this.selectedSection) {
                return false;
            }

            if (this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Payment) {
                return true;
            }

            switch (this.selectedSection.sectionType) {
                case RegisterSectionTypeEnum.RefundReason:
                    return true;
            }

            return false;            
        }

        isBackToSaleVisible(): boolean {
            return this.isInRestrictedSubFlow();
        }

        isRefundButtonHidden(): boolean {
            return this.isInRestrictedSubFlow();
        }

        //used for navigation on ng-click
        navigate(sectionType: RegisterSectionTypeEnum, listItem: any, isPayment: boolean, reset: boolean, isRefundMode: boolean) {
            this.productContext.selectionMode = ProductSelectionMode.Cats;

            if (device.largeTablet() || (!device.tablet() && !device.portrait())) {
                switch (sectionType) {
                    case RegisterSectionTypeEnum.PaymentOptions:
                        this.showPaymentOptions(reset);
                        break;
                    case RegisterSectionTypeEnum.ChangeOptions:
                        this.showChangeOptions(reset);
                        break;
                    default:
                        this.selectSection(sectionType, reset);
                        break;
                }

                return;
            }

            // ipad in portrait or mobile device
            if (isRefundMode) {
                this.selectSection(RegisterSectionTypeEnum.RefundOptions);
            } else if (listItem) {
                //if no list item navigates back to smart ticket/button sets
                //set sectionType to desired nav point if no list item sub category
                this.selectSection(sectionType, reset);
            } else if (isPayment) {
                if (this.isCreditMode) {
                    this.selectSection(RegisterSectionTypeEnum.ChangeOptions, reset);
                }
                else {
                    //if payment section navigate to payment button set
                    this.selectSection(RegisterSectionTypeEnum.PaymentOptions, reset);
                }
            } else {
                //navigate to smart ticket
                this.selectSection(RegisterSectionTypeEnum.Ticket, reset);
            }

            //hide checkout button if membership, package, discount, gift card
            if (sectionType === RegisterSectionTypeEnum.Package ||
                sectionType === RegisterSectionTypeEnum.Memberships ||
                sectionType === RegisterSectionTypeEnum.Discounts ||
                sectionType === RegisterSectionTypeEnum.PromotionalGiftCard ||
                sectionType === RegisterSectionTypeEnum.GiftCard) {
                this.hideCheckoutButtons = false;
            }
        }

        //used for ng-disabled state
        disabledNavigation(listItem: any) {
            if (listItem) {
                return false;
            } else if (!device.mobile()) {
                //not a mobile device -- normal navigation flow
                return true;
            } else if (device.largeTablet()) {
                //ipad pro sized device -- normal navigation flow
                return true;
            } else if (device.tablet() && !device.portrait() && !device.largeTablet()) {
                //ipad in landscape -- normal navigation flow
                return true;
            } else {
                return false;
            }
        }


        initializeSections(): void { }
        initializeRegisterSections(): ng.IPromise<any> {
            //Note: XXXXXSection -- namespace of xxxxx.section.ts
            //Note: template -- folder name and less class for calc height. see directives/registerContext.ts for ng-includes example
            //Note: handlesOwnCrud = true
            this.clientContext = new SpecifyClientSection(this);
            this.sections.push(this.clientContext);

            this.sections.push(new ServicesSection(this));

            this.productContext = new ProductsSection(this);
            this.sections.push(this.productContext);

            this.giftCardSection = new GiftCardSection(this);
            this.sections.push(this.giftCardSection);

            this.sections.push(new ClientAccountsSection(this));

            this.sections.push(new PackageSection(this));

            this.sections.push(new SpecifyEmployeeSection(this));

            this.buttonsSection = new ButtonsSection(this, this.securityService);
            this.sections.push(this.buttonsSection);

            this.sections.push(new PaymentSection(this));

            this.sections.push(new SmartTicketSection(this));

            this.sections.push(new DiscountsSection(this));

            this.sections.push(new PromotionalGiftCardsSection(this));

            this.sections.push(new AutomaticDiscountsSection(this));

            this.sections.push(new PackageRedemptionSection(this));

            this.sections.push(new EmptySection(this));

            this.sections.push(new PackageTransferSection(this));

            this.sections.push(new SplitCommissionSection(this));

            this.sections.push(new RefundReasonSection(this));

            this.sections.push(new PaymentOptionsSection(this, this.modalService));

            this.refundOptionsSection = new RefundOptionsSection(this)
            this.sections.push(this.refundOptionsSection);

            this.sections.push(new ChangeOptionsSection(this, this.modalService));

            let teacherSection = new SpecifyTeacherSection(this);
            teacherSection.sectionType = RegisterSectionTypeEnum.Teacher;
            this.sections.push(teacherSection);

            this.paymentPlanPaymentsSection = new PaymentPlanPaymentsSection(this);
            this.sections.push(this.paymentPlanPaymentsSection);

            this.sections.push(new ProductUsageSection(this));

            this.sections.push(new LotSelectionSection(this));

            var promises: ng.IPromise<any>[] = [
                this.getRegisterSettings(),
                this.getFinancialInfo(),
                this.getHasNonLiabilityPromoGiftCardType(),
            ];

            return this.$q.all(promises);
        }

        getHasNonLiabilityPromoGiftCardType(): ng.IPromise<any> {
            // Count active non-liability promotional gift card types; the proc filters by both isPromo and
            // isPromoLiability, so we only need to know whether any exist.
            const request = {
                criteria: {
                    isPromo: true,
                    isPromoLiability: false,
                    includeInvalid: false
                }
            };
            return this.dataService.getCount('GiftCardType', request)
                .then((count: number) => {
                    this.hasNonLiabilityPromoGiftCardType = count > 0;
                })
                .catch(() => {
                    this.hasNonLiabilityPromoGiftCardType = false;
                });
        }

        getRegisterSettings(): ng.IPromise<any> {
            const USE_DISCOUNTED_PRICE = 1;

            return this.dataService.customMethodData("api/tenant/businessInfo/settings", "get", null).then((response) => {
                this.creditCardProcessingEnabled = response.data.registerSettings.enableCreditCardProcessing;
                this.allowProductRefundingResell = response.data.registerSettings.allowProductRefundingResell;
                this.allowTipRefunding = response.data.registerSettings.enableTipRefunds;
                this.autoGenerateMembershipNumber = response.data.membershipSettings.autoGenerateMembershipNumber;
                this.showProductRecommendations = response.data.registerSettings.showProductRecommendations;
                this.showAnonymousClient = response.data.registerSettings.showAnonymousClient;
                this.allowGiftCardReload = response.data.registerSettings.reloadGiftCard;
                this.allowGiftCardReuse = response.data.registerSettings.reuseGiftCard;
                this.showRebookPrompt = response.data.registerSettings.showRebookPrompt;
                this.visitNoteServicePrompt = response.data.registerSettings.visitNoteServicePrompt;
                this.cancelNoShowNumberOfDaysBack = response.data.registerSettings.cancelNoShowNumberOfDaysBack;
                this.appointmentNoShowFeePercentage = response.data.appointmentBookSettings.appointmentNoShowFeePercentage;
                this.applyNoShowFeeToAddOns = response.data.appointmentBookSettings.applyNoShowFeeToAddOns;
                this.defaultTipType = response.data.registerSettings.defaultTipType;
                this.clientCCFileMissingZipCode = response.data.membershipSettings.clientCCFileMissingZipCode;
                this.disablePrintingOfMerchantCreditCardReceipt = response.data.registerSettings.disablePrintingOfMerchantCreditCardReceipt;
                this.autoGenerateGiftCardNumberButton = response.data.registerSettings.autoGenerateGiftCardNumberButton;
                this.defaultClientSortOrder = response.data.clientsSettings.defaultClientSortOrder;
                this.defaultTipCalculationsDiscountedPrice = response.data.registerSettings.defaultTipCalculations === USE_DISCOUNTED_PRICE;
                this.allowSharedRedemptionOfPointsWithinFamily = response.data.clientsSettings.allowSharedRedemptionFamilyPoints;
                this.numberOfWeeksGFExpiresAfterPurchase = response.data.registerSettings.numberOfWeeksStandrardGiftCardExpiresAfterPurchase;
                this.selfPayDefaultTipPercentage = response.data.registerSettings.selfPayDefaultTipPercentage;
                this.includeProductsInTips = response.data.registerSettings.includeProductsInTips;
                this.promptToPrintHoldReceipt = response.data.registerSettings.promptToPrintHoldReceipt;
                this.requireEmployeeSelectionForRetail = response.data.registerSettings.requireEmployeeSelectionForRetail;
                this.allowCustomPackageRedemptionAtAnyLocation = response.data.registerSettings.allowCustomPackageRedemptionAtAnyLocation;
                this.restrictCashRefundsWhenCreditCardPaymentExists = response.data.registerSettings.restrictCashRefundsWhenCreditCardPaymentExists;

                this.enableClientAccountSpendingLimit = response.data.registerSettings.enableClientAccountSpendingLimit;
                this.clientAccountSpendingLimit = response.data.registerSettings.clientAccountSpendingLimit;
                this.isProductUsageTrackingEnabled = response.data.generalSettings.productUsageTracking;

                if (Model.Guard.isSomething(response.data.registerSettings.percentageTipValues)) {
                    this.percentageTipValues = angular.fromJson(response.data.registerSettings.percentageTipValues);
                }
                if (Model.Guard.isSomething(response.data.registerSettings.amountTipValues)) {
                    this.amountTipValues = angular.fromJson(response.data.registerSettings.amountTipValues);
                }

                this.sections.push(new MembershipsSection(this, response.data));

                this.sections.push(new RefundTipsSection(this, response.data.registerSettings.numberOfDaysTipCanBeRefunded));
            });
        }

        getFinancialInfo(): ng.IPromise<any> {
            return this.dataService.customMethodData("api/tax", "get", null).then((response) => {
                this.financialInfo = response.data;
            });
        }

        initializeHeader(model: any): void {
            //      this.headerContent = "Walk-In"; // change later to be dynamic
        }

        hasClient() {
            return this.selectedClient || this.selectedClientType;
        }

        addToAllUniqueClients(clientObj, clientType, appointmentId) {
            let rClient = new RegisterClient({
                client: clientObj,
                clientType: clientType,
                appointmentId: appointmentId,
                clientDisplayName: clientObj ? clientObj.clientDisplayName : undefined
            });

            let clientId = rClient.getId();
            let existingRegisterClient = this.getRegisterClient(rClient, _.find);
            let loadClientData = false;

            if (!existingRegisterClient) {
                existingRegisterClient = rClient;
                this.allUniqueClients.push(rClient);
                this.addClientFamily(clientId);
                loadClientData = clientType === Model.ClientTypeEnum.Client && clientId != "";
            }

            let promises = [];

            if (loadClientData) {
                let clientTypePromise = this.dataService.customMethodData(`api/client/${clientId}/clienttypes`, "GET", null).then((response) => {
                    if (response.data.length > 0) {
                        existingRegisterClient.client.clientClientTypeIds = _.pluck(response.data, "id");
                    }
                });
                promises.push(clientTypePromise);

                let clientAccountPromise = this.dataService.customMethodData(`api/client/${clientId}/accountbalance`, "GET", null).then((response) => {
                    existingRegisterClient.client.allowChargesCreditOnAccount = response.data.allowChargesCreditOnAccount;
                    existingRegisterClient.client.accountBalance = +response.data.accountBalance;
                });
                promises.push(clientAccountPromise);
            }

            if (clientType === Model.ClientTypeEnum.Client && (!existingRegisterClient || !existingRegisterClient.clientIdCheckedForMembership || existingRegisterClient.clientIdCheckedForMembership != existingRegisterClient.client.id)) {
                let request: any = {
                    ClientIds: [clientId],
                    IncludeUpgradeEligibility: true
                }

                let url = "/api/Membership/Client/StatusIndicator/List";
                let clientStatusIndicatorPromise = this.dataService.customMethodData(url, "POST", request).then((response) => {
                    existingRegisterClient.clientIdCheckedForMembership = clientObj.id;

                    const item = response.data[0];
                    existingRegisterClient.client.membershipNumber = item.membershipNumber;
                    existingRegisterClient.client.clientMembershipId = item.clientMembershipId;
                    existingRegisterClient.client.membershipId = item.membershipId;
                    existingRegisterClient.client.membershipStatus = item.clientMembershipStatusEnum;
                    existingRegisterClient.client.membershipIndicatorStatus = item.clientMembershipIndicatorStatusEnum;
                    existingRegisterClient.client.membershipDisplayName = item.membershipDisplayName;
                    existingRegisterClient.client.canOfferMembershipUpgrade = item.canOfferUpgrade;
                    existingRegisterClient.client.isEligibleForMembershipUpgrade = item.isEligibleForUpgrade;
                    existingRegisterClient.client.membershipHomePriceMarketDisplayName = item.homePriceMarketDisplayName;
                });

                promises.push(clientStatusIndicatorPromise);
            }

            return this.$q.all(promises);
        }

        editClient() {
            if (!this.isSelectedDrawerOpen()) {
                return;
            }

            this.payingClient = undefined;
            if (this.selectedClient) {
                this.payingClient = this.selectedClient;
                this.registerNotesService.removeAggregatedNote(this.selectedClient.id);
            }
            this.payingClientType = undefined;
            if (this.selectedClientType) {
                this.payingClientType = this.selectedClientType;
            }
            this.showToday = false;
            this.selectSection(RegisterSectionTypeEnum.Client);
            this.editSelectedClient = true;
        }

        selectClient(clientObj, doNotSwitchToServices?: boolean, checkDrawerIsOpen: boolean = true) {
            /*
            if (this.hasPendingPayment()) {
                this.modalService.alert("MESSAGE_PENDING_CREDIT_CARD_PAYMENT");
                return;
            }
            */
            if (!clientObj || (checkDrawerIsOpen && !this.isSelectedDrawerOpen())) {
                return;
            }

            this.selectedClient = clientObj.client;
            this.selectedClientType = clientObj.clientType;
            this.selectedClientAppointmentId = clientObj.appointmentId;

            if (!_.isUndefined(this.selectedSection)) {
                this.selectedSection.clientSelected();
            }
            if (!doNotSwitchToServices && this.selectedSection && this.selectedSection.switchToServicesWhenClientSelected()) {
                this.selectSection(RegisterSectionTypeEnum.Services);
            }
            // set views for the notification bars for each client added to register
            this.toggleAlerts();
        }

        sendToTransactionHistory(registerClient) {
            if (!registerClient) {
                return;
            }

            this.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, registerClient.getId(), "SECTION_HISTORY", undefined, registerClient.getDisplayName(), "TRANSACTION_HISTORY");
        }

        hasRealClient() {
            return _.where(this.allUniqueClients, { clientType: Meevo.Model.ClientTypeEnum.Client }).length > 0;
        }

        removeClient(clientObj) {
            if (!this.isSelectedDrawerOpen() || this.sale.recalculateSaleInProgress) {
                return;
            }

            if (this.selectedSection.sectionCatType == RegisterSectionCatTypeEnum.Payment || this.selectedSection.sectionCatType == RegisterSectionCatTypeEnum.Other) {
                this.selectSection(RegisterSectionTypeEnum.Services);
            }

            let message = this.$translate.instant("MESSAGE_DELETE_CLIENT_ON_SMART_RECEIPT_CONFIRMATION", {
                clientDisplayName: clientObj.getDisplayName()
            });

            var hasItems = _.findIndex(this.sale.saleLines, (item) => {
                return item.client && clientObj.client ? item.client.id == clientObj.client.id : (item.clientType == clientObj.clientType && item.appointmentId == clientObj.appointmentId);
            });

            if (hasItems > -1) {
                this.modalService.confirmHandler(message).then((result) => {
                    if (result) {
                        this.removeClientConfirmation();
                    }
                });
            } else {
                this.removeClientConfirmation();
            }
        }

        private removeExistingTip() {
            this.sale.tipLines = [];
            this.sale.tipAmount = null;
            this.sale.tipPercentage = null;
            this.sale.deviceTip = undefined;
            this.sale.deviceTipBypass = false;
            this.sale.useDiscountedPrice = this.defaultTipCalculationsDiscountedPrice;
        }

        removeClientConfirmation() {
            let rClient = new RegisterClient({
                clientType: this.selectedClientType,
                client: this.selectedClient,
                appointmentId: this.selectedClientAppointmentId
            });

            this.removeAllSaleItems(rClient);
            if (this.selectedClient && this.selectedClient.id) {
                this.registerNotesService.removeAggregatedNote(this.selectedClient.id);
            }

            var deleteClientIndex = this.getRegisterClient(rClient, _.findIndex);
            if (deleteClientIndex > -1) {
                this.allUniqueClients.splice(deleteClientIndex, 1);
            }
            this.removeClientFamily(rClient.getId());

            this.selectedClient = undefined;
            this.selectedClientType = undefined;
            this.selectedClientAppointmentId = undefined;

            if (this.allUniqueClients.length > 0) {
                this.clientChangedUpdateRefundTips();
                this.recalculateSale().then(() => {
                    this.selectClient(this.allUniqueClients[this.allUniqueClients.length - 1]);
                });
            } else {
                this.removeExistingTip();

                this.cancelPendingHostedPagePayments().finally(() => {
                    this.clientChangedUpdateRefundTips();
                    this.recalculateSale().then(() => {
                        this.selectSection(RegisterSectionTypeEnum.Client);
                    });
                });
            }
        }

        showManipulation(clientObj) {
            return clientObj.client && this.selectedClient ? clientObj.client.id == this.selectedClient.id : (clientObj.clientType == this.selectedClientType && this.selectedClientAppointmentId == clientObj.appointmentId);
        }

        reset(switchToClientSection: boolean = true, exitPastTransactionMode: boolean = true) {
            this.tippyService.deleteTransaction(this.sale);
            this.membershipFormsSentNow = [];
            this.sale = {
                paymentLines: [],
                saleLines: [],
                tipLines: [],
                subTotal: 0,
                total: 0,
                tip: 0,
                baseTax: 0,
                baseTaxIncluded: 0,
                finalTax: 0,
                finalTaxIncluded: 0,
                tax: 0,
                taxIncluded: 0,
                changeDue: 0,
                saleStage: Model.SaleStageEnum.Initial,
                onHoldIds: {},
                mergeClientIds: [],
                noLinkMergeClientIds: [],
                noSale: false,
                totalPrepaidTip: 0,
                containsAvailableAutomaticDiscounts: false,
                isProductTaxDeclined: false,
                isServiceTaxDeclined: false,
                changedClientIds: [],
                automaticDiscountIdToBeApplied: null,
                saleNotes: [],
                locale: this.appSettings.APP_COUNTRYID,
                timeFormat: this.appSettings.APP_TIME_FORMAT,
                tipConvenienceFee: 0
            };

            if (this.giftCardPaymentsSection) {
                this.giftCardPaymentsSection.clear();
            }

            this.selectedClient = undefined;
            this.selectedClientType = undefined;
            this.selectedClientAppointmentId = undefined;
            this.selectedEmployee = undefined;
            this.selectedTeacher = undefined;
            this.allUniqueClients = [];
            this.allUniqueServices = {};
            this.showToday = false;
            this.showDrawerManager = false;
            this.payingClient = undefined;
            this.payingClientType = undefined;
            this.editSelectedClient = false;
            this.explicitHoldAdded = false;
            this.isCreditMode = false;
            this.registerNotesService.resetSaleNotes();
            this.registerNotesService.resetAggregatedNotes();
            this.clientFamilyMembers = [];
            this.clientsForReferralExclude = [];
            this.paymentPlanPaymentsSection.clearCache();
            this.refundPackageRedemptionPackageItems = [];

            const isSelectedDrawerOpen = this.isSelectedDrawerOpen();
            let reset = true;
            if (isSelectedDrawerOpen) {
                if (switchToClientSection) {
                    this.selectSection(RegisterSectionTypeEnum.Client);
                    reset = false; // reset already happening with client section select
                }
            }
            else {
                this.openDrawerManager();
            }

            if (reset && angular.isDefined(this.selectedSection)) {
                this.selectedSection.reset();
            }

            if (exitPastTransactionMode) {
                this.exitRegisterPastTransactionMode();
            }

            this.printService.showStandbyMessage();
        }

        giftCardValueAdjustment(saleLine, newFinalItemPrice): any {
            let deferred = this.$q.defer();

            if (saleLine.saleType !== Model.SalesTypeEnum.GiftCard) {
                deferred.resolve();
                return deferred.promise;
            }

            function adjustGiftCardValue() {
                saleLine.baseItemPrice =
                    saleLine.originalFinalItemPrice =
                    saleLine.item.clientGiftCard.remainingAmount = newFinalItemPrice;
            }

            if (newFinalItemPrice >= saleLine.item.clientGiftCard.remainingAmount) {
                deferred.resolve();
                adjustGiftCardValue();
            } else {
                const formattedPrice = this.meevoCurrency(newFinalItemPrice);
                const message = this.$translate.instant("MESSAGE_REDUCE_GIFT_CARD_VALUE", { price: formattedPrice });

                this.modalService.confirm(message)
                    .then(() => {
                        adjustGiftCardValue();
                    })
                    .finally(() => {
                        deferred.resolve();
                    });
            }

            return deferred.promise;
        }

        priceChange(saleLine: Model.SaleLine, sale?: Model.Sale) {
            sale = sale || this.sale;
            let newFinalItemPrice: number = +saleLine.newFinalItemPrice;
            let newFinalItemPriceCharge: number = +saleLine.newFinalItemPrice;
            let newFinalItemCharge: number = null;

            if (saleLine.isRefund && saleLine.originalFinalCharge) {
                const originalFinalItemCharge = Math.abs(saleLine.originalFinalCharge) / saleLine.originalQuantity;
                const ratio = newFinalItemPrice / (Math.abs(saleLine.originalFinalItemPrice) + originalFinalItemCharge);
                newFinalItemCharge = this.normalizeDecimalPlaces(originalFinalItemCharge * ratio);
                newFinalItemPrice = this.normalizeDecimalPlaces(newFinalItemPrice - newFinalItemCharge);
            }

            if (this.isPackageType(saleLine)) {
                this.removeRedemptionForPackage(saleLine.item.id, sale);
            }

            if (this.registerDiscountService.isPriceChangeDiscountSame(saleLine, newFinalItemPrice, newFinalItemCharge)) {
                return;
            }

            return this.giftCardValueAdjustment(saleLine, newFinalItemPrice).then(() => {

                // Treat manual change as special price discount
                this.registerDiscountService.handlePriceChangeDiscount(this, saleLine, newFinalItemPrice, newFinalItemCharge);

                if (saleLine.isRefund) {
                    if (saleLine.saleType === Model.SalesTypeEnum.ReloadGiftCard) {
                        const saleLineItem = saleLine.item as Model.GiftCardSaleLineItem;
                        if (Math.abs(newFinalItemPrice) > Math.abs(saleLineItem.clientGiftCard.remainingRefundAmount)) {
                            this.modalService.alert("MESSAGE_REFUND_AMOUNT_EXCEED_VALIDATION");
                            return;
                        }
                    } else {
                        if (Math.abs(newFinalItemPrice) > Math.abs(saleLine.originalFinalItemPrice)) {
                            saleLine.newFinalItemPrice = -saleLine.originalFinalItemPrice;
                            return this.modalService.alert("MESSAGE_REFUND_EXCEED_VALIDATION");
                        }
                        if (newFinalItemCharge !== null && Math.abs(newFinalItemCharge) > Math.abs(saleLine.originalFinalItemCharge)) {
                            saleLine.newFinalItemCharge = -saleLine.originalFinalItemCharge;
                            return this.modalService.alert("MESSAGE_REFUND_EXCEED_VALIDATION");
                        }
                        if (Math.abs(saleLine.originalFinalItemPriceCharge) > 0 && Math.abs(newFinalItemPriceCharge) == 0) {
                            this.modalService.alert(this.$translate.instant('MESSAGE_REFUND_CANNOT_REFUND_FOR_0_VALIDATION', { zeroAmount: 0.00 }));
                            return;
                        }
                        if (this.saleLineHasTippyServiceCharge(saleLine) && Math.abs(newFinalItemPrice) !== Math.abs(saleLine.finalItemPriceCharge)) {
                            return this.modalService.alert("MESSAGE_REGISTER_TIPPY_SERVICE_CHARGE_CHANGED").then(() => {
                                saleLine.newFinalItemPrice = Math.abs(saleLine.finalItemPriceCharge);
                                (saleLine as any).hideAmount = true;
                                this.$timeout(() => delete((saleLine as any).hideAmount))
                            });
                        }
                    }
                }

                saleLine.finalItemPrice = newFinalItemPrice;
                if (saleLine.originalFinalCharge) {
                    saleLine.finalItemCharge = newFinalItemCharge;
                }

                return this.recalculateSale(true, null, false, sale)
                    .catch(() => {
                        if (saleLine.saleType === Model.SalesTypeEnum.GiftCard) {
                            saleLine.finalItemPrice = saleLine.baseItemPrice;
                        }
                    })
                    .finally(() => {
                        saleLine.newFinalItemPrice = Math.abs(saleLine.newFinalItemPrice);
                        this.recalculateChangeDue(sale);
                    });
            });
        }

        quantityChange(saleLine: Model.SaleLine, sale?: Model.Sale) {
            sale = sale || this.sale;
            let newQuantity = +saleLine.newQuantity;

            if (saleLine.quantity === newQuantity) {
                return this.$q.resolve();
            }
            return this.$timeout(0).then(() => {
                var promise: ng.IPromise<any> = null;
                if (_.find(saleLine.discountLines, (item: Model.DiscountLine) => { return !!item.discountId; })) {
                    // if sale line has a pre-defined discount
                    if (saleLine.quantity > newQuantity) {
                        promise = this.modalService.confirm("MESSAGE_DECREASE_QUANTITY_FOR_DISCOUNTED_SALE_LINE");
                    }
                    else if (saleLine.quantity < newQuantity) {
                        promise = this.modalService.alert("MESSAGE_INCREASE_QUANTITY_FOR_DISCOUNTED_SALE_LINE");
                    }
                }
                else if (saleLine.packageRedeemed && saleLine.redeemedPackages && saleLine.redeemedPackages.length > 0) {
                    promise = this.modalService.alert("MESSAGE_CHANGE_QUANTITY_FOR_REDEEMED_SALE_LINE");
                }

                if (promise == null) {
                    promise = this.$q.resolve(true);
                }

                saleLine.showPoleMessage = Model.SaleLineStatusEnum.Updated;

                return promise.then(() => {
                    if (saleLine.packageRedeemed && saleLine.redeemedPackages && saleLine.redeemedPackages.length > 0) {
                        // if sale line redeems package services
                        this.removePackageRedemption(saleLine, false, sale);
                    }

                    let isValid = true;
                    if (saleLine.refundSaleId && saleLine.refundSaleDate && saleLine.refundSaleLineId !== 0 && newQuantity > saleLine.originalQuantity) {
                        this.modalService.alert("MESSAGE_REFUND_EXCEED_VALIDATION");
                        newQuantity = saleLine.originalQuantity;
                        isValid = false;
                    }

                    saleLine.quantity = newQuantity;
                    saleLine.isDirty = true;
                    this.syncRefundLotAllocations(saleLine);

                    if (isValid && saleLine.redeemedPackageItems) {
                        this.addPackageRedeemedRefundSaleLine(saleLine, saleLine.saleType,0, true, saleLine.client);
                    }
                    return this.recalculateSale(true, null, false, sale).then(() => {
                        this.registerDiscountService.reinitializeDiscounts(this, saleLine);
                    });
                });
            });
        }

        addAssociatedClientSaleLine(client, clientType: Meevo.Model.ClientTypeEnum = null, sale: Model.Sale = null): Model.SaleLine {
            sale = sale || this.sale;

            var associatedClientSaleLineItem = new Meevo.Plugins.Register.AssociatedClientSaleLineItem({});
            let saleLine: Model.SaleLine = {
                saleType: Model.SalesTypeEnum.AssociatedClient,
                item: associatedClientSaleLineItem,
                quantity: 1,
                client: client,
                clientId: client ? client.id : undefined,
                clientType: clientType || Meevo.Model.ClientTypeEnum.Client,
                finalItemPrice: 0,
                baseItemPrice: 0,
                finalItemPriceCharge: 0,
                baseItemPriceCharge: 0,
                tax: 0,
                taxes: [],
                isRefund: false,
            };
            sale.saleLines.push(saleLine);
            return saleLine;
        }

        recalculateSale(keepAccordionOpen: boolean = false, selectSection: RegisterSectionTypeEnum = null, checkWarnings: boolean = false, sale?: Model.Sale, skipAutoAddExistingServices = false) {
            return this.registerTicketService.recalculateSale(this, keepAccordionOpen, selectSection, checkWarnings, sale, skipAutoAddExistingServices);
        }

        // Fire the pre-finalize "send membership form now" call for any membership sale line the
        // user flagged (sendFormNow === true) once it has been persisted
        sendMembershipFormNowIfPending(): void {
            if (!this.sale || !this.sale.saleLines) {
                return;
            }

            this.sale.saleLines
                .filter(saleLine => saleLine.saleType === Model.SalesTypeEnum.Membership && !saleLine.isRefund && saleLine.item &&
                    (<MembershipSaleLineItem>saleLine.item).sendFormNow === true && saleLine.item.id &&
                    this.membershipFormsSentNow.indexOf(saleLine.item.id) === -1)
                .forEach(saleLine => {
                    const item = <MembershipSaleLineItem>saleLine.item;
                    // Mark before the async call so a concurrent recalc can't double-fire.
                    this.membershipFormsSentNow.push(item.id);

                    this.dataService.customMethodData("/api/DocsAndForms/ResendClientForm", "post", {
                        FormFillTypeEnum: Meevo.Plugins.DocsAndForms.FormFillTypeEnum.Membership,
                        ClientId: saleLine.clientId || item.clientId,
                        MembershipId: item.membershipId,
                        ClientMembershipId: item.id
                    }).catch(() => {
                        // Let a later recalc retry if the send failed.
                        let sentIndex = this.membershipFormsSentNow.indexOf(item.id);
                        if (sentIndex !== -1) {
                            this.membershipFormsSentNow.splice(sentIndex, 1);
                        }
                    });
                });
        }

        checkSignaturePendingPayments(): angular.IPromise<void> {
            let signaturePendingPaymentLine = _.findWhere(this.sale.paymentLines, { paymentRequestStatus: Model.PaymentRequestStatusEnum.SignatureVerificationPending });
            if (signaturePendingPaymentLine) {
                return this.loadPaymentCategories().then(() => {
                    let signaturePendingCreditPaymentsSection = new CreditPaymentsSection(this, RegisterSectionTypeEnum.CreditSingleCard);
                    signaturePendingCreditPaymentsSection.reset();
                    return signaturePendingCreditPaymentsSection.initiateTimeoutWorkflow(signaturePendingPaymentLine);
                })
            }
            return this.$q.resolve();
        }

        private transferObject(dstObj, srcObj) {
            if (!srcObj || !dstObj || srcObj === dstObj) {
                return
            }
            // transfer srcObj properties into dstObj but keep dstObj reference
            Object.keys(dstObj).forEach(function (key) {
                delete dstObj[key];
            });
            Object.keys(srcObj).forEach(function (key) {
                dstObj[key] = srcObj[key];
            });
        }

        printVoidReceipts(sale: Model.Sale) {
            var paymentRequests =
                _.pluck(sale.paymentLines.filter((payment) => {
                    return payment.paymentCategory === Model.PaymentCategoryEnum.CreditDebit
                        && (payment as Model.SaleCreditCardPayment).paymentRequest
                        && (payment as Model.SaleCreditCardPayment).paymentRequest.paymentRequestVoidStatus === Model.PaymentRequestStatusEnum.Approved;
                }), "paymentRequest");
            if (paymentRequests.length > 0) {
                this.printCreditCardReceipts(paymentRequests, true);
            }
        }

        clearSale(deferred: ng.IDeferred<{}>, sale?: Model.Sale): angular.IPromise<void> {
            sale = sale || this.sale;

            sale.noSale = true;
            if (this.selectedTerminal) {
                sale.merchantTerminalId = this.selectedTerminal.id;
                sale.externalTerminalId = this.selectedTerminal.externalTerminalId;
            }

            sale.merchantAccountId = this.selectedDrawer.merchantAccountId;

            this.busyService.start();
            return this.dataService.add("drawer", sale, new Guid(this.selectedDrawer.id), "sale")
                .then((response: Model.Sale) => {
                    this.printVoidReceipts(response);

                    this.reset();
                    if (sale) {
                        this.transferObject(sale, this.sale);
                    }

                    // clear register data
                    deferred.resolve();
                })
                .catch(() => {
                    sale.noSale = false;
                })
                .finally(() => {
                    this.busyService.stop();
                    this.checkMembershipOrigination();
                });
        }

        clearSaleSelfPaymentEntityVersionValidationFailure(retainCareCredit: boolean) {
            let message = `${this.$translate.instant("MESSAGE_SELF_PAYMENT_VERSION_EXCEPTION")}
${retainCareCredit ? this.$translate.instant("MESSAGE_SELF_PAYMENT_VERSION_EXCEPTION_RETAIN_CARE_CREDIT") : ""}
`;
            this.modalService.alert(message);
            let deferred = this.$q.defer();
            let careCreditPayments = this.sale.paymentLines.filter(paymentLine => paymentLine.paymentCategory ===
                Meevo.Model.PaymentCategoryEnum.CareCredit);

            this.sale.paymentLines = _(this.sale.paymentLines).without(...careCreditPayments);
            this.clearSale(deferred).then(() => {
                if (retainCareCredit) {
                    this.sale.paymentLines.push(...careCreditPayments);
                    this.recalculateChangeDue(this.sale);
                }
            });
        }

        selectFirstClient(selectSection) {
            if (this.allUniqueClients.length === 0) {
                selectSection = RegisterSectionTypeEnum.Client;
            }
            let doNotSelectServices = false;

            if (selectSection !== null) {
                this.selectSection(selectSection);
                doNotSelectServices = true;
            }

            if (!this.selectedClient &&
                !this.selectedClientType &&
                this.allUniqueClients.length > 0) {
                this.selectClient(this.allUniqueClients[0], doNotSelectServices);
            }
        }

        queuePosDisplay(saleLines: Model.SaleLine[]) {
            let messages: Meevo.Components.Common.IPoleDisplayObject[] = [];

            saleLines.forEach((saleLine: Model.SaleLine) => {
                if (saleLine.showPoleMessage != null) {
                    let displayName = saleLine.item ? saleLine.item.displayName : "";
                    let displayText1: string = ((saleLine.saleType === Model.SalesTypeEnum.Service ? (saleLine.item.shortcut + ":") : "") + displayName);
                    if (saleLine.discountLines && saleLine.discountLines.length > 0) {
                        if (_.findWhere(saleLine.discountLines, { saleLineDiscountType: Model.SaleLineDiscountTypeEnum.CancellationFee })) {
                            displayText1 = "CXCLFee " + displayText1;
                        }
                        else if (_.findWhere(saleLine.discountLines, { saleLineDiscountType: Model.SaleLineDiscountTypeEnum.NoShowFee })) {
                            displayText1 = "NSFee " + displayText1;
                        }
                    }

                    /* bug: use finalItemPriceCharge for refund?
                    let itemPrice = saleLine.isRefund
                        ? saleLine.finalItemPriceCharge
                        : saleLine.baseItemPriceCharge;
                    */
                    let itemPrice = saleLine.baseItemPriceCharge;

                    messages.push({
                        lines: [
                            { text: [((saleLine.showPoleMessage == Model.SaleLineStatusEnum.Updated) ? this.$translate.instant("LABEL_POLE_UPDT") + "-" : "") + displayText1], alignment: Meevo.Components.Common.PoleDisplayAlignment.Left },
                            { text: [saleLine.quantity + " x " + this.formatAmountForPoleDisplay(itemPrice)], alignment: Meevo.Components.Common.PoleDisplayAlignment.Right }
                        ]
                    });
                }

                if (saleLine.discountLines && saleLine.discountLines.length > 0) {
                    saleLine.discountLines.forEach((discountLine: Model.DiscountLine) => {
                        if (discountLine.saleLineDiscountType != Model.SaleLineDiscountTypeEnum.CancellationFee
                            && discountLine.saleLineDiscountType != Model.SaleLineDiscountTypeEnum.NoShowFee
                            && !discountLine.isBuyItem
                            && (discountLine.showPoleMessage != null || saleLine.showPoleMessage == Model.SaleLineStatusEnum.Added)) {
                            messages.push({
                                lines: [
                                    { text: [((discountLine.showPoleMessage == Model.SaleLineStatusEnum.Updated) ? this.$translate.instant("LABEL_POLE_UPDT") + "-" : "") + this.getDiscountName(discountLine)], alignment: Meevo.Components.Common.PoleDisplayAlignment.Left },
                                    { text: [this.formatAmountForPoleDisplay(-discountLine.amount)], alignment: Meevo.Components.Common.PoleDisplayAlignment.Right }
                                ]
                            });
                        }
                        discountLine.showPoleMessage = null;
                    });
                }
                saleLine.showPoleMessage = null;
            });

            this.printService.queueMessagesToPoleDisplay(...messages);
        }

        private formatAmountForPoleDisplay(amount: number): string {
            return this.meevoCurrency(amount, 'financial');
        }

        showDocsAndForms(saleLines) {
            let defer = this.$q.defer();

            this.securityService.checkSecurityKey(this.meevoSecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_FORMS)
                .then((result) => {
                    if (result === Meevo.Model.SecurityAccessEnum.Grant) {
                        let serviceSaleLineItems = _(saleLines).chain().filter((saleLine: Model.SaleLine) => {
                            if (this.isSaleLineAService(saleLine) && saleLine.clientType == Model.ClientTypeEnum.Client) {
                                let serviceSaleLineItem = <ServiceSaleLineItem>saleLine.item;
                                return Meevo.Model.Guard.isSomething(serviceSaleLineItem.appointmentServiceId);
                            }
                            return false;
                        }).pluck("item").value();
                        if (serviceSaleLineItems.length > 0) {
                            let request = {
                                "AppointmentServicesList": _(serviceSaleLineItems).pluck("appointmentServiceId"),
                                "TriggerEventEnum": Meevo.Model.DocsAndFormsTriggerEventEnum.Booked,
                                "IsRequired": true
                            }
                            this.dataService.customMethodData("api/DocsAndForms/AppointmentServiceForm/List", "post",
                                request).then((formsResponse) => {
                                    let unsubmittedForms = _(formsResponse.data).filter((form) => !form.isSubmitted);
                                    if (unsubmittedForms.length > 0) {

                                        let modalOptions: Meevo.Components.Modal.IModalOptions = {
                                            templateUrl: "app/plugins/AppointmentBook/views/DocsAndForms.html",
                                            controller: "meevo.plugins.appointmentBook.DocsAndFormsController",
                                            controllerAs: "vm",
                                            bindToController: true,
                                            locals: {
                                                forms: unsubmittedForms,
                                                formCollectionState: Meevo.Plugins.AppointmentBook.FormCollectionStateEnum.Checkin,
                                                request: request,
                                                appointmentServices: null,
                                                iframeCallback: () => defer.resolve()
                                            }
                                        };
                                        this.modalService.showCustom(modalOptions).then(() => {
                                            defer.resolve();
                                        });
                                    }
                                    else {
                                        defer.resolve();
                                    }
                                });
                        }
                        else {
                            defer.resolve();
                        }
                    } else {
                        defer.resolve();
                    }
                });

            return defer.promise;
        }
        showCustomControls(saleLines, forceShow) {
            var defer = this.$q.defer();
            let customControlsSaleLines = _(saleLines).filter((saleLine: Model.SaleLine) => {
                if (this.isSaleLineAService(saleLine)) {
                    let serviceSaleLineItem = <ServiceSaleLineItem>saleLine.item;
                    return serviceSaleLineItem.hasCheckoutCustomControls && (forceShow || !serviceSaleLineItem.customControlsAnswers);
                }
                return false;
            });
            if (_(customControlsSaleLines).any()) {
                let details = [];
                customControlsSaleLines.forEach((saleLine) => {
                    let serviceSaleLineItem = <ServiceSaleLineItem>saleLine.item;
                    details.push({
                        serviceId: serviceSaleLineItem.id,
                        id: serviceSaleLineItem.appointmentServiceId,
                        serviceDisplayName: serviceSaleLineItem.displayName,
                        customControlsAnswers: { answers: serviceSaleLineItem.customControlsAnswers }
                    });
                });
                let modalOptions: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/AppointmentBook/views/CustomFields.html",
                    controller: "meevo.plugins.appointmentbook.CustomFieldsController",
                    controllerAs: "vm",
                    bindToController: true,
                    additionalClassName: 'appointment-custom-fields-modal',
                    locals: {
                        appointDetails: details,
                        appArea: Meevo.Model.AppAreaEnum.Checkout,
                        canEdit: true,
                        forceCancel: true
                    }
                };
                this.modalService.showCustom(modalOptions)
                    .then((customFieldsResponse) => {
                        if (customFieldsResponse.proceed) {
                            customFieldsResponse.data.forEach((data) => {
                                let serviceSaleLine = _(saleLines)
                                    .find((saleLine) => {
                                        return this.isSaleLineAService(saleLine) && (<ServiceSaleLineItem>saleLine.item).appointmentServiceId == data.appointDetail.id;
                                    });
                                (<ServiceSaleLineItem>serviceSaleLine.item).customControlsAnswers = data.appointDetail.customControlsAnswers.answers;
                            });
                        }
                        defer.resolve();
                    });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        clientHasNoSaleItem(clientObj: RegisterClient) {
            return !_(this.sale.saleLines).any((saleLine) =>
                saleLine.saleType !== Model.SalesTypeEnum.AssociatedClient &&
                !(saleLine.saleType === Meevo.Model.SalesTypeEnum.PaymentSurcharge && !saleLine.isRefund) &&
                clientObj.isMatch(saleLine));
        }

        hasClientWithNoSaleItem() {
            return this.allUniqueClients.some((clientObj) => this.clientHasNoSaleItem(clientObj));
        }

        productInformation(saleLine: Model.SaleLine, event) {
            event.stopPropagation();
            let item: ProductSaleLineItem = <ProductSaleLineItem>saleLine.item;
            let modalOptions : Meevo.Plugins.Product.ProductInfoModalOptions = {
                productId: item.productId,
                variantIdInitiator: item.id,
                productInventoryTypeEnum: item.productInventoryType,
                parentType: Meevo.Plugins.Product.ProductInfoModalParent.Register
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/product/modals/productInformation.template.html",
                controller: "meevo.plugins.product.ProductInformationController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    options: modalOptions
                }
            }
            this.modalService.showCustom(options);
        }

        isSaleLineRemovable(saleLine: Model.SaleLine) {
            if (!saleLine) {
                return false;
            }

            if (this.isTicketCharge(saleLine) && !saleLine.isRefund) {
                return false;
            }

            if (this.selectedSection.sectionType === RegisterSectionTypeEnum.Package &&
                this.isRefundMode && saleLine.isRefund &&
                (saleLine.saleType === Model.SalesTypeEnum.Package || saleLine.saleType === Model.SalesTypeEnum.PackageRefund)) {

                    return false;
            }

            if (saleLine.isRefund && saleLine.saleType === Model.SalesTypeEnum.PackageServiceSwapFee) {
                return !saleLine.isLinkedRefundLine;
            }

            if (saleLine.saleType === Model.SalesTypeEnum.PaymentPlanReduction ||
                (saleLine.isRefund && this.paymentPlanService.paymentPlanHasRemainingBalance(saleLine.paymentPlanId))) {
                return false;
            }

            if (saleLine.saleType === Model.SalesTypeEnum.PaymentPlanPayment) {
                return this.paymentPlanService.isPaymentPlanPaymentSaleLineRemovable(this.sale, saleLine);
            }

            return true;
        }

        isSaleLineServiceOrSwapFee(saleLine: Model.SaleLine) {
            return saleLine.saleType === Model.SalesTypeEnum.Service || saleLine.saleType === Model.SalesTypeEnum.PackageServiceSwapFee;
        }

        removeSaleLine(saleLine, sale?: Model.Sale, shouldSelectClient: boolean = true) {
            sale = sale || this.sale;

            if (!this.isSelectedDrawerOpen() || this.sale.recalculateSaleInProgress) {
                return;
            }

            if ((this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Payment ||
                this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Other) &&
                (this.selectedSection.sectionType != RegisterSectionTypeEnum.PaymentPlan &&
                    !this.isRefundMode)) {
                this.selectSection(RegisterSectionTypeEnum.Services);
            }

            if (saleLine.isRefund && saleLine.saleType === Model.SalesTypeEnum.Service && this.saleLineHasLinkedIds(saleLine)) {
                var linkedRefundSaleLine = this.getLinkedRefundSaleLine(saleLine, this.sale.saleLines);

                if (linkedRefundSaleLine &&
                    linkedRefundSaleLine.saleType === Model.SalesTypeEnum.PackageServiceSwapFee) {
                    linkedRefundSaleLine.isLinkedRefundLine = false;
                }
            }

            let saleTypeKey;
            let url;

            if (!saleLine.isRefund) {
                switch (saleLine.saleType) {
                    case Model.SalesTypeEnum.Package:
                        saleTypeKey = "LABEL_PACKAGE";
                        url = `/api/clientpackage/${saleLine.item.id}`;
                        break;
                    case Model.SalesTypeEnum.PackageTransfer:
                        saleTypeKey = "LABEL_PACKAGE_TRANSFER";
                        url = `/api/clientpackage/${saleLine.item.id}`;
                        break;
                    case Model.SalesTypeEnum.Membership:
                        saleTypeKey = "LABEL_MEMBERSHIP";
                        url = `/api/Membership/Client/${saleLine.item.id}`;
                        break;
                }
            }

            if (saleTypeKey) {
                let message = this.$translate.instant("MESSAGE_DELETE_SALE_LINE", {
                    saleType: this.$translate.instant(saleTypeKey).toLowerCase()
                });

                this.modalService.confirm(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate).then(() => {
                    this.removeSaleLineWorker(saleLine, sale, shouldSelectClient);
                    this.dataService.customMethodData(url, "delete", undefined);
                });
            } else {
                this.removeSaleLineWorker(saleLine, sale, shouldSelectClient);
            }
        }

        private removeRelatedRedeemedSaleLines(saleLine: Model.SaleLine, indicesToRemove: number[], sale: Model.Sale) {
            saleLine.isDeleteWithPackageRedeemed = true;

            sale.saleLines.forEach((otherSaleLine, otherSaleLineIndex) => {
                let otherSaleLineItem = otherSaleLine.item as Model.PackageServiceSwapFeeSaleLineItem;

                if (otherSaleLine.saleType === Model.SalesTypeEnum.PackageServiceSwapFee
                    && saleLine.packageRedemptionPath.totalSwapFee > 0
                    && _.find(saleLine.redeemedPackages, (redeemedPackage: any) => {
                        return _.findWhere(redeemedPackage.packageServices, { id: otherSaleLineItem.clientPackageServiceId }) != null;
                    })) {
                    indicesToRemove.push(otherSaleLineIndex);
                }
            });

            //Remove the split sale line for product usage if it exists
            const redeemPackageSplitLineIndex = this.getRedeemPackageSplitLineIndex(saleLine, sale);
            if (redeemPackageSplitLineIndex >= 0) {
                indicesToRemove.push(redeemPackageSplitLineIndex);
            }
        }

        private getRedeemPackageSplitLineIndex(saleLine: Model.SaleLine, sale: Model.Sale) {
            if ((!!saleLine.redeemedPackages &&
                 saleLine.redeemedPackages.find(clientPackage => clientPackage.category === Model.PackageTypeCategoryEnum.ProductUsageTracking)) ||
                (!!saleLine.redeemedPackageItems &&
                 saleLine.redeemedPackageItems.find(item => item.itemType == Model.PackageItemTypeEnum.ProductUnit))
            ) {
                return sale.saleLines.findIndex(localSaleLine => !!localSaleLine.linkedSaleLineIds &&
                    !!localSaleLine.linkedSaleLineIds.find(linkedSaleLineId => linkedSaleLineId === saleLine.id));
            }
        }

        private removeRelatedPromoGiftCardPaymentLine(paymentPromoGiftCardId: string, sale: Model.Sale) {
            let paymentLine = _(sale.paymentLines).findWhere({ giftCardId: paymentPromoGiftCardId });

            if (!paymentLine) {
                return;
            }

            this.removeTicketPaymentLine(paymentLine, sale);
        }

        private removeRelatedPromoGiftCardSaleLines(saleLine: Model.SaleLine, indicesToRemove: number[], sale: Model.Sale) {
            let saleLineItem = saleLine.item as Model.ServiceSaleLineItem;

            sale.saleLines.forEach((otherSaleLine, otherSaleLineIndex) => {
                if (otherSaleLine.saleType === Model.SalesTypeEnum.PackageServiceSwapFee) {
                    let otherSaleLineItem = otherSaleLine.item as Model.PackageServiceSwapFeeSaleLineItem;

                    if (otherSaleLineItem.paymentPromoGiftCardId && otherSaleLineItem.paymentPromoGiftCardId == saleLineItem.paymentPromoGiftCardId) {
                        indicesToRemove.push(otherSaleLineIndex);
                    }
                }
            });
        }

        private removeRelatedDepositPaymentLine(saleLine: Model.SaleLine, sale: Model.Sale) {
            let saleLineItem = saleLine.item as Model.ServiceSaleLineItem;

            let paymentLine = _(sale.paymentLines).findWhere({ appointmentServiceId: saleLineItem.appointmentServiceId });

            if (!paymentLine) {
                return;
            }

            this.removeTicketPaymentLine(paymentLine, sale);
        }

        private removeParentSplitRedeemLine(saleLine: Model.SaleLine, sale: Model.Sale) {
            if (this.isPartialRedemptionRemainder(saleLine) &&
                saleLine.linkedSaleLineIds) {
                const parentSaleLine = sale.saleLines.find(localSaleLine =>
                    !!saleLine.linkedSaleLineIds.find(linkedSaleLineId => linkedSaleLineId === localSaleLine.id));
                if (parentSaleLine) {
                    this.removePackageRedemption(parentSaleLine, false);
                }
            }
        }

        private removeRefundSplitLine(saleLine: Model.SaleLine, indicesToRemove: number[], sale: Model.Sale) {
            if (saleLine.isLinkedRefundLine &&
                saleLine.saleType !== Model.SalesTypeEnum.PackageServiceSwapFee) {
                const index = sale.saleLines.findIndex(localSaleLine =>
                    localSaleLine.saleType !== Model.SalesTypeEnum.PackageServiceSwapFee &&
                    localSaleLine.refundLocationId === saleLine.refundLocationId &&
                    moment(localSaleLine.refundSaleDate).isSame(saleLine.refundSaleDate) &&
                    localSaleLine.refundSaleId === saleLine.refundSaleId &&
                    !!localSaleLine.linkedSaleLineIds &&
                    !!localSaleLine.linkedSaleLineIds.find(linkedSaleLineId => linkedSaleLineId === saleLine.refundSaleLineId));
                if (index >= 0) {
                    indicesToRemove.push(index);
                }
            }
        }

        private removeRedemptionForPackageServiceSwapFee(saleLine: Model.SaleLine, sale: Model.Sale) {
            let redeemedSaleLine = _.find(sale.saleLines, (sl) => {
                return _.find(sl.redeemedPackages, (cp) => {
                    return _.findWhere(cp.packageServices, { id: (saleLine.item as Model.PackageServiceSwapFeeSaleLineItem).clientPackageServiceId }) != null;
                }) != null;
            });

            if (redeemedSaleLine) {
                redeemedSaleLine.packageRedeemed = false;
            }
        }

        private removeRelatedDeposit(saleLine: Model.SaleLine, indicesToRemove: number[], sale: Model.Sale) {
            let saleLineItem = saleLine.item as Model.ServiceSaleLineItem;
            if (!saleLineItem.appointmentServiceId) {
                return;
            }

            sale.saleLines.forEach((otherSaleLine, otherSaleLineIndex) => {
                if (otherSaleLine.saleType === Model.SalesTypeEnum.DepositCredit) {
                    let otherSaleLineItem = otherSaleLine.item as Model.ClientAccountSaleLineItem;

                    if (otherSaleLineItem.appointmentServiceId == saleLineItem.appointmentServiceId) {
                        indicesToRemove.push(otherSaleLineIndex);
                    }
                }
            });
        }

        private removeRelatedFee(saleLine: Model.SaleLine, indicesToRemove: number[], sale: Model.Sale) {
            let saleLineItem = saleLine.item as Model.ClientAccountSaleLineItem;
            if (!saleLineItem.appointmentServiceId) {
                return;
            }

            sale.saleLines.forEach((otherSaleLine, otherSaleLineIndex) => {
                let otherSaleLineItem = otherSaleLine.item as Model.ServiceSaleLineItem;

                if (this.isFee(otherSaleLine.saleType)
                    && otherSaleLineItem.appointmentServiceId == saleLineItem.appointmentServiceId) {
                    indicesToRemove.push(otherSaleLineIndex);
                }
            });
        }

        private removeSaleLineWorker(saleLine: Model.SaleLine, sale: Model.Sale, shouldSelectClient: boolean = true) {
            let selectClient = () => {
                if (!shouldSelectClient) {
                    return;
                }

                // find saleLine for selected client
                var clientMatch: RegisterClient = new RegisterClient({ clientType: this.selectedClientType, client: this.selectedClient, appointmentId: this.selectedClientAppointmentId });
                if (this.clientHasNoSaleItem(clientMatch) && this.selectedSection.sectionType === RegisterSectionTypeEnum.Client) {
                    this.selectSection(RegisterSectionTypeEnum.Services);
                }
            }

            let indexOfSaleLine = _(sale.saleLines).indexOf(saleLine);

            if (indexOfSaleLine === -1) {
                selectClient();
                return;
            }

            let indicesToRemove: number[] = [indexOfSaleLine];

            if (this.isSaleLineAService(saleLine)) {
                let saleLineItem = saleLine.item as Model.ServiceSaleLineItem;

                if (this.allUniqueServices[saleLineItem.appointmentServiceId]) {
                    this.allUniqueServices[saleLineItem.appointmentServiceId] = null;
                    delete this.allUniqueServices[saleLineItem.appointmentServiceId];
                }

                if (saleLine.packageRedeemed && saleLine.redeemedPackages && saleLine.redeemedPackages.length > 0) {
                    indicesToRemove = [];
                    this.removeRelatedRedeemedSaleLines(saleLine, indicesToRemove, sale);
                }

                this.removeRelatedPromoGiftCardSaleLines(saleLine, indicesToRemove, sale);
                this.removeRelatedPromoGiftCardPaymentLine(saleLineItem.paymentPromoGiftCardId, sale);
                this.removeRelatedDepositPaymentLine(saleLine, sale);
                this.removeParentSplitRedeemLine(saleLine, sale);
                this.removeRefundSplitLine(saleLine, indicesToRemove, sale);

                if (this.isFee(saleLine.saleType)) {
                    this.removeRelatedDeposit(saleLine, indicesToRemove, sale);
                }
            }
            else if (saleLine.saleType === Meevo.Model.SalesTypeEnum.DepositCredit) {
                this.removeRelatedFee(saleLine, indicesToRemove, sale);
            }
            else if (saleLine.saleType === Meevo.Model.SalesTypeEnum.Package || saleLine.saleType === Meevo.Model.SalesTypeEnum.PackageTransfer) {
                // remove package redemption on other sale lines which uses this package
                this.removeRedemptionForPackage(saleLine.item.id, sale);
            }
            else if (saleLine.saleType === Meevo.Model.SalesTypeEnum.PackageServiceSwapFee) {
                // remove the package redemption on other sale lines which this fee is tied to
                this.removeRedemptionForPackageServiceSwapFee(saleLine, sale);

                let saleLineItem = saleLine.item as Model.PackageServiceSwapFeeSaleLineItem;
                this.removeRelatedPromoGiftCardPaymentLine(saleLineItem.paymentPromoGiftCardId, sale);
            }

            this.selectedSection.delete(saleLine);

            // sort indices in descending order
            indicesToRemove.sort((a, b) => { return b - a; });

            // delete all sale lines
            indicesToRemove.forEach((v, i) => {
                sale.saleLines.splice(v, 1);
            });

            //Need to recompute originalQuantity
            if (saleLine.redeemedPackageItems) {
                this.addPackageRedeemedRefundSaleLine(saleLine, saleLine.saleType, 0, true, saleLine.client);
            }

            this.recalculateSale(false, null, false, sale).then(() => {
                selectClient();
            });
        }

        editSaleItem(saleLine: Model.SaleLine, bypass: boolean = false) {
            let registerSectionType: RegisterSectionTypeEnum;
            let reset: boolean = true;
            switch (saleLine.saleType) {
                case Model.SalesTypeEnum.Package:
                    if (!bypass && _.find(this.sale.saleLines, (item) => { return (item.redeemedPackages && item.redeemedPackages.length > 0 && _.findWhere(item.redeemedPackages, { id: saleLine.item.id })); })) {
                        this.modalService
                            .confirm("MESSAGE_CONFIRM_PACKAGE_CHANGE_REMOVAL_OF_REDEMPTION")
                            .then(() => {
                                this.sale.saleLines.forEach((item) => {
                                    if (item.redeemedPackages && item.redeemedPackages.length > 0 && _.findWhere(item.redeemedPackages, { id: saleLine.item.id })) {
                                        this.removePackageRedemption(item, false);
                                    }
                                });
                                this.recalculateSale(true).then(() => {
                                    saleLine = _.find(this.sale.saleLines, (item) => { return item.item.id == saleLine.item.id; });
                                    if (saleLine) {
                                        this.editSaleItem(saleLine, true);
                                    }
                                });
                            });
                        return;
                    }
                    registerSectionType = RegisterSectionTypeEnum.Package;
                    break;
                case Model.SalesTypeEnum.Membership:
                    registerSectionType = RegisterSectionTypeEnum.Memberships;
                    break;
                case Model.SalesTypeEnum.ClientAccountCredit:
                case Model.SalesTypeEnum.ClientAccountPayment:
                    reset = false;
                    registerSectionType = RegisterSectionTypeEnum.ClientAccounts;
                    break;
                case Model.SalesTypeEnum.Product:
                    registerSectionType = RegisterSectionTypeEnum.Products;
                    break;
                case Model.SalesTypeEnum.BulkGiftCard:
                    registerSectionType = RegisterSectionTypeEnum.GiftCard;
                    break;
                default:
                    return;
            }
            this.selectSection(registerSectionType, reset, saleLine.isRefund).then(() => {
                this.selectedSection.edit(saleLine);
            });
        }

        removeAllSaleItems(regClient: RegisterClient, onlyServices?: boolean) {
            for (var index = this.sale.saleLines.length - 1; index >= 0; index--) {
                let saleLine = this.sale.saleLines[index];
                if (regClient && regClient.isMatch(saleLine)) {
                    if (this.isSaleLineAService(saleLine)) {
                        // remove the service from the hash table
                        let serviceItem = (saleLine.item as Meevo.Model.ServiceSaleLineItem);
                        if (this.allUniqueServices[serviceItem.appointmentServiceId]) {
                            this.allUniqueServices[serviceItem.appointmentServiceId] = null;
                            delete this.allUniqueServices[serviceItem.appointmentServiceId];
                        }
                    }
                    if (!onlyServices || this.isSaleLineAService(saleLine)) {
                        this.sale.saleLines.splice(index, 1);
                    }
                }
            };
        }

        removePaymentLine(paymentLine: Meevo.Model.SalePayment) {
            this.registerController.usageTrackingLog(Meevo.Model.VerbEnum.DeletePaymentClicked);
            if (!paymentLine) {
                return;
            }

            if (paymentLine.paymentRequest && paymentLine.paymentRequest.amount < 0 && paymentLine.paymentRequest.isAuthorization) {
                this.removeTicketPaymentLine(paymentLine);
                return;
            }

            const reversePayment = (paymentLine, paymentTypeDisplayName) => {
                const creditPaymentLine = <Model.SaleCreditCardPayment>paymentLine;

                creditPaymentLine.reverse = true;

                this.startReversePaymentRequest(paymentLine.amount, [creditPaymentLine.paymentRequestId], creditPaymentLine.paymentRequestId).then((succeeded) => {
                    if (!succeeded) {
                        return;
                    }

                    this.removeTicketPaymentLine(paymentLine);

                    this.displayPoleMessage(paymentTypeDisplayName, paymentLine.amount);

                    let oneCreditPayment = _.find(this.sale.paymentLines, (salePayment: Model.SalePayment) => {
                        if (salePayment.paymentCategory === Model.PaymentCategoryEnum.CreditDebit) {
                            var creditPaymentLine = <Model.SaleCreditCardPayment>salePayment;
                            return creditPaymentLine.paymentRequestId != null;
                        }

                        return false;
                    });

                    if (oneCreditPayment == null) {
                        this.sale.onHoldIds = {};
                    }
                });
            };

            const continueExecution = () => {
                let paymentTypeDisplayName = this.getPaymentLinePaymentTypeDisplayName(paymentLine);

                // transaction setup id is only set when it is an unfinalized hosted payment
                if (paymentLine.transactionSetupId) {
                    this.selectedSection.reset();
                    this.refreshPaymentRequest(paymentLine);
                }
                else if (this.creditCardProcessingEnabled && paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CreditDebit) {
                    // ??? should this be done against payment request's merchant account instead of current merchant account ???
                    if (!this.getMerchantAccountCanVoidTransactions()) {
                        this.modalService.confirm("MESSAGE_REVERSE_CREDIT_CARD_PAYMENT_PROMPT").then(() => {
                            reversePayment(paymentLine, paymentTypeDisplayName);
                        });
                    }
                    else {
                        let promptMsg = this.$translate.instant("MESSAGE_VOID_CREDIT_CARD_PAYMENT_PROMPT", {
                            creditCardTypeName: paymentLine.paymentTypeDisplayName,
                            transactionAmount: this.meevoCurrency(paymentLine.amount)
                        });

                        this.modalService.confirm(promptMsg, Components.Modal.ModalTranslationModes.DoNotTranslate).then(() => {
                            this.refreshPaymentRequest(paymentLine).then(() => {
                                this.displayPoleMessage(paymentTypeDisplayName, paymentLine.amount);
                            });
                        });
                    }
                }
                else if (paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.GiftCard && paymentLine["paymentRequestId"]) {
                    this.refreshPaymentRequest(paymentLine).then(() => {
                        this.displayPoleMessage(paymentTypeDisplayName, paymentLine.amount);
                    });
                }
                else {
                    this.removeTicketPaymentLine(paymentLine);
                }
            };

            if (this.paymentTypes && this.paymentCats) {
                continueExecution();
            } else {
                this.loadPaymentCategories().then(() => continueExecution());
            }
        }

        getPaymentLinePaymentTypeDisplayName(paymentLine) {
            let paymentType: any = _.findWhere(this.paymentTypes, { id: paymentLine.paymentTypeId });

            if (!paymentType) {
                paymentType = _.findWhere(this.paymentCats, { id: paymentLine.paymentCategory });
            }

            let paymentTypeDisplayName = this.$translate.instant("LABEL_POLE_VOID") + "-" + paymentType.displayName;

            return paymentTypeDisplayName;
        }

        removePendingTicketPaymentLine() {
            let paymentLine: Model.SaleCreditCardPayment = _.findWhere(this.sale.paymentLines, { isPending: true });
            if (paymentLine) {
                this.removeTicketPaymentLine(paymentLine);
            }
        }

        removeTicketPaymentLine(paymentLine: Model.SalePayment, sale?: Model.Sale) {
            sale = sale || this.sale;
            const paymentLineRemoved = (paymentTypeDisplayName) => {
                this.displayPoleMessage(paymentTypeDisplayName, paymentLine.amount);

                if (this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Payment) {
                    let selectedSection = this.selectedSection as RegisterPaymentSectionBase;
                    if (selectedSection && selectedSection.paymentLineRemoved) {
                        selectedSection.paymentLineRemoved(paymentLine);
                    }
                }
            }

            const continueExecution = () => {
                sale.paymentLines = _(sale.paymentLines).without(paymentLine);

                if (paymentLine.amount < 0) {
                    this.setChangeDueAsCash = false;
                }

                let paymentTypeDisplayName = this.getPaymentLinePaymentTypeDisplayName(paymentLine);

                if (paymentLine.paymentSubCategory === Model.PaymentSubCategoryEnum.DepositCharge ||
                    (paymentLine.paymentCategory === Model.PaymentCategoryEnum.GiftCard && paymentLine["isPromo"])) {
                    // Need to recalculate sale if removed payment line is a deposit charge or promo gift card
                    this.recalculateSale(false, null, false, sale).then(() => {
                        paymentLineRemoved(paymentTypeDisplayName);
                    });
                } else if (paymentLine.surcharge) {
                    this.recalculateSale();
                } else {
                    this.recalculateChangeDue(sale);
                    paymentLineRemoved(paymentTypeDisplayName);
                }
            };

            if (this.paymentTypes && this.paymentCats) {
                continueExecution();
            } else {
                this.loadPaymentCategories().then(() => continueExecution());
            }
        }

        private displayPoleMessage(displayLabel, displayValue, amount = null) {
            const line1 = [
                displayLabel != null && displayLabel.length > 0 ? displayLabel + ':' : '',
                displayValue != null ? this.formatAmountForPoleDisplay(displayValue) : '',
            ];

            const balanceDue = this.getBalanceDue(false);
            amount = amount || (balanceDue > 0 ? balanceDue : -Math.abs(this.getChangeDue()));

            const line2 = this.createSecondLineForChangeOrBalanceDue(amount);

            this.printService.queueMessagesToPoleDisplay({
                lines: [
                    { text: line1, alignment: Meevo.Components.Common.PoleDisplayAlignment.Spaced },
                    { text: line2, alignment: Meevo.Components.Common.PoleDisplayAlignment.Spaced }
                ]
            });
        }

        hasPaymentAlertMessage(status: Meevo.Model.CreditCardStatus): boolean {
            return status && status.paymentAlertMessage && status.paymentAlertMessage.length > 0;
        }

        appendPaymentAlertMessage(status: Meevo.Model.CreditCardStatus): string {
            if (!this.hasPaymentAlertMessage(status)) {
                return '';
            }

            return '. ' + this.$translate.instant(status.paymentAlertMessage);
        }

        getPaymentRequestStatus(paymentLine: Meevo.Model.SalePayment, isCareCredit: boolean = false) {
            let url = `api/paymentRequest/${paymentLine.paymentRequestId}/status`;

            if (isCareCredit) {
                url += '?isCareCredit=true';
            }

            return this.dataService.customMethodData(url, "GET", null);
        }

        refreshPaymentRequest(paymentLine: Meevo.Model.SalePayment, useBusyService: boolean = true, isHostedPageCancel = false) {
            let defer = this.$q.defer();

            // a very fast click on a hosted page payment screen's back button can result in getting here without a payment request id
            if (!paymentLine.paymentRequestId) {
                this.removeTicketPaymentLine(paymentLine);
                defer.resolve();
                return defer.promise;
            }

            if (useBusyService) {
                this.busyService.start();
            }

            paymentLine.isPending = true;

            const url = `api/${this.appSettings.API_ENDPOINTS.drawer}/${this.selectedDrawer.id}/paymentRequest/${paymentLine.paymentRequestId}`;

            const request = {
                sale: this.sale,
                paymentCategory: paymentLine.paymentCategory,
                paymentRequestId: paymentLine.paymentRequestId,
            };

            // for CareCredit, this is a refresh attempt
            // - transaction query -> no info found = cancel, else update payment request & clear transaction setup id
            // for other cards, this is a cancel attempt
            this.dataService.customMethodData(url, "DELETE", request)
                .then((response) => {
                    if (response.status === 409) { // conflict
                        this.modalService.alert(response.data.responseStatus.message);
                        return defer.reject();
                    }

                    let paymentRequest = response.data;

                    // if CareCredit payment request was updated then
                    // - approved -> update finalized payment line with details
                    // - failed -> remove unfinalized payment line
                    if (paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CareCredit &&
                        paymentRequest.paymentRequestStatus !== Meevo.Model.PaymentRequestStatusEnum.Pending &&
                        !paymentRequest.processorTransactionSetupId) {
                        paymentLine.transactionSetupId = null;

                        if (paymentRequest.paymentRequestStatus === Meevo.Model.PaymentRequestStatusEnum.Approved) {
                            this.updatePaymentLineWithPaymentRequest(paymentRequest, paymentLine);
                        } else {
                            this.removePaymentLine(paymentLine);
                        }

                        return defer.resolve();
                    }

                    // hosted page cancel successful or payment request is not pending
                    if (isHostedPageCancel) {
                        this.removeTicketPaymentLine(paymentLine);

                        return defer.resolve();
                    }

                    // payment alert void messages not shown currently, but left here for future use

                    if (paymentRequest.paymentRequestVoidStatus === Model.PaymentRequestStatusEnum.Failed) {
                        if (paymentRequest.paymentRequestVoidCreditCardProcessorStatus) {
                            let message = this.$translate.instant(paymentRequest.paymentRequestVoidCreditCardProcessorStatus.message);
                            //message += this.appendPaymentAlertMessage(paymentRequest.paymentRequestVoidCreditCardProcessorStatus);
                            this.modalService.alert(message, Components.Modal.ModalTranslationModes.DoNotTranslate);
                        }

                        return defer.reject();
                    }

                    if (!paymentRequest.saleId) {
                        this.printCreditCardReceipts([paymentRequest], true);
                    }

                    this.sale.onHoldIds = {};

                    if (paymentRequest.onHoldId) {
                        this.sale.onHoldIds[paymentRequest.onHoldId] = paymentRequest.holdType || Meevo.Model.HoldTypeEnum.Recovery;
                        this.updateSelfPaymentWithOnHoldId(paymentRequest.onHoldId);
                    }

                    this.removeTicketPaymentLine(paymentLine);

                    defer.resolve();
                })
                .catch((error) => {
                    console.error(error);

                    this.removeTicketPaymentLine(paymentLine);

                    defer.reject();
                })
                .finally(() => {
                    if (useBusyService) {
                        this.busyService.stop();
                    }
                    paymentLine.isPending = false;
                });

            return defer.promise;
        }

        isDirty(checkPaymentLines: boolean = false): boolean {
            return (
                (this.selectedClient && this.selectedClient.id != Guid.empty.toString()) ||
                this.selectedClientType === Meevo.Model.ClientTypeEnum.AnonymousFemale ||
                this.selectedClientType === Meevo.Model.ClientTypeEnum.AnonymousMale ||
                this.selectedClientType === Meevo.Model.ClientTypeEnum.AnonymousOther ||
                (
                    this.sale && (this.sale.saleLines.length > 0 || this.sale.tipLines.length > 0 ||
                        (checkPaymentLines && this.sale.paymentLines && this.sale.paymentLines.length > 0))
                )
            );
        }

        getTotalQuantity() {
            var num = 0;
            if (this.sale && this.sale.saleLines) {
                _(this.sale.saleLines).each(item => {
                    if (!item.hideInReceipt) {
                        num += Number(item.quantity);
                    }
                });
            }
            return num;
        }

        getQuantityByType() {
            let quantityByTypeHash = [];
            let quantityByTypeList = [];
            if (this.sale && this.sale.saleLines) {
                _(this.sale.saleLines).each(item => {
                    if (!item.hideInReceipt) {
                        var quantityByType = quantityByTypeHash[item.saleType.toString()];
                        if (!quantityByType) {
                            quantityByType = {
                                totalCount: 0,
                                totalPrice: 0,
                                saleType: item.saleType,
                                displayName: Meevo.Model.SalesTypeEnum[item.saleType]
                            };
                            quantityByTypeHash[item.saleType.toString()] = quantityByType;
                            quantityByTypeList[quantityByTypeList.length] = quantityByType;
                            if (item.saleType === Meevo.Model.SalesTypeEnum.GiftCard) {
                                quantityByType.displayName = "Gift Card";
                            }
                            if (quantityByType.totalCount > 1) {
                                quantityByType.displayName += "s"; // plural form
                            }
                        }
                        if (quantityByType.totalCount == 1) {
                            quantityByType.displayName += "s"; // plural form
                        }
                        quantityByType.totalCount += Number(item.quantity);
                        if (_.isNumber(item.finalItemPrice)) {
                            quantityByType.totalPrice += (Number(item.quantity) * item.finalItemPrice);
                        }
                    }
                });
            }
            return quantityByTypeList;
        }

        getTotal(): number {
            if (!this.sale) {
                return 0;
            }

            return this.sale.total;
        }

        getPaymentAmount(): number {
            if (!this.sale) {
                return 0;
            }

            const paymentAmount = this.isCreditMode
                ? -Math.abs(this.getChangeDue())
                : this.getBalanceDue(false);

            if (this.hasMeevoPaySplitFunding()) {
                const minimumDue = this.getExternalTipAmountDue();
                if (minimumDue > 0) {
                    return Math.max(paymentAmount, minimumDue);
                }
            }

            return paymentAmount;
        }

        getTaxAmount(): number {
            if (!this.sale) {
                return 0;
            }

            return this.sale.tax;
        }

        getBalanceDue(cashRounding: boolean = true): number {
            if (!this.sale) {
                return 0;
            }

            let totalPayments: number = cashRounding
                ? this.getTotalPaymentsWithRounding()
                : this.getTotalPayments();

            return Math.max(0, this.subtractNormalizedNumbers(this.sale.total, totalPayments));
        }

        updateTotal(sale: Model.Sale) {
            sale.total = this.normalizeDecimalPlaces(sale.subTotal 
                + (sale.finalTax - sale.finalTaxIncluded)
                + ((sale.tip + (sale.tipRefund || 0)) - (sale.totalPrepaidTipRedeemed || 0)) 
                + (sale.totalPrepaidTip || 0)
                + ((sale.tipConvenienceFee || 0) + (sale.tipConvenienceFeeRefund || 0))
                + (sale.surchargeTotal || 0));
        }

        showRefundReasons(): ng.IPromise<any> {
            return this.selectSection(RegisterSectionTypeEnum.RefundReason);
        }

        isRefundReasonValid(): boolean {
            return this.registerNotesService.isRefundReasonValid();
        }

        isRefundReasonVisible(): boolean {
            return this.hasRefundsInSale() && !this.isRefundReasonValid();
        }

        hasPrepaidTip(sale: Model.Sale): boolean {
            if (!sale || sale.tipLines.length === 0) {
                return false;
            }

            for (const tipLine of sale.tipLines) {
                if (tipLine.prepaidTipMinimum > 0) {
                    return true;
                }
            }

            return false;
        }

        finishSection(forcePaymentOptions: boolean = false): ng.IPromise<any> {
            this.$scope["paymentsAccordion"].collapseAll();

            if (!this.validateSaleItems()) {
                const defer = this.$q.defer();
                defer.resolve();
                return defer.promise;
            }

            if (this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Sale && !this.areAllLotsValid()) {
                this.scrollToFirstInvalidLot();
                const defer = this.$q.defer();
                defer.resolve();
                return defer.promise;
            }

            if (this.isRefundReasonVisible()) {
                this.forcePaymentOptions = forcePaymentOptions;
                return this.showRefundReasons();
            }

            const localValidate = (): ng.IPromise<any> => {
                if (this.hasPendingPayment()) {
                    return this.modalService.alert("MESSAGE_PENDING_CREDIT_CARD_PAYMENT");
                }

                if (!this.getExternalTipRefundDue() && this.getBalanceDue() > 0) {
                    return this.modalService.alert("MESSAGE_REGISTER_BALANCE_STILL_DUE");
                }

                return this.checkout();
            }

            const localCheckout = (): ng.IPromise<any> => {
                let paymentPlanPaymentLine = this.paymentPlanService.getExistingPaymentPlanPaymentLine(this.sale);
                if (paymentPlanPaymentLine && this.paymentPlan.hasChanged) {
                    return this.selectPaymentLine(paymentPlanPaymentLine);
                }
                if (this.sale.deviceTip > 0 && this.selectedSection.sectionType === RegisterSectionTypeEnum.CreditSingleCard) {
                    return this.showTips(RegisterModalTypeEnum.TipCreditCard).then(() => {
                        return localValidate();
                    });
                } else {
                    return localValidate();
                }
            };

            if (this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Sale || this.selectedSection.sectionType === RegisterSectionTypeEnum.Client || forcePaymentOptions) {
                this.sale.isItemSelectionComplete = true;

                this.setSaleNote(this.registerNotesService.saleNoteTextRefund, Model.SaleNoteTypeEnum.Refund);

                return this.dataService.add("drawer", this.sale, new Guid(this.selectedDrawer.id), "sale")
                    .then(() => {
                        return this.showDocsAndForms(this.sale.saleLines);
                    })
                    .then(() => {
                        return this.showCustomControls(this.sale.saleLines, false);
                    })
                    .then(() => {
                        // don't show rebook candidates modal in history mode
                        if (!this.registerTicketService.isPastTransactionMode) {
                            return this.showRebookCandidates(false, true);
                        }
                    })
                    .then(() => {
                        if (this.sale.isTippyKioskMode && this.hasPrepaidTip(this.sale)) {
                            return this.modalService.alert("MESSAGE_PREPAID_TIPS_MEEVOTIPS");
                        }
                    })
                    .then(() => {
                        if (this.getChangeDue() > 0) {
                            return this.getRefundItemCreditCardPayments();
                        }
                    })
                    .then(() => {
                        if (!this.hasExternalTipRefundDue() && !this.hasPaymentAuthorization(this.sale)) {
                            this.sale.externalTipTransactionId = undefined;
                            this.tippyService.updateTipConvenienceFee(this.sale, this, 0);
                            return this.tippyService.createTransaction(this);
                        }
                    })
                    .then(() => {
                        if (!this.hasExternalTipRefundDue() && !this.hasPaymentAuthorization(this.sale)) {
                            if (forcePaymentOptions || this.forcePaymentOptions || this.getBalanceDue() > 0 || this.hasExternalTipAmountDue()) {
                                if (this.selectedSection.sectionType === RegisterSectionTypeEnum.PaymentOptions) {
                                    this.forcePaymentOptions = false;
                                }
                                return this.showPaymentOptions();
                            }
                        }

                        return localCheckout();
                    })
                    .finally(() => {
                        this.sale.isItemSelectionComplete = false;
                    });

            }

            return localCheckout();
        }

        getRegisterClient(clientMatch: Meevo.Model.IRegisterClient, fn) {
            if (clientMatch) {
                return fn(this.allUniqueClients, (item: RegisterClient) => item.isMatch(clientMatch));
            }
            else {
                return null;
            }
        }

        private validateSaleItems() {
            var allHasAssignedEmployee = true;
            var item: Meevo.Model.SaleLine;

            for (var i = 0; i < this.sale.saleLines.length; i++) {
                item = this.sale.saleLines[i];
                if (this.isSaleLineAService(item) && !item.employeeId) {
                    allHasAssignedEmployee = false;
                    break;
                }
            }

            if (!allHasAssignedEmployee) {
                // first select client
                let rClient = new RegisterClient({ clientType: item.clientType, client: item.client, appointmentId: item.appointmentId });
                this.selectClient(rClient);

                let rClientIndex = this.getRegisterClient(rClient, _.findIndex);
                let registerClient = $(".register-items" + rClientIndex);

                // look for the index of the item within the client's list of saleLines
                var clientIndex = 0;
                for (var index = 0; index < this.sale.saleLines.length; index++) {
                    let saleLine = this.sale.saleLines[index];
                    if (rClient.isMatch(saleLine)) {
                        if (saleLine === item) {
                            item.isExpanded = true;
                            break;
                        }
                        clientIndex++;
                    }
                }

                // show prompt and then navigate to saleLine at index i (item);
                this.modalService.alert("Employee is missing for " + item.item.displayName + " service.").then(() => {
                    //get input for employee
                    if (registerClient.length > 0) {
                        registerClient.css("overflow", "visible");
                        let clientSaleLine = registerClient.find(".vAccordion--default .vPane" + clientIndex);
                        if (clientSaleLine.length > 0) {
                            clientSaleLine.css("overflow", "visible");
                            let clientSaleLineEmployeeEditor = clientSaleLine.find(".vPaneContent" + clientIndex + " input[name='serviceEmployee']");
                            if (clientSaleLineEmployeeEditor.length > 0) {
                                clientSaleLineEmployeeEditor.focus();
                            }
                        }
                    }
                });
            }

            return allHasAssignedEmployee;
        }

        private updatePoleDisplay(useBalance: boolean = true, amountOverride: number = null) {
            const amount = amountOverride || (
                useBalance
                    ? this.getBalanceDue(false)
                    : -Math.abs(this.getChangeDue())
            );

            const tax = this.normalizeDecimalPlaces(this.sale.finalTax - this.sale.finalTaxIncluded);

            //          bug:  hide tax when "tax included in price"?
            //          if (this.sale.finalTaxIncluded === 0) {
            this.displayPoleMessage(this.$translate.instant("LABEL_TAX"), tax, amount);
            //          } else {
            // don't show tax when tax is included in price
            //              this.displayPoleMessage(null, null, amount);
            //          }
        }

        updatePoleDisplayCashRounding(sectionType: RegisterSectionTypeEnum, useBalance: boolean = true) {
            if (this.getCashRounding() != 0) {
                const isCashPayment = sectionType === RegisterSectionTypeEnum.Cash;

                if (isCashPayment) {
                    const amount = useBalance
                        ? this.getBalanceDue(isCashPayment)
                        : -Math.abs(this.getCashChangeDue());

                    this.updatePoleDisplay(useBalance, amount);
                }
            }
        }

        private showChangeOptions(reset: boolean = undefined) {
            this.updatePoleDisplay(false);

            return this.selectSection(RegisterSectionTypeEnum.ChangeOptions, reset);
        }

        private showPaymentOptions(reset: boolean = undefined) {
            return this.loadPaymentCategories().then(() => {
                this.updatePoleDisplay();

                return this.selectSection(RegisterSectionTypeEnum.PaymentOptions, reset);
            });
        }

        private getDefaultMerchantAccount(): ng.IPromise<Model.MerchantAccount> {
            const request = {
                criteria: {
                    getDefaultAccountOnly: true
                }
            };

            const endPointUrl = `${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.merchantAccount}/List`;

            return this.dataService.customMethodData(endPointUrl, "POST", request).then((response: any) => {
                if (response.data && response.data.length > 0) {
                    const merchantAccount = response.data[0] as Model.MerchantAccount;

                    return this.dataService.getItem(this.appSettings.API_ENDPOINTS.merchantAccount, new Guid(merchantAccount.id)).then((merchantAccount: Model.MerchantAccount) => {
                        this.defaultMerchantAccount = merchantAccount;
                        return merchantAccount;
                    });
                }
            });
        }

        getMerchantAccountByProvider(providerId: number): ng.IPromise<Model.MerchantAccount> {
            const request = {
                criteria: {
                    merchantAccountProvider: providerId
                }
            };

            const endPointUrl = `${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.merchantAccount}/List`;

            return this.dataService.customMethodData(endPointUrl, "POST", request).then((response: any) => {
                if (response.data && response.data.length > 0) {
                    const merchantAccount = response.data[0] as Model.MerchantAccount;
                    return this.dataService.getItem(this.appSettings.API_ENDPOINTS.merchantAccount, new Guid(merchantAccount.id));
                }
            });
        }

        isPaymentTypeVisible(paymentType) {
            if (paymentType.isHidden) {
                return false;
            }

            if (this.registerTicketService.isPastTransactionMode) {
                switch (paymentType.sectionType) {
                    case RegisterSectionTypeEnum.ClientPoints:
                    case RegisterSectionTypeEnum.GiftCardPayment:
                    case RegisterSectionTypeEnum.ClientAccountPayment:
                    case RegisterSectionTypeEnum.Self:
                        return false;
                }
            }

            switch (paymentType.sectionType) {
                case RegisterSectionTypeEnum.ClientPoints:
                    if (!this.hasRealClient()) {
                        return false;
                    }
                    break;
            }

            if (this.hasMeevoPaySplitFunding()) {
                const minimumDue = this.getExternalTipAmountDue();
                if (minimumDue > 0) {
                    switch (paymentType.sectionType) {
                        case RegisterSectionTypeEnum.CreditSingleCard:
                        case RegisterSectionTypeEnum.CardOnFile:
                            return true;
                        case RegisterSectionTypeEnum.CreditMultiCard:
                            const balanceDue = -this.getChangeDue();
                            return balanceDue > minimumDue;
                        default:
                            return false;
                    }
                }
            }

            return true;
        }

        private getPaymentTypeDisplayName(paymentType) {
            switch (paymentType.paymentCategory) {
                case Model.PaymentCategoryEnum.PointsRewards:
                    return this.$translate.instant("LABEL_POINTS");

                case Model.PaymentCategoryEnum.CareCredit:
                    return this.$translate.instant("LABEL_CARECREDIT");

                case Model.PaymentCategoryEnum.ClientAccount:
                    if (paymentType.paymentSubCategory === Model.PaymentSubCategoryEnum.DepositCharge) {
                        return paymentType.displayName;
                    }
                    break;
            }

            // this is to handle international variants of names (Cheque vs Check)
            const key = 'LABEL_PAYMENT_TYPE_' + paymentType.paymentCategory;
            const lookup = this.$translate.instant(key);
            if (lookup !== key) {
                return lookup;
            }

            if (paymentType.paymentCategory === Model.PaymentCategoryEnum.Other) {
                return paymentType.displayName;
            }

            return paymentType.paymentCategoryDisplayName || paymentType.displayName;
        }

        private loadPaymentTypes(): ng.IPromise<Model.PaymentTypeListItem[]> {
            let deferred = this.$q.defer<Model.PaymentTypeListItem[]>();

            if (this.paymentTypes) {
                deferred.resolve(this.paymentTypes);
                return deferred.promise;
            }

            let request = {
                pageNumber: 0,
                itemsPerPage: 1000,
                sortDirection: Model.SortDirection.Ascending,
                criteria: {
                    includeNonMonetary: undefined,
                    includeCreditTypesIfCcProcessingIsEnabled: true
                }
            }

            this.paymentPlansEnabled = false;
            let promises : angular.IPromise<any>[] = [
                this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.paymentType, request).then((response: Model.PaymentTypeListItem[]) => {
                    this.paymentTypes = response;
                }),
                this.dataService.customMethodData("/api/paymentplan/template", "get", {}, {
                    numberOfPayments: 1,
                    amount: this.getSmallestAmountForCurrency(),
                    ignoreException: true
                }).then(() => {
                    this.paymentPlansEnabled = true;
                })];

            this.$q.all(promises).then(() => {
                deferred.resolve(this.paymentTypes);
            });
            return deferred.promise;
        }

        loadPaymentCategories(): ng.IPromise<RegisterPaymentCat[]> {
            let deferred = this.$q.defer<RegisterPaymentCat[]>();

            if (this.paymentCats) {
                if (this.giftCardPaymentsSection) {
                    this.giftCardPaymentsSection.reset();
                }

                if (this.clientPointsPaymentsSection) {
                    this.clientPointsPaymentsSection.reset();
                }

                if (this.cardOnFilePaymentsSection) {
                    this.cardOnFilePaymentsSection.checkCreditCardOnFile(true);
                }

                this.registerCareCreditService.updateCareCreditPaymentType(this.paymentCats, this.sale);

                deferred.resolve(this.paymentCats);
                return deferred.promise;
            }

            this.loadPaymentTypes().then((response: Model.PaymentTypeListItem[]) => {
                let paymentCatsTemp: RegisterPaymentCat[] = [];

                var paymentTypesByCategory = _(response).groupBy(type => type.paymentCategory);

                for (const paymentCategory in paymentTypesByCategory) {
                    const paymentTypes = paymentTypesByCategory[paymentCategory] as Array<Model.PaymentTypeListItem>;
                    const paymentType = paymentTypes[0];

                    if (!this.registerTicketService.isPastTransactionPaymentValid(paymentType)) {
                        continue;
                    }

                    let registerPaymentCat: RegisterPaymentCat = {
                        id: paymentType.paymentCategory,
                        displayName: this.getPaymentTypeDisplayName(paymentType),
                        securityKey: 'REGISTER:REGISTER:ACTION:PAYMENTCAT' + paymentType.paymentCategory,
                        paymentCategory: paymentType.paymentCategory,
                        isHidden: false,
                        isDisabled: false,
                        isRefundable: _(paymentTypes).any(type => type.isRefundable)
                    }

                    registerPaymentCat.originalDisplayName = registerPaymentCat.displayName;

                    switch (paymentType.paymentCategory) {
                        case Model.PaymentCategoryEnum.Cash:
                            this.sections.push(new CashPaymentsSection(this));
                            registerPaymentCat.sectionType = RegisterSectionTypeEnum.Cash;
                            registerPaymentCat.sequence = 20;
                            registerPaymentCat.iconName = 'pmtopt_cash.svg';
                            break;
                        case Model.PaymentCategoryEnum.PaymentPlan:
                            if (!this.paymentPlansEnabled) {
                                continue;
                            }
                            registerPaymentCat.sectionType = RegisterSectionTypeEnum.PaymentPlan;
                            registerPaymentCat.sequence = 20;
                            registerPaymentCat.iconName = 'pmtopt_cash.svg';
                            break;
                        case Model.PaymentCategoryEnum.CreditDebit:
                            this.sections.push(new CreditPaymentsSection(this, RegisterSectionTypeEnum.CreditMultiCard));
                            if (this.creditCardProcessingEnabled) {
                                registerPaymentCat.displayName = this.getPaymentTypeDisplayName(paymentType) + ' ' + this.$translate.instant("LABEL_PAYMENT_TYPE_MULTI_CARD");
                            }
                            registerPaymentCat.sectionType = RegisterSectionTypeEnum.CreditMultiCard;
                            registerPaymentCat.sequence = 11;
                            registerPaymentCat.iconName = 'pmtopt_creditdebit.svg';
                            break;

                        case Model.PaymentCategoryEnum.Other:
                            this.sections.push(new OtherPaymentsSection(this));
                            registerPaymentCat.displayName = paymentType.paymentCategoryDisplayName;
                            registerPaymentCat.sectionType = RegisterSectionTypeEnum.Other;
                            registerPaymentCat.sequence = 70;
                            registerPaymentCat.iconName = 'pmtopt_other.svg';
                            break;

                        case Model.PaymentCategoryEnum.Check:
                            this.sections.push(new CheckPaymentsSection(this));
                            registerPaymentCat.sectionType = RegisterSectionTypeEnum.Check;
                            registerPaymentCat.sequence = 60;
                            registerPaymentCat.iconName = 'pmtopt_check.svg';
                            break;

                        case Model.PaymentCategoryEnum.GiftCard:
                            this.giftCardPaymentsSection = new GiftCardPaymentsSection(this);
                            this.sections.push(this.giftCardPaymentsSection);
                            registerPaymentCat.sectionType = RegisterSectionTypeEnum.GiftCardPayment;
                            registerPaymentCat.sequence = 40;
                            registerPaymentCat.iconName = 'pmtopt_giftcard.svg';
                            this.giftCardPaymentsSection.reset();
                            break;

                        case Model.PaymentCategoryEnum.PointsRewards:
                            this.clientPointsPaymentsSection = new ClientPointsPaymentsSection(this);
                            this.sections.push(this.clientPointsPaymentsSection);
                            registerPaymentCat.sectionType = RegisterSectionTypeEnum.ClientPoints;
                            registerPaymentCat.sequence = 30;
                            registerPaymentCat.iconName = 'pmtopt_points.svg';
                            this.clientPointsPaymentsSection.reset();
                            break;

                        case Model.PaymentCategoryEnum.ClientAccount:
                            if (paymentType.paymentSubCategory === Meevo.Model.PaymentSubCategoryEnum.AccountCharge) {
                                this.sections.push(new ClientAccountPaymentsSection(this));
                                registerPaymentCat.sectionType = RegisterSectionTypeEnum.ClientAccountPayment;
                                registerPaymentCat.sequence = 50;
                                registerPaymentCat.iconName = 'pmtopt_accountcharge.svg';
                            }
                            break;

                        case Model.PaymentCategoryEnum.CareCredit:
                            this.registerCareCreditService.buildCareCreditOption(this, registerPaymentCat);
                            break;

                    }

                    if (registerPaymentCat.sectionType) {
                        paymentCatsTemp.push(registerPaymentCat);

                        if (paymentType.paymentCategory === Model.PaymentCategoryEnum.CreditDebit && this.creditCardProcessingEnabled) {
                            if (this.getMerchantAccountCanCreateTokens()) {
                                paymentCatsTemp.push(this.buildCardOnFileOption());
                            }

                            paymentCatsTemp.push(this.buildCreditCardSingleOption(paymentType));
                        }
                    }
                }

                if (this.creditCardProcessingEnabled &&
                    this.defaultMerchantAccount &&
                    this.defaultMerchantAccount.hasHostedPageSupport &&
                    (this.defaultMerchantAccount.canCreateTokens || this.defaultMerchantAccount.canCreateTemporaryTokens)) {
                    paymentCatsTemp.push(this.buildSelfPaymentOption());
                }

                this.paymentCats = _(paymentCatsTemp).sortBy((item) => item.sequence);

                deferred.resolve(this.paymentCats);
            });

            return deferred.promise;
        }

        private buildCardOnFileOption() {
            this.cardOnFilePaymentsSection = new CreditPaymentsSection(this, RegisterSectionTypeEnum.CardOnFile);
            this.sections.push(this.cardOnFilePaymentsSection);

            const option: RegisterPaymentCat = {
                sectionType: RegisterSectionTypeEnum.CardOnFile,
                id: Model.PaymentCategoryEnum.CreditDebit,
                securityKey: 'REGISTER:REGISTER:ACTION:PAYMENTCATCARDONFILE',
                displayName: this.$translate.instant("LABEL_CARD_ON_FILE"),
                paymentCategory: Model.PaymentCategoryEnum.CreditDebit,
                sequence: 12,
                iconName: 'pmtopt_cardonfile.svg',
            };

            option.originalDisplayName = option.displayName;
            this.cardOnFilePaymentsSection.checkCreditCardOnFile(true);

            return option;
        }

        private buildCreditCardSingleOption(paymentType) {
            this.sections.push(new CreditPaymentsSection(this, RegisterSectionTypeEnum.CreditSingleCard));

            const option: RegisterPaymentCat = {
                sectionType: RegisterSectionTypeEnum.CreditSingleCard,
                id: Model.PaymentCategoryEnum.CreditDebit,
                securityKey: 'REGISTER:REGISTER:ACTION:PAYMENTCATSINGLECARD',
                displayName: this.getPaymentTypeDisplayName(paymentType),
                paymentCategory: Model.PaymentCategoryEnum.CreditDebit,
                sequence: 10,
                iconName: 'pmtopt_singlecard.svg',
            };

            option.originalDisplayName = option.displayName;
            option.displayName = option.displayName + ' ' + this.$translate.instant("LABEL_PAYMENT_TYPE_SINGLE_CARD");

            return option;
        }

        private buildSelfPaymentOption() {
            this.sections.push(new SelfPaymentsSection(this));

            const option: RegisterPaymentCat = {
                id: Model.PaymentCategoryEnum.Other,
                displayName: this.$translate.instant("LABEL_SELF_PAY"),
                securityKey: 'REGISTER:REGISTER:ACTION:PAYMENTCATSELFPAY',
                paymentCategory: Model.PaymentCategoryEnum.Other,
                sectionType: RegisterSectionTypeEnum.Self,
                sequence: 80,
                iconName: 'pmtopt_selfpay.svg',
                originalDisplayName: this.$translate.instant("LABEL_SELF_PAY")
            }

            return option;
        }

        showRebookCandidates(enforceAction: boolean = false, isFinal: boolean = false): angular.IPromise<any> {
            let defer = this.$q.defer();
            this.securityService.checkSecurityKey(
                this.meevoSecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_ACTION_REBOOKAPPOINTMENT
            ).then(response => {
                if (response === Meevo.Model.SecurityAccessEnum.Grant) {
                    // Usage - 1. AfterSelectingPayNowInRegister; 2. UponCheckOut (enforceAction = true). In both cases need to have list of items.
                    // In #2 get all, in #1 only if there are any new pairs are added
                    if (enforceAction || (this.showRebookPrompt === Meevo.Model.ShowPromptForRebookEnum.AfterSelectingPayNowInRegister && isFinal)) {
                        this.rebookService.showRebookCandidates(this.getRebookItems(true), true).then(() => {
                            defer.resolve();
                        });
                    } else {
                        // Upon CheckOut, only rebook Candidates that are In Need of Rebook should trigger auto Rebook Modal
                        let rebookItemsForCheckOut = this.getRebookItems(false, true);
                        if (this.showRebookPrompt === Meevo.Model.ShowPromptForRebookEnum.UponCheckOut && rebookItemsForCheckOut.length > 0) {
                            this.rebookService.getRebookCandidates(rebookItemsForCheckOut).then((rebookCandidates) => {
                                if (rebookCandidates.length > 0 && this.isAnyCandidateInNeedOfRebook(rebookCandidates)) {
                                    this.rebookService.showRebookCandidates(this.getRebookItems(true), true, rebookCandidates).then(() => {
                                        defer.resolve();
                                    });
                                }
                                else {
                                    defer.resolve();
                                }
                            });
                        }
                        else {
                            defer.resolve();
                        }
                    }
                } else {
                    defer.resolve();
                }
            });
            return defer.promise;
        }
        isAnyCandidateInNeedOfRebook(rebookCandidates: any[]): boolean {
            let isAny = _.find(rebookCandidates, function (candidate) { return !candidate.nextAppointServiceDateTime; });
            return !angular.isUndefined(isAny);
        }
        isDisplayPromptForRebookButton() {
            return (this.showRebookPrompt === Meevo.Model.ShowPromptForRebookEnum.UponCheckOut && this.sale && this.sale.hasRebookCandidates);
        }
        setHasRebookCandidates(sale: Model.Sale = null) {
            this.rebookService.getRebookCandidates(this.getRebookItems(null, null, sale)).then(candidates => {
                this.sale.hasRebookCandidates = (candidates.length > 0);
            });
        }
        getRebookItems(trackDisplayedSaleLines: boolean = false, checkOnlyNewCandidates: boolean = false, sale: Model.Sale = null) {
            let rebookItems: RebookItem[] = [];
            sale = sale || this.sale;

            sale.saleLines.forEach((saleLine: Model.SaleLine) => {
                if (saleLine.saleType === Model.SalesTypeEnum.Service &&
                    saleLine.clientType === Model.ClientTypeEnum.Client) {
                    let appointmentServiceItem = <ServiceSaleLineItem>saleLine.item;
                    //We only want to display Client once even it multiple appoint services are added (if forced), do not dosplay automatically ones coming from Hold
                    if (!angular.isUndefined(appointmentServiceItem.appointmentServiceId) &&
                        (checkOnlyNewCandidates ? this.isClientRebookNotAlreadyDisplayed(saleLine) : true)) {
                        rebookItems.push({
                            serviceDate: appointmentServiceItem.appointmentServiceDate,
                            appointmentServiceId: appointmentServiceItem.appointmentServiceId,
                            employee: saleLine.employee,
                            client: saleLine.client,
                            service: {
                                id: saleLine.item.id,
                                displayName: appointmentServiceItem.displayName,
                                shortcut: appointmentServiceItem.shortcut
                            }
                        });
                        if (trackDisplayedSaleLines) {
                            saleLine.hasPromptedForRebook = true;
                        }
                    }
                }
            });
            return rebookItems;
        }
        isClientRebookNotAlreadyDisplayed(saleLine): boolean {
            return (!saleLine.hasPromptedForRebook && !saleLine.isComingFromHold);
        }

        private prepareSaleForCheckOut() {
            this.sale.saleStage = Model.SaleStageEnum.Finalize;
        }

        public shouldShowChangeOptions() {
            return this.hasCreditWithRefunds() && !this.setChangeDueAsCash;
        }

        private getCurrentTip() {
            let currentTip = 0;

            this.sale.tipLines.forEach(tipLine => {
                currentTip += tipLine.amount;
            });

            return this.normalizeDecimalPlaces(currentTip);
        }

        private checkoutContinuation() {
            if (this.shouldShowChangeOptions()) {
                return this.showChangeOptions();
            }

            if (this.getCashRounding() != 0) {
                const changeDue = -Math.abs(this.getCashChangeDue());

                this.displayPoleMessage(this.$translate.instant("LABEL_CHANGE_DUE_ROUNDING"), this.getCashRounding(), changeDue);
            } else {
                this.updatePoleDisplay(false);
            }

            // don't pop drawer in history mode
            if (!this.registerTicketService.isPastTransactionMode) {
                this.registerPopDrawer();
            }

            return this.showModal(RegisterModalTypeEnum.ChangeDue);
        }

        private prepaidTipsNeedToBeApplied(): boolean {
            const pendingTip = this.getTotalTipFromPrepaid();
            return pendingTip > 0 && this.getCurrentTip() < pendingTip;
        }

        private checkout(): ng.IPromise<any> {
            this.sale.saleStage = Model.SaleStageEnum.PreFinalize;

            return this.recalculateSale().then(() => {
                if (this.prepaidTipsNeedToBeApplied()) {
                    return this.showModal(RegisterModalTypeEnum.Tip).then(() => {
                        this.checkoutContinuation();
                    });
                } else {
                    this.checkoutContinuation();
                }
            });
        }

        popDrawer(): ng.IPromise<any> {
            // ignore pop drawer errors
            let defer = this.$q.defer();

            this.isDrawerPopped = true;
            this.$timeout(() => {
                this.isDrawerPopped = false;
            }, 700);

            this.printService.openDrawer()
                .finally(() => {
                    defer.resolve();
                });
            /*
            .catch((error) =>
            {
                if (error === 'timeout')
                {
                    this.modalService.alert("MESSAGE_COULD_NOT_OPEN_DRAWER").then(() =>
                    {
                        defer.resolve();
                    });
                }
            });
            */
            return defer.promise;
        }

        saleInProgress(): boolean {
            return this.completeSaleInProgress || (this.sale && this.sale.recalculateSaleInProgress);
        }

        registerPopDrawer() {
            let isChangeDue = this.getCashChangeDue() > 0;
            let isCashPayment = _(this.sale.paymentLines).any(paymentLine => paymentLine.paymentCategory === Model.PaymentCategoryEnum.Cash);

            if (isChangeDue || isCashPayment) {
                return this.popDrawer();
            }
        }

        completeSaleInProgress = false;

        checkoutHandleReceipt(): ng.IPromise<any> {
            if (!this.registerTicketService.isPastTransactionMode) {
                return this._checkoutHandleReceipt();
            }

            return this.modalService.confirm("MESSAGE_INSERT_TRANSACTION_WARNING")
                .then(() => {
                    return this._checkoutHandleReceipt();
                })
                .catch(() => {
                    return this.showModal(RegisterModalTypeEnum.ChangeDue);
                });
        }

        private _checkoutHandleReceipt() {
            this.completeSaleInProgress = true;

            const localContinue = () => {
                return this.handleReceipt().finally(() => {
                    if (this.visitNoteServicePrompt) {
                        return this.displayVisitNoteServicePrompt();
                    }
                });
            }

            const showTippyMessage = this.tippyService.hasExternalTipRefund(this.sale);
            const tippyRefundDeferred = this.$q.defer();
            
            return this.completeSale(tippyRefundDeferred)
                .then(() => {
                    if (this.selectedDrawer.receiptTypeEnum === Model.RegisterReceiptTypeEnum.PromptReceipt ||
                        (this.selectedDrawer.receiptTypeEnum === Model.RegisterReceiptTypeEnum.EmailReceipt && !this.isEmailEnabled)) {
                        return this.showModal(RegisterModalTypeEnum.Receipt).then(() => {
                            return localContinue();
                        });
                    } else {
                        this.receiptPreference = this.selectedDrawer.receiptTypeEnum;
                        return localContinue();
                    }
                })
                .then(() => {
                    // this should only run on successful sale
                    this.isCreditMode = false;
                    this.checkMembershipOrigination();
                    this.registerNotesService.resetAggregatedNotes();
                    this.registerNotesService.resetVisitNotes();
                    this.clientsForReferralExclude = [];
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.RING_UP_TRANSACTIONFOR_CLIENT);
                })
                .then(() => {
                    return tippyRefundDeferred.promise.then((isFundedAtSettlementTime: boolean) => {
                        return (!isFundedAtSettlementTime ?
                            this.modalService.alert('MESSAGE_TIPPY_REFUND_REMINDER') : this.$q.resolve(true));
                    });
                })
                .finally(() => {
                    // this should run for any sale
                    this.printService.showStandbyMessage();
                    this.completeSaleInProgress = false;
                    this.exitRegisterPastTransactionMode();
                });
        }

        private sendToPaymentPlanManager() : void {
            if (_(this.sale.saleLines).any(saleLine => {
                return saleLine.saleType === Model.SalesTypeEnum.PaymentPlanPayment &&
                    !saleLine.isRefund
            }))
            {
                this.registerController.interopService.pushToAllChild(Meevo.Components.Common.Messages.PAYMENT_PLAN_PAYMENT_FINALIZED, {});

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: this.appSettings.ROUTE_NAMES.paymentPlans
                });
            }
        }

        private displayVisitNoteServicePrompt(): ng.IPromise<any> {
            return this.registerNotesService.displayVisitNoteServicePrompt();
        }

        private getGiftReceiptModal(forceShow = false): ng.IPromise<any> {
            if (this.isIncludeGiftReceipt || forceShow) {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/register/modals/giftReceiptModal.template.html",
                    controller: "meevo.plugins.register.GiftReceiptModal",
                    controllerAs: "vm",
                    bindToController: true,
                    multiple: true,
                    locals: {
                        transactionId: this.transactionId
                    }
                }

                return this.modalService.showCustom(options);
            }
        }

        public handleReceipt(): ng.IPromise<any> {
            const finish = (excludeSaleLineIds: Number[] = null) => {
                let defer = this.$q.defer();
                this.sale.hasPurchasedItems = false;
                if (this.receiptPreference === Model.RegisterReceiptTypeEnum.PrintReceipt) {
                    defer.resolve(this.communicateWithPrinter(excludeSaleLineIds));
                }
                else if (this.receiptPreference === Model.RegisterReceiptTypeEnum.EmailReceipt && this.isEmailEnabled) {
                    defer.resolve(this.email(Model.CommunicationTypeEnum.SaleCreated, this.isIncludeGiftReceipt, excludeSaleLineIds));
                }
                else if (this.receiptPreference === Model.RegisterReceiptTypeEnum.PrintEmailReceipt) {
                    defer.resolve(this.$q.all([
                        this.communicateWithPrinter(excludeSaleLineIds),
                        this.email(Model.CommunicationTypeEnum.SaleCreated, this.isIncludeGiftReceipt, excludeSaleLineIds)
                    ]));
                }
                else { // Model.RegisterReceiptTypeEnum.NoReceipt
                    defer.resolve();
                }
                return defer.promise;
            }

            if (this.isIncludeGiftReceipt && this.receiptPreference !== Model.RegisterReceiptTypeEnum.NoReceipt) {
                return this.getGiftReceiptModal().then((excludeSaleLineIds) => {
                    this.isIncludeGiftReceipt = !!excludeSaleLineIds;
                    return finish(excludeSaleLineIds);
                });
            } else {
                return finish();
            }
        }

        // Sends email notifications based on types i.e. Sale Created ( receipt ) , Gift Receipt created ( gift receipt )
        ReceiptNotification(communicationType: Meevo.Model.CommunicationTypeEnum, selectedEmail: string = "", showCopy: boolean = false, excludeSaleLineIds?: Number[]) {
            var saleDate = moment(this.transactionDateTime).format("YYYY-MM-DD").toString();
            var communicationMethod = Meevo.Model.CommunicationMethodEnum.Email;
            if (this.saleId) {
                var saleid = parseInt(this.saleId);

                return this.$http({
                    url: `/${this.appSettings.API_ROOT}/Sale/${saleid}/Notification`,
                    method: "POST",
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                    data: {
                        "id": saleid,
                        "emailId": selectedEmail,
                        "saleId": saleid,
                        "saleDate": saleDate,
                        "CommunicationType": communicationType,
                        "communicationMethod": communicationMethod,
                        "clientId": null,
                        "showCopy": showCopy,
                        "locale": this.appSettings.APP_COUNTRYID,
                        "timeFormat": this.appSettings.APP_TIME_FORMAT,
                        "excludeSaleLineIds": excludeSaleLineIds
                    }
                }).then(response => { });
            }
        }

        email(communicationType: Meevo.Model.CommunicationTypeEnum, isEmailGiftReceipt = false, excludedSaleLineIds: Number[]) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/client/sectionViews/selectEmail.modal.html',
                controller: 'meevo.plugins.client.SelectEmailController',
                controllerAs: "vm",
                bindToController: true,
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {
                    email: this.firstClientEmailAddress,
                    validateRegex: true
                }
            }
            return this.modalService.showCustom(options).then(selectedEmail => {
                this.ReceiptNotification(communicationType, selectedEmail, false);
                if (isEmailGiftReceipt) {
                    this.ReceiptNotification(Model.CommunicationTypeEnum.GiftReceiptCreated, selectedEmail, false, excludedSaleLineIds);
                }
                if (!this.firstClientEmailAddress && !this.multipleClients && this.firstClientId) {
                    this.updateClientEmailAddress(selectedEmail);
                }
            });
        }

        private updateClientEmailAddress(emailAddress: string) {
            let clientEmailPost: any = {
                id: this.firstClientId,
                emailAddress: emailAddress,
                forceUpdate: false
            }
            this.dataService.customMethodData(`/api/client/${this.firstClientId}/Email`, "post", clientEmailPost);
        }

        private saveCustomControls(sale: Model.Sale): angular.IPromise<any> {
            let defer = this.$q.defer();
            let promises = [];

            _(sale.saleLines).forEach((saleLine) => {
                if (this.isSaleLineAService(saleLine)) {
                    let serviceSaleLineItem = <ServiceSaleLineItem>saleLine.item;
                    if (serviceSaleLineItem.customControlsAnswers && serviceSaleLineItem.customControlsAnswers.length > 0) {
                        let controlAnswers = serviceSaleLineItem.customControlsAnswers;

                        controlAnswers.forEach((answer) => {
                            answer.entity_Id = saleLine.computedGuid;
                            answer.auditEntityId = serviceSaleLineItem.appointmentId;
                            answer.auditSubEntityId = serviceSaleLineItem.appointmentServiceId;
                            answer.appAreaEnum = Model.AppAreaEnum.Checkout;
                        });
                        let data = {
                            answers: controlAnswers
                        };
                        promises.push(this.dataService.add(`customData/Answer`, data));
                    }
                }
            });

            this.$q.all(promises).then(() => {
                defer.resolve();
            });

            return defer.promise;
        }

        completeSale(tippyRefundDeferred: ng.IDeferred<boolean>) {
            let defer = this.$q.defer();

            const drawerSessionPromise = this.registerTicketService.isPastTransactionMode
                ? this.getPastTransactionDrawerSession()
                : this.getLatestDrawerSession(this.selectedDrawer.id)

            drawerSessionPromise
                .then((data: any) => {
                    this.selectedDrawer.drawerSession = data;
                    this.selectedDrawer.drawerState = this.selectedDrawer.drawerSession.drawerState;

                    if (!this.isSelectedDrawerOpen()) {
                        return this.modalService.alert("MESSAGE_DRAWER_CLOSED").then(() => {
                            this.closeModal();
                            this.selectSection(RegisterSectionTypeEnum.Drawer);
                            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.DRAWER_STATE_CHANGED, { name: "drawerManager" }, { selectedDrawerId: this.selectedDrawer.id });
                            defer.reject();
                            return;
                        });
                    }

                    return this.paymentPlanService.validatePaymentPlanPayment(this).then(() => {
                        this.prepareSaleForCheckOut();
                        this.busyService.start();
                        return this.dataService.add("drawer", this.sale, new Guid(this.selectedDrawer.id), "sale")
                             .then((response: Model.Sale) => {
                                this.busyService.stop();
                                if (response.isClientAccountUsageInvalid) {
                                    return this.showClientAccountInvalidUsageModal();
                                }
                                if (this.visitNoteServicePrompt) {
                                    response.saleLines
                                        .filter(saleLine => saleLine.saleType === Model.SalesTypeEnum.Service && !!saleLine.clientId && !saleLine.isRefund)
                                        .forEach(saleLine => {
                                            let saleLineItem = saleLine.item as Model.ServiceSaleLineItem;
                                            if (saleLineItem.clientVisitNoteTypeId) {
                                                this.registerNotesService.addVisitNoteModel({
                                                    clientId: saleLine.clientId,
                                                    client: saleLine.client,
                                                    employee: saleLine.employee,
                                                    visitNoteTypeId: saleLineItem.clientVisitNoteTypeId,
                                                    serviceDisplayName: saleLineItem.displayName,
                                                    productUsage: angular.copy(saleLine.item.productUsage),
                                                });
                                            }
                                        });
                                }
                                return this.saveCustomControls(response).finally(async () => {
                                    let apptIds = _.unique(_.pluck(this.sale.saleLines, "appointmentId"));
                                    apptIds.forEach((item) => {
                                        if (item) {
                                            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLIENT_FIND_APPT_CHECKED_OUT, item, true);
                                        }
                                    });

                                    //store saleid and date for printer to be able to access the id
                                    this.saleId = response.id.toString();
                                    this.transactionId = response.transactionId.toString();
                                    this.sale.transactionId = response.transactionId;
                                    this.firstClientEmailAddress = "";
                                    this.multipleClients = this.allUniqueClients.length > 1;

                                        if (this.sale.saleLines.length > 0) {
                                        this.firstClientId = this.sale.saleLines[0].clientId;

                                        if (this.firstClientId) {
                                            await this.setFirstClientEmailAddress();
                                        }
                                    }

                                    this.transactionDateTime = response.transactionDateTime;

                                    const hasPurchasedItems = this.sale.hasPurchasedItems;
                                    if (this.isIncludeGiftReceipt && !hasPurchasedItems) {
                                        this.isIncludeGiftReceipt = false;
                                    }
                                    this.sendToPaymentPlanManager();
                                    this.tippyService.confirmTransaction(this.sale);
                                    this.tippyService.refundTransaction(this.sale, this).then(isFundedAtSettlementTime => {
                                        if (!!tippyRefundDeferred) {
                                            tippyRefundDeferred.resolve(isFundedAtSettlementTime);
                                        }
                                    });
                                    
                                    this.reset(true, false);
                                    this.sale.hasPurchasedItems = hasPurchasedItems;
                                    defer.resolve();
                                });
                            })
                            .catch((response) => {
                                this.busyService.stop();
                                this.checkForFailedCreditCardPaymentLines(response);
                                this.trackUsageProductUsageFinalize(response);
                                this.checkPaymentAuthorizationError(response);
                                defer.reject();
                                this.sale.saleStage = Model.SaleStageEnum.Initial;
                            })
                            .finally(() => {
                                this.busyService.stop();
                            });
                    }).catch((response) => {
                        defer.reject();
                    })
                })
                .catch(() => {
                    defer.reject();
                });

            return defer.promise;
        }

        trackUsageProductUsageFinalize(response) {
            if (response.data && response.data.responseStatus && response.data.responseStatus.errors &&
                _(response.data.responseStatus.errors).any(error => error.message === "MESSAGE_SALE_PRODUCT_USAGE_VALIDATION")) {
                this.registerController.usageTrackingLog(Model.VerbEnum.ProductUsageDisabledWarningViewed);
            }
        }

        showClientAccountInvalidUsageModal() {
            return this.modalService.confirm('MESSAGE_CLIENT_ACCOUNT_USAGE_INVALID')
                .then(() => {
                    this.sale.skipClientAccountValidation = true;
                    this.sale.isClientAccountUsageInvalid = false;
                    this.checkoutHandleReceipt();
                    return this.$q.reject();
                })
                .catch(() => {
                    this.selectSection(RegisterSectionTypeEnum.PaymentOptions);
                    return this.$q.reject()
                });
        }

        async setFirstClientEmailAddress() {
            if (this.sale.saleLines[0].client.emailAddress != undefined && this.sale.saleLines[0].client.emailAddress != "") {
                this.firstClientEmailAddress = this.sale.saleLines[0].client.emailAddress;
                return;
            }
            //check if any other Sale Line with same Client has an email address
            let saleLiensWithClientWithEmail = _.filter(this.sale.saleLines, (sl) => {
                return (sl.client && sl.client.id == this.firstClientId && sl.client.emailAddress != undefined && sl.client.emailAddress != "");
            });
            if (saleLiensWithClientWithEmail.length > 0) {
                this.firstClientEmailAddress = saleLiensWithClientWithEmail[0].client.emailAddress;
            }
            else {
                //check if first client was created outside of Register and needs to get email address from DB
                let regClient = _.filter(this.allUniqueClients, (rClient) => { return (rClient.client && rClient.client.id == this.firstClientId) });
                if (regClient[0].client.isCreatedOutsideOfRegister) {
                    await this.dataService.getItem('client', <Guid><any>this.firstClientId)
                        .then((clientResp: any) => {
                            this.firstClientEmailAddress = clientResp.emailAddress;
                        });
                }
            }
        }

        checkForFailedCreditCardPaymentLines(response) {
            if (response.data && response.data.responseStatus && response.data.responseStatus.errors) {
                let indexesToDelete = [];
                response.data.responseStatus.errors.forEach((validationFailure) => {
                    let fieldName = validationFailure.fieldName;
                    if (fieldName.indexOf("PaymentLines[") >= 0) {
                        indexesToDelete.push(parseInt(fieldName.substring(fieldName.indexOf("[") + 1, fieldName.indexOf("]"))));
                    }
                })
                if (indexesToDelete.length > 0) {
                    for (let i = this.sale.paymentLines.length - 1; i >= 0; i--) {
                        if (indexesToDelete.indexOf(i) >= 0) {
                            this.sale.paymentLines.splice(i, 1);
                        }
                    }
                    this.recalculateChangeDue();
                    this.showPaymentOptions();
                }
            }
        }

        checkPaymentAuthorizationError(response) {
            const propName: keyof Model.PaymentRequest = "isAuthorization"
            var paymentAuthorizatonError = response.data && response.data.responseStatus && response.data.responseStatus.errors &&
                _(response.data.responseStatus.errors).find(error => error.fieldName.toLowerCase() === String(propName).toLowerCase());
            if (paymentAuthorizatonError) {
                this.printVoidReceipts(paymentAuthorizatonError.customState);
                this.sale.paymentLines = this.getRemainingAuthorizationReversalPaymentLines(paymentAuthorizatonError.customState);
                this.recalculateChangeDue();
                this.selectSection(RegisterSectionTypeEnum.PaymentOptions);
            }
        }

        hasPromoGiftCardWithService() {
            return true;
        }

        showTips(modalType: RegisterModalTypeEnum = RegisterModalTypeEnum.Tip): angular.IPromise<any> {
            return this.registerTipService.showTips(this, this.sale, modalType);
        }

        showModal(modalType: RegisterModalTypeEnum): angular.IPromise<any> {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/modals/modal.template.html",
                controller: "meevo.plugins.register.ModalController",
                controllerAs: "vm",
                bindToController: true,
                //clickOutsideToClose: true,
                locals: {
                    registerContext: this,
                    modalType: modalType
                }
            }

            return this.modalService.showCustom(options);
        }

        closeModal(receiptPreference: Model.RegisterReceiptTypeEnum = Model.RegisterReceiptTypeEnum.NoReceipt) {
            this.receiptPreference = receiptPreference;
            return this.$mdDialog.hide();
        }

        employeeChanged(saleLine, isSecondEmployee = false) {
            if (!isSecondEmployee && (!saleLine.employee || saleLine.employee.id == saleLine.employeeId)) {
                return;
            }

            if (!saleLine.secondEmployee) {
                this.postEmployeeChanged(saleLine, false);
                return;
            }

            if (isSecondEmployee && this.isEmployeeHouseEmployee(saleLine.secondEmployee)) {
                this.modalService.confirmHandler(this.$translate.instant("MESSAGE_SPLIT_COMMISSION_WITH_HOUSE", { employee: this.HouseEmployee.displayName }))
                    .then((response: boolean) => {
                        if (response) {
                            if (saleLine.employeeSplitCommission == 1 && saleLine.secondEmployeeSplitCommission == 1) {
                                if (isSecondEmployee) {
                                    saleLine.secondEmployeeSplitCommission = 0;
                                } else {
                                    saleLine.employeeSplitCommission = 0;
                                }
                            }
                            this.postEmployeeChanged(saleLine, isSecondEmployee);
                        } else {
                            if (isSecondEmployee) {
                                this.removeSecondEmployee(saleLine);
                            } else {
                                saleLine.employee = null;
                                saleLine.employeeId = null;
                            }
                        }
                    });
            } else {
                this.postEmployeeChanged(saleLine, isSecondEmployee);
            }
        }

        postEmployeeChanged(saleLine, isSecondEmployee: boolean = false) {
            this.registerTipService.reassignTips(this, this.sale, saleLine, isSecondEmployee);

            if (isSecondEmployee) {
                saleLine.secondEmployeeId = saleLine.secondEmployee.id;

                if (!saleLine.originalSecondEmployeeId) {
                    saleLine.originalSecondEmployeeId = saleLine.secondEmployeeId;
                }
                else if (saleLine.originalSecondEmployeeId == saleLine.secondEmployee.id) {
                    saleLine.originalSecondEmployeeId = undefined;
                }
            } else {
                saleLine.employeeId = saleLine.employee.id;

                if (!saleLine.originalEmployeeId) {
                    saleLine.originalEmployeeId = saleLine.employeeId;
                }
                else if (saleLine.originalEmployeeId == saleLine.employee.id) {
                    saleLine.originalEmployeeId = undefined;
                }

                this.selectedEmployee = saleLine.employee;

                if (this.isSaleLineAService(saleLine) && saleLine.redeemedPackages) {
                    this.updateLinkedSwapFeeSaleLine(saleLine)
                }
            }

            // NOTE: right now, we only have Service and Product; Product change do not require recalculate while Service change does.
            //       Fix this condition appropriately for next TransType. This condition assumes that only Services require recalculation.
            if (this.isSaleLineAService(saleLine) && !saleLine.isRefund &&
                (!saleLine.redeemedPackages || saleLine.redeemedPackages.length < 1)) {

                saleLine.finalItemPrice = null;
                saleLine.baseItemPrice = null;
            }

            // employee changes can impact tipping
            this.recalculateSale(true);
        }

        teacherChanged(saleLine) {
            saleLine.teacherId = saleLine.teacher ? saleLine.teacher.id : undefined;
            this.selectedTeacher = saleLine.teacher;
        }

        itemChanged(saleLine) {
            if (saleLine.item.temp) {
                if (!saleLine.item.originalId) {
                    saleLine.item.originalId = saleLine.item.id;
                }
                else if (saleLine.item.originalId == saleLine.item.temp.id) {
                    saleLine.item.originalId = undefined;
                }

                saleLine.finalItemPrice = null;
                saleLine.baseItemPrice = null;
                let newItem = new Meevo.Plugins.Register.ServiceSaleLineItem({
                    displayName: saleLine.item.temp.displayName,
                    shortcut: saleLine.item.temp.shortcut,
                    id: saleLine.item.temp.id,
                    appointmentId: saleLine.item.appointmentId,
                    appointmentServiceId: saleLine.item.appointmentServiceId,
                    addOnAppointmentServiceId: saleLine.item.addOnAppointmentServiceId,
                    appointmentServiceDate: saleLine.item.appointmentServiceDate,
                    isRebooked: saleLine.item.isRebooked,
                    originalId: saleLine.item.originalId,
                    doNotAllowTips: saleLine.item.temp.doNotAllowTips,
                    depositAmount: saleLine.item.depositAmount
                });
                saleLine.item = newItem;
                saleLine.isDirty = true;

                this.removePackageRedemption(saleLine, false);
                this.recalculateSale(true).finally(() => {
                    this.registerDiscountService.showOfferRemovedMessages(this.sale);
                });
            }
        }
        expandCallback(clientIndex, saleLineIndex): void {
            let filter: any = this.$filter("saleLinesByClient");
            let saleLine = filter(this.sale.saleLines, this.allUniqueClients[clientIndex])[saleLineIndex];
            saleLine.isDetailExpanded = true;
            saleLine.needsCollapsing = false;

            //Setting z-index to the index in reverse order.
            $(".register-items" + clientIndex).css("zIndex", $(".register-items").length - clientIndex);
            $(".register-items" + clientIndex + " .vPaneContent" + saleLineIndex).css("zIndex", $(".register-items" + clientIndex + " .accordion-pane").length - saleLineIndex);

            setTimeout(() => {
                //setting overflow to visible for clicked register-item and v-pan so typeahead can be visible fully.
                $(".register-items" + clientIndex + " .vPane" + saleLineIndex).css("overflow", "visible");
                $(".register-items" + clientIndex).css("overflow", "visible");
            }, 500);

            this.openRefundDetails(saleLine, this.allUniqueClients[clientIndex]);
        }

        openRefundDetails(saleLine, client) {
            if (!saleLine.isRefund || saleLine.saleType === Model.SalesTypeEnum.BulkGiftCard) {
                return;
            }

            this.selectClient(client);

            if (this.isSaleLineEditable(saleLine, true)) {
                this.isRefundMode = true;
                this.editSaleItem(saleLine);
                return;
            }

            let registerSection: RegisterSectionTypeEnum;
            switch(saleLine.saleType) {
                case Model.SalesTypeEnum.Product:
                    registerSection = RegisterSectionTypeEnum.Products;
                    break;
                case Model.SalesTypeEnum.GiftCard:
                case Model.SalesTypeEnum.ReloadGiftCard:
                    // don't open refund pane for transaction gift card refunds
                    if (saleLine.refundLocationId &&
                        saleLine.refundSaleDate &&
                        saleLine.refundSaleId &&
                        saleLine.refundSaleLineId
                    ) {
                        break;
                    }
                    registerSection = RegisterSectionTypeEnum.GiftCard;
                    break;
                case Model.SalesTypeEnum.Service:
                case Model.SalesTypeEnum.ServiceCancellationFee:
                case Model.SalesTypeEnum.ServiceNoShowFee:
                case Model.SalesTypeEnum.PackageServiceSwapFee:
                    registerSection = RegisterSectionTypeEnum.Services;
                    break;
                default:
                    return;
            }

            this.selectSection(registerSection, true, true, true);
        }

        collapseCallback(clientIndex, saleLineIndex): void {
            let filter: any = this.$filter("saleLinesByClient");
            filter(this.sale.saleLines, this.allUniqueClients[clientIndex])[saleLineIndex].needsCollapsing = true;

            $(".register-items" + clientIndex + " .vPane" + saleLineIndex).css("overflow", "hidden");
            $(".register-items" + clientIndex).css("overflow", "hidden");

            // when the sale line is collapsed while viewing the Discounts section, switch to Services section
            if (this.selectedSection && this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Other &&
                this.selectedSection.sectionType !== RegisterSectionTypeEnum.Client &&
                this.selectedSection.sectionType !== RegisterSectionTypeEnum.PaymentPlan) {
                this.selectSection(RegisterSectionTypeEnum.Services, true);
            }
        }

        expandPaymentCallback(index, id): void {
            if (this.openedPaymentAccordion != null) {
                this.collapsePaymentCallback(index, id);
            }
            this.openedPaymentAccordion = $(".vPaymentAccordion--default v-pane");
            this.openedPaymentAccordionIndex = index;
            setTimeout(() => {
                this.openedPaymentAccordion.css("overflow", "visible");
            }, 500);
        }

        collapsePaymentCallback(index, id): void {
            this.openedPaymentAccordion.css("overflow", "hidden");
            this.openedPaymentAccordion = null;
            this.openedPaymentAccordionIndex = null;
            this.recalculateChangeDue();
            this.changePaymentLine(index);
        }

        calculateCashRounding(sale?: Model.Sale) {
            sale = sale || this.sale;
            if (!sale) {
                return;
            }

            let changeDueCash = this.getChangeDue(true, sale);
            let changeDue = this.getChangeDue(false, sale);
            let changeDueDifference = this.subtractNormalizedNumbers(changeDueCash, changeDue);

            sale.cashRounding = 0;

            if (changeDueDifference != 0 &&
                Math.abs(changeDueDifference) < this.financialInfo.cashRoundingInterval
            ) {
                sale.cashRounding = changeDueDifference;
            }
        }

        addPayment(paymentObject: Model.SalePayment, automaticChangeDue: boolean = true, sale: Model.Sale = undefined): angular.IPromise<void> {
            sale = sale || this.sale;

            let recalculateSale: boolean = false;
            let addAsNew = true;
            let paymentTypeDisplayName = "";
            let paymentLine: Model.SalePayment;

            let paymentType = _(this.paymentTypes).findWhere({ id: paymentObject.paymentTypeId });

            const updatePaymentLine = (paymentLine, paymentObject) => {
                paymentLine.amount = this.addNormalizedNumbers(paymentLine.amountBeforeSurcharge || paymentLine.amount, paymentObject.amount);
                paymentLine.surcharge = this.addNormalizedNumbers(paymentLine.surcharge || 0, paymentObject.surcharge || 0);
                paymentLine.amountBeforeSurcharge = paymentLine.amount;
            };

            // if projected refund saleline exists, then add additional payment to it
            const projectedRefund = sale.paymentLines.find(paymentLine => paymentLine.amount < 0 && paymentLine.paymentRequest && paymentLine.paymentRequest.isAuthorization);
            if (projectedRefund && projectedRefund.paymentRequest.parentId === paymentObject.parentId) {
                updatePaymentLine(projectedRefund, paymentObject);
                projectedRefund.paymentRequest.amount = projectedRefund.amount;
                addAsNew = false;
            }

            // paymentType should always be populated!
            if (paymentType) {
                if (this.hasChangeDueWithRefunds()) {
                    if (paymentType.paymentCategory === Model.PaymentCategoryEnum.Cash) {
                        addAsNew = false; // no negative payment line for cash credit - just change due
                    }
                }
                else if (paymentType.paymentCategory === Model.PaymentCategoryEnum.Cash ||
                    (paymentType.paymentCategory === Model.PaymentCategoryEnum.CreditDebit && !this.creditCardProcessingEnabled)) {
                    // accumulate amount for cash and credit/debit (when credit card processing disabled) type payments
                    paymentLine = _(this.sale.paymentLines).findWhere({ paymentTypeId: paymentObject.paymentTypeId });

                    // if paymentRequestId exists, this was a payment made with creditCardProcessingEnabled checked on and should not be merged
                    if (paymentLine && !paymentLine.paymentRequestId) {
                        updatePaymentLine(paymentLine, paymentObject);
                        addAsNew = false;
                    }
                }
                else if (paymentType.paymentCategory === Model.PaymentCategoryEnum.Other) {
                    // accumulate amount for other type payments (excluding refunds)
                    if (+paymentObject.amount > 0) {
                        paymentLine = _(this.sale.paymentLines).find(paymentLine =>
                            paymentLine.amount > 0 &&
                            paymentLine.paymentTypeId === paymentObject.paymentTypeId);

                        if (paymentLine) {
                            updatePaymentLine(paymentLine, paymentObject);
                            addAsNew = false;
                        }

                        recalculateSale = !!paymentObject.surcharge;
                    }
                }
                else if (paymentType.paymentCategory === Model.PaymentCategoryEnum.GiftCard) {
                    const giftCardPayment = paymentObject as Model.SaleGiftCardPayment;
                    recalculateSale = giftCardPayment.isPromo;
                    paymentLine = _(this.sale.paymentLines).findWhere({ giftCardId: giftCardPayment.giftCardId });

                    if (paymentLine) {
                        addAsNew = false;
                    }
                }
                else if (paymentType.paymentCategory === Model.PaymentCategoryEnum.PointsRewards) {
                    paymentLine = _(this.sale.paymentLines).findWhere({
                        clientId: (paymentObject as Model.SaleClientPointPayment).clientId,
                        paymentCategory: Model.PaymentCategoryEnum.PointsRewards
                    });

                    if (paymentLine) {
                        paymentLine.amount = paymentObject.amount;
                        addAsNew = false;
                    }
                }
                else if (paymentType.paymentCategory === Model.PaymentCategoryEnum.PaymentPlan) {
                    let existingPaymentPlanPayment = this.paymentPlanService.getExistingPaymentPlanPaymentLine(this.sale);
                    if (existingPaymentPlanPayment) {
                        this.sale.paymentLines.splice(_(this.sale.paymentLines).indexOf(existingPaymentPlanPayment), 1, paymentObject)
                        addAsNew = false;
                    }
                }
            }

            if (paymentLine && !!paymentLine.paymentTypeDisplayName) {
                paymentTypeDisplayName = paymentLine.paymentTypeDisplayName;
            }
            else if (paymentType) {
                paymentTypeDisplayName = paymentType.displayName;
            }
            else {
                let paymentCat = _.findWhere(this.paymentCats, { id: paymentObject.paymentCategory });
                paymentTypeDisplayName = paymentCat.displayName;
            }

            if (addAsNew) {
                // create new entry
                sale.paymentLines.push(paymentObject);
            }
            else if (this.hasChangeDueWithRefunds()) {
                // do something else?
            }
            else {
                paymentTypeDisplayName = this.$translate.instant("LABEL_POLE_UPDT") + "-" + paymentTypeDisplayName;
            }

            this.recalculateChangeDue(sale);

            this.displayPoleMessage(paymentTypeDisplayName, paymentObject.amount);

            if (recalculateSale) {
                return this.recalculateSale(false, null, false, sale).then(() => {
                    var continueToChangeDueModalIfPaymentIsEnough = true;
                    if (paymentType.paymentCategory === Model.PaymentCategoryEnum.GiftCard) {
                        let giftCardPayment = paymentObject as Model.SaleGiftCardPayment;
                        if (giftCardPayment.isPromo) {
                            let paymentLine = _(this.sale.paymentLines).findWhere({ giftCardId: giftCardPayment.giftCardId });

                            if (!paymentLine) {
                                continueToChangeDueModalIfPaymentIsEnough = false;
                                const message = this.$translate.instant("MESSAGE_PROMO_GIFT_CARD_NOT_APPLICABLE", { promoServiceDisplayName: giftCardPayment.promoServiceDisplayName });
                                this.modalService.alert(message);
                            }
                        }
                    }

                    if (continueToChangeDueModalIfPaymentIsEnough && automaticChangeDue && this.checkIfPaymentIsEnough()) {
                        return this.finishSection();
                    }
                });
            }
            else if (automaticChangeDue && this.checkIfPaymentIsEnough()) {
                return this.finishSection();
            }

            return this.$q.resolve();
        }

        checkIfPaymentIsEnough(excludePending: boolean = true) {
            const totalPayments = this.getTotalPaymentsWithRounding(excludePending);
            return Math.abs(this.sale.total) <= Math.abs(totalPayments);
        }

        createSecondLineForChangeOrBalanceDue(amount) {
            const messageKey = amount > 0 ? "LABEL_BALANCE" : "LABEL_CHANGE";

            return [
                this.$translate.instant(messageKey) + ':',
                this.meevoCurrency(Math.abs(amount))
            ];
        }

        formatPaymentPoleMessage(label, value) {
            if (label.length > value.length) {
                value = value.padLeft(this.maxPoleMessageLength - label.length, " ");
            } else {
                label = label.padRight(this.maxPoleMessageLength - value.length, " ");
            }
            return label + value;
        }

        showDepositChargeInsufficientBalance(paymentLine: Model.SalePayment) {
            return paymentLine.paymentSubCategory === Model.PaymentSubCategoryEnum.DepositCharge &&
                paymentLine.amount === 0;
        }

        showDepositCreditInsufficientBalance(saleLine: Model.SaleLine) {
            return saleLine.saleType === Model.SalesTypeEnum.DepositCredit && saleLine.isRefund &&
                saleLine.finalPrice === 0;
        }

        getPaymentDescription(paymentLine: Model.SalePayment): string {
            let description: string;

            let getPaymentTypeDescription = (typeId) => {
                let paymentType = _.findWhere(this.paymentTypes, { id: typeId });
                if (paymentType) {
                    return this.getPaymentTypeDisplayName(paymentType);
                }
                return this.$translate.instant("LABEL_OTHER");
            }

            if (paymentLine.paymentTypeId) {
                switch (paymentLine.paymentCategory) {
                    case Meevo.Model.PaymentCategoryEnum.CreditDebit:
                        if (this.creditCardProcessingEnabled) {
                            let creditDebitPaymentLine = paymentLine as Model.SaleCreditCardPayment;
                            description = `${creditDebitPaymentLine.paymentTypeDisplayName} ${creditDebitPaymentLine.creditCardNumber}`;
                        } else {
                            description = getPaymentTypeDescription(paymentLine.paymentTypeId);
                        }
                        break;

                    case Meevo.Model.PaymentCategoryEnum.GiftCard:
                        let giftCardPaymentType = this.$translate.instant("LABEL_GIFT_CARD");
                        let giftCardPaymentLine = paymentLine as Model.SaleGiftCardPayment;
                        description = `${giftCardPaymentType}: ${giftCardPaymentLine.giftCardNumber}`;
                        break;

                    case Meevo.Model.PaymentCategoryEnum.PointsRewards:
                        let pointsPaymentLine = paymentLine as Model.SaleClientPointPayment;
                        const points = this.$translate.instant('LABEL_POINTS');
                        description = `${points} - ${pointsPaymentLine.clientDisplayName}`;
                        break;

                    case Meevo.Model.PaymentCategoryEnum.ClientAccount:
                        let clientAccountPaymentType = getPaymentTypeDescription(paymentLine.paymentTypeId);
                        let clientAccountPaymentLine = paymentLine as Model.SaleClientAccountPayment;

                        switch (paymentLine.paymentSubCategory) {
                            case Model.PaymentSubCategoryEnum.AccountCharge:
                                description = `${clientAccountPaymentType}: ${clientAccountPaymentLine.clientDisplayName}`;
                                break;

                            case Model.PaymentSubCategoryEnum.DepositCharge:
                                let depositChargeDescription = this.$translate.instant("LABEL_DEPOSIT_CHARGE", {
                                    serviceShortcut: clientAccountPaymentLine.serviceShortcut,
                                    clientDisplayName: clientAccountPaymentLine.clientDisplayName,
                                });

                                description = `${clientAccountPaymentType}: ${depositChargeDescription}`;
                                break;
                        }
                        break;
                    default:
                        description = getPaymentTypeDescription(paymentLine.paymentTypeId);
                        break;
                }
            }
            else if (this.isCreditPaymentLine(paymentLine)) {
                description = this.getPendingCreditDebitPaymentLineText(paymentLine);
            }
            return description;
        }

        private isCreditPaymentLine(paymentLine): boolean {
            return (paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CreditDebit && this.creditCardProcessingEnabled) ||
                paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CareCredit;
        }

        private getPendingCreditDebitPaymentLineText(paymentLine): string {
            const creditDebitPaymentLine = paymentLine as Model.SaleCreditCardPayment;
            if (!creditDebitPaymentLine || !creditDebitPaymentLine.isPending) {
                return null;
            }

            let description = null;

            switch (creditDebitPaymentLine.paymentCategory) {
                case Meevo.Model.PaymentCategoryEnum.CareCredit:
                    description = this.$translate.instant("LABEL_CARECREDIT_PENDING_PROCESSING");
                    break;

                default:
                    description = creditDebitPaymentLine.transactionSetupId
                        ? this.$translate.instant("LABEL_HOSTED_PAGE") + ' '
                        : '';

                    description += this.$translate.instant("LABEL_CREDIT_DEBIT_PENDING_PROCESSING");
                    break;
            }

            return description;
        }

        getTotalFinalSales() {
            if (!this.sale) {
                return 0;
            }

            let totalSales: number = 0;

            _(this.sale.saleLines).each((saleLine: Model.SaleLine) => {
                if (saleLine.isRefund || saleLine.saleType === Model.SalesTypeEnum.AssociatedClient) {
                    return;
                }

                if (saleLine.packageRedeemed || (saleLine.redeemedPackages && saleLine.redeemedPackages.length > 0)) {
                    return;
                }

                totalSales += saleLine.finalPriceCharge + (saleLine.finalTax - saleLine.finalTaxIncluded) + (saleLine.prepaidTip || 0);
            });

            _(this.sale.tipLines).each((tipLine: Model.TipLine) => {
                if (tipLine.isRefund) {
                    return;
                }

                totalSales += tipLine.amount || 0;
            });

            return this.normalizeDecimalPlaces(totalSales);
        }

        getTotalFinalRefunds() {
            if (!this.sale) {
                return 0;
            }

            let totalRefunds: number = 0;

            _(this.sale.saleLines).each((saleLine: Model.SaleLine) => {
                if (!saleLine.isRefund || saleLine.saleType === Model.SalesTypeEnum.AssociatedClient) {
                    return;
                }

                totalRefunds += saleLine.finalPriceCharge + (saleLine.finalTax - saleLine.finalTaxIncluded) + (saleLine.prepaidTip || 0);
            });

            _(this.sale.tipLines).each((tipLine: Model.TipLine) => {
                if (!tipLine.isRefund) {
                    return;
                }

                totalRefunds += tipLine.amount || 0;
            });

            return this.normalizeDecimalPlaces(totalRefunds);
        }

        getTotalPayments(excludePending: boolean = false, sale: Model.Sale = null): number {
            sale = sale || this.sale;

            let totalPayments: number = 0;
            if (sale && sale.paymentLines) {
                _(sale.paymentLines).each(item => {
                    if (!excludePending || !item.isPending) {
                        totalPayments += +item.amount;
                    }
                });
            }

            return this.normalizeDecimalPlaces(totalPayments);
        }

        getTotalPaymentsWithRounding(excludePending: boolean = false): number {
            let totalPayments = this.getTotalPayments(excludePending);
            return this.addNormalizedNumbers(totalPayments, this.getCashRounding());
        }

        getTotalPointsPayments(clientId?: string): number {
            let totalPayments: number = 0;
            if (this.sale && this.sale.paymentLines) {
                _.chain(this.sale.paymentLines)
                    .filter((item) => {
                        return (item.paymentCategory === Model.PaymentCategoryEnum.PointsRewards
                            && (clientId == null || (<Model.SaleClientPointPayment>item).clientId == clientId));
                    })
                    .each((item) => {
                        totalPayments += item.amount;
                    });
            }
            return totalPayments;
        }

        isSaleLineBeingCancelled(saleLine: Model.SaleLine): boolean {
            return (saleLine.saleType === Model.SalesTypeEnum.ServiceCancellationFee) || (this.isSaleLineAService(saleLine) && (saleLine.item as Model.ServiceSaleLineItem).cancellationTypeId != null);
        }

        canEditService(saleLine: Model.SaleLine): boolean {
            return (this.isSelectedDrawerOpen() || !this.isSaleLineBeingCancelled(saleLine));
        }

        private isHostedPaymentFinalized(paymentLine: Model.SalePayment): boolean {
            return paymentLine.paymentRequestId && !paymentLine.transactionSetupId;
        }

        canDeletePaymentLine(paymentLine: Model.SalePayment): boolean {
            if (!paymentLine) {
                return false;
            }

            if (paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CareCredit) {
                return false;
            }

            if ((paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CreditDebit && this.creditCardProcessingEnabled) &&
                paymentLine.amount < 0 &&
                paymentLine.paymentRequest &&
                !paymentLine.paymentRequest.isAuthorization &&
                !this.getMerchantAccountCanVoidRefunds()
            ) {
                return false;
            }

            return !paymentLine.isPending || !this.isHostedPaymentFinalized(paymentLine);
        }

        canEditPaymentLine(paymentLine: Model.SalePayment): boolean {
            if (!paymentLine) {
                return false;
            }

            if ((paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CreditDebit && this.creditCardProcessingEnabled) ||
                paymentLine.paymentCategory === Model.PaymentCategoryEnum.GiftCard ||
                paymentLine.paymentCategory === Model.PaymentCategoryEnum.PointsRewards ||
                paymentLine.amount >= 0) {
                return false;
            }

            return true;
        }

        cancelPendingHostedPagePayments() {
            let deferred = this.$q.defer();

            if (!this.sale) {
                deferred.resolve();
                return deferred.promise;
            }

            let promises = [];

            _(this.sale.paymentLines).each((paymentLine) => {
                if (paymentLine.isPending && !this.isHostedPaymentFinalized(paymentLine)) {
                    promises.push(this.refreshPaymentRequest(paymentLine, false, true));
                }
            });

            if (promises.length === 0) {
                deferred.resolve();
                return deferred.promise;
            }

            this.busyService.start();

            this.$q.all(promises)
                .then(() => deferred.resolve())
                .catch(() => deferred.reject())
                .finally(() => {
                    this.busyService.stop();
                });

            return deferred.promise;
        }

        showDrawerLayer(): boolean {
            return !this.isSelectedDrawerOpen();
        }

        showPendingLayer(): boolean {
            return this.hasPendingPayment()
                || this.isPackageRedemption()
                || this.isProductUsage()
                || this.isDiscounts()
                || this.isPromotionalGiftCard()
                || this.registerTicketService.recalculateSaleInProgress
                || this.isPopulatingTicketFromAppointmentServices
                || (this.isRefundMode && this.selectedSection.sectionType === RegisterSectionTypeEnum.PaymentPlan);
        }

        clickPendingLayer() {
            if (this.isProductUsage()) {
                this.modalService.info(this.$translate.instant("MESSAGE_CLOSE_PRODUCT_USAGE"));
            }
        }

        private isTicketBlockedToProtectPayment() {
            if (!this.selectedSection) {
                return false;
            }

            switch (this.selectedSection.sectionType) {
                case RegisterSectionTypeEnum.PaymentOptions:
                case RegisterSectionTypeEnum.ChangeOptions:
                case RegisterSectionTypeEnum.CardOnFile:
                case RegisterSectionTypeEnum.CreditSingleCard:
                case RegisterSectionTypeEnum.CreditMultiCard:
                case RegisterSectionTypeEnum.CareCreditPayment:
                    return true;
            }

            return false;
        }

        showPaymentLayer(): boolean {
            if (this.showPendingLayer()) {
                return false;
            }

            return this.isTicketBlockedToProtectPayment();
        }

        hasPendingPayment(): boolean {
            return this.sale && (_(this.sale.paymentLines).any(paymentLine => paymentLine.isPending) || this._reversePaymentRequest != null);
        }

        isCreditDebitPayment(paymentLine: Model.SalePayment): boolean {
            return paymentLine &&
                !paymentLine.isPending &&
                paymentLine.paymentCategory === Meevo.Model.PaymentCategoryEnum.CreditDebit &&
                this.creditCardProcessingEnabled;
        }

        hasCreditDebitPayment(): boolean {
            if (!this.sale) {
                return false;
            }

            return _(this.sale.paymentLines).any(paymentLine => this.isCreditDebitPayment(paymentLine));
        }

        changePaymentLine(paymentLineIndex) {
            let updatedPaymentLine = this.sale.paymentLines[paymentLineIndex];
            if (!updatedPaymentLine) {
                return;
            }

            let paymentTypeDisplayName = "";
            if (!!updatedPaymentLine.paymentTypeDisplayName) {
                paymentTypeDisplayName = updatedPaymentLine.paymentTypeDisplayName;
            } else {
                let paymentCat = _.findWhere(this.paymentCats, { id: updatedPaymentLine.paymentCategory });
                if (paymentCat) {
                    paymentTypeDisplayName = paymentCat.displayName;
                }
            }

            paymentTypeDisplayName = this.$translate.instant("LABEL_POLE_UPDT") + "-" + paymentTypeDisplayName;

            const isCashPayment = updatedPaymentLine.paymentCategory === Model.PaymentCategoryEnum.Cash;

            this.displayPoleMessage(paymentTypeDisplayName, updatedPaymentLine.amount, this.getBalanceDue(isCashPayment));
        }

        recalculateChangeDue(sale: Model.Sale = null) {
            sale = sale || this.sale;

            const totalPayments = this.getTotalPayments(false, sale);
            sale.changeDue = this.subtractNormalizedNumbers(totalPayments, sale.total);

            this.calculateCashRounding(sale);
        }

        clientChangedUpdateRefundTips() {
            let clients = _(this.allUniqueClients).chain().where({ clientType: Model.ClientTypeEnum.Client }).pluck("client").value();
            for (var i = this.sale.tipLines.length - 1; i >= 0; i--) {
                let tipLine = this.sale.tipLines[i];
                if (tipLine.isRefund) {
                    let clientFound = false;
                    for (var clientId of tipLine.clientIds) {
                        if (_(clients).findWhere({ id: clientId })) {
                            clientFound = true;
                            break;
                        }
                    }
                    if (!clientFound) {
                        this.sale.tipLines.splice(i, 1);
                    }
                }
            }
            this.updateTip();
            this.tippyService.partialRefundTransaction(this);
        }

        isTipEligible(): boolean {
            return this.registerTipService.isTipEligible(this.sale.saleLines, this.isCreditMode, this.includeProductsInTips);
        }

        addUniqueClientsFromTipLines(tipLines: Model.TipLine[]): void {
            tipLines
                .filter(tipLine => !!tipLine.registerClients && !!tipLine.registerClients.length)
                .forEach(tipLine => {
                    tipLine.registerClients.forEach(registerClient => {

                        if (this.clientContext.isAnonymousClient(registerClient.clientType)) {
                            this.addToAllUniqueClients(undefined, registerClient.clientType, undefined);
                        } else {
                            const client = {
                                id: registerClient.clientId,
                                clientType: registerClient.clientType,
                                appointmentId: registerClient.appointmentId,
                                clientDisplayName: registerClient.clientDisplayName
                            }

                            this.addToAllUniqueClients(client, client.clientType, client.appointmentId);
                        }

                    });
                });

            if (this.allUniqueClients && this.allUniqueClients.length) {
                this.selectClient(this.allUniqueClients[0], true);
            }
        }

        recalculateTip(sale: Model.Sale = null) {
            sale = sale || this.sale;
            return this.registerTipService.recalculateTip(this, sale);
        }

        updateTip(tipLines: any[] = null, tipPercentage: number = null, tipAmount: number = null, useDiscountedPrice: boolean = null) {
            return this.registerTipService.updateTip(this, this.sale, tipLines, tipPercentage, tipAmount, useDiscountedPrice);
        }

        isPaymentScreen(): boolean {
            return this.selectedSection && this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Payment;
        }

        isPaymentPlanScreen(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.PaymentPlan;
        }

        canFinalize(isPaymentScreen: boolean = false): boolean {
            if (this.saleInProgress()) {
                return false;
            }

            if (this.showPendingLayer()) {
                return false;
            }

            if (!this.allUniqueClients || this.allUniqueClients.length === 0) {
                return false;
            }

            if (!this.isSelectedDrawerOpen()) {
                return false;
            }

            return (!isPaymentScreen || this.isFinalize()) &&
                (
                    (this.sale.saleLines && this.sale.saleLines.length > 0 && !this.hasClientWithNoSaleItem()) ||
                    (this.sale.tipLines && this.sale.tipLines.length > 0)
                );
        }

        isFinalize(): boolean {
            if (this.hasExternalTipAmountDue()) {
                return false;
            }

            return this.sale && this.getTotalPaymentsWithRounding() >= this.sale.total;
        }

        isAddPaymentButtonHidden(): boolean {
            if (!this.selectedSection) {
                return true;
            }

            switch (this.selectedSection.sectionType) {
                case RegisterSectionTypeEnum.PaymentOptions:
                case RegisterSectionTypeEnum.RefundOptions:
                case RegisterSectionTypeEnum.RefundReason:
                    return true;
            }

            return this.getCashChangeDue() !== 0 || this.isFinalizeButtonHidden() || !this.canFinalize(this.isPaymentScreen());
        }

        isFinalizeButtonHidden(): boolean {
            if (!this.selectedSection) {
                return true;
            }

            return (
                this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Payment &&
                this.selectedSection.sectionType !== RegisterSectionTypeEnum.PaymentOptions &&
                !this.hasRefundsInSale()
            ) ||
                (
                    this.selectedSection.sectionCatType === RegisterSectionCatTypeEnum.Payment &&
                    this.selectedSection.sectionType !== RegisterSectionTypeEnum.PaymentOptions &&
                    this.selectedSection.sectionType !== RegisterSectionTypeEnum.ChangeOptions &&
                    this.hasRefundsInSale()
                ) ||
                this.selectedSection.sectionType === RegisterSectionTypeEnum.ChangeOptions ||
                this.selectedSection.sectionType === RegisterSectionTypeEnum.PaymentPlan;
        }

        isPackageRedemption(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.PackageRedemption;
        }

        isProductUsage(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.ProductUsage;
        }

        isDiscounts(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.Discounts;
        }

        isPromotionalGiftCard(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.PromotionalGiftCard;
        }

        isRefundReason(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.RefundReason;
        }

        isChangeOptions(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.ChangeOptions;
        }

        isPaymentOptions(): boolean {
            return this.selectedSection && this.selectedSection.sectionType === RegisterSectionTypeEnum.PaymentOptions;
        }

        canDoNoSale(): boolean {
            return this.noSalePermission;
        }

        canRefund(): boolean {
            return this.isSelectedDrawerOpen() && this.isDirty();
        }

        isAddClientVisible(): boolean {
            const sectionType = this.getSelectedSectionType();

            switch (sectionType) {
                case RegisterSectionTypeEnum.Client:
                case RegisterSectionTypeEnum.Drawer:
                    return false;
            }

            return true;
        }

        canAddClient(): boolean {
            return this.isSelectedDrawerOpen() && !this.hasClientWithNoSaleItem();
        }

        assignTeacherToServiceSaleLines(teacher) {
            this.selectedTeacher = teacher;
            _(this.sale.saleLines).where({ needsTeacherAssignment: true }).forEach((saleLine: Model.SaleLine) => {
                saleLine.needsTeacherAssignment = false;
                if (this.selectedTeacher.id != Meevo.Guid.empty.toString()) {
                    saleLine.teacher = this.selectedTeacher;
                    saleLine.teacherId = this.selectedTeacher.id;
                }
            });
        }

        populateFromAppointmentServices(checkOutServices: any[], checkOutDetails?: any[], apptEntityVersion?: number) {
            return this.getClientAccountBalancesForCheckout(checkOutServices).then(() =>
                this.registerTicketService.populateFromAppointmentServices(this, checkOutServices, checkOutDetails, apptEntityVersion));
        }

        getClientAccountBalancesForCheckout(checkoutServices: any[]) {
            return this.registerClientAccountService.getClientAccountBalancesForCheckout(this, checkoutServices);
        }

        populateFromGiftCardReload(clientId: string, gcId: string, gcNumber: string, gcAmount: number) {
            var newClient: any = [];

            if (clientId) {
                this.dataService.getItem("client/", new Guid(clientId)).then((response: any) => {
                    this.selectedClient = response;
                    this.selectedClientType = Meevo.Model.ClientTypeEnum.Client;

                    newClient.client = this.selectedClient;
                    newClient.clientType = this.selectedClientType;

                    this.populateFromGiftCardReloadAfterClient(newClient, gcId);
                });
            } else {
                this.selectedClientType = Model.ClientTypeEnum.AnonymousOther;

                newClient.client = undefined;
                newClient.clientType = this.selectedClientType;

                this.populateFromGiftCardReloadAfterClient(newClient, gcId);
            }
        }

        populateFromGiftCardReloadAfterClient(newClient, gcId) {

            if (newClient.client) {
                newClient.clientFirstName = newClient.client.firstName;
                newClient.clientLastName = newClient.client.lastName;
            }

            newClient.clientDisplayName = this.formatClientDisplayName(newClient.clientFirstName, newClient.clientLastName, newClient.clientType);

            if (newClient.client) {
                newClient.client.displayName = newClient.clientDisplayName;
            }

            this.addToAllUniqueClients(newClient.client, newClient.clientType, undefined);
            this.selectClient(newClient, true, true);

            this.giftCardSection.loadGiftCard(gcId);
            this.giftCardSection.stage = GiftCardStageEnum.Single;
            this.selectSection(RegisterSectionTypeEnum.GiftCard, false);
        }

        startAddClient() {
            this.payingClient = undefined;
            this.payingClientType = undefined;
            this.editSelectedClient = false;
            this.showToday = false;
            this.selectSection(RegisterSectionTypeEnum.Client);
        }

        canHold() {
            if (!this.sale) {
                return false;
            }

            if (this.sale.saleLines && this.sale.saleLines.length > 0) {
                return true;
            }

            if (this.sale.tipLines && this.sale.tipLines.length > 0) {
                return true;
            }

            if (this.sale.paymentLines && this.sale.paymentLines.length > 0) {
                return _(this.sale.paymentLines).some((paymentLine: any) => !!paymentLine.paymentRequestId);
            }

            return false;
        }

        preProcessSelfPayments(isSelfPaymentAdd, selfPayments, willTriggerTippyKiosk = false) {
            let message_key: string;
            const isPuttingOnSelfPaymentHold = this.isPuttingOnSelfPaymentHold(isSelfPaymentAdd, selfPayments);

            if (isPuttingOnSelfPaymentHold && willTriggerTippyKiosk) {
                message_key = "MESSAGE_SELF_PAY_TIPPY_TRANSACTION_HOLD";
            } else if (isPuttingOnSelfPaymentHold && this.saleHasExternalTips()) {
                message_key = "MESSAGE_SELF_PAY_TIPPY_REFUND_HOLD";
            } else if ((!isSelfPaymentAdd && selfPayments.length > 1) ||
                (selfPayments.length > 0 && this.hasInvalidPaymentTypesForSelfPay())) {
                message_key = "MESAGE_SELF_PAYMENT_REHOLD_MULTIPLE";
            }
            if (angular.isDefined(message_key)) {
                return this.modalService.okCancelHandler(message_key);
            }

            return this.$q.resolve(true);
        }

        isPuttingOnSelfPaymentHold(isSelfPaymentAdd, selfPayments) {
            return !isSelfPaymentAdd && selfPayments.length > 0
        }

        postProcessSelfPayment(isSelfPaymentAdd, selfPayments, onHoldId, selfPayTippyEligibility: ISelfPayTippyEligibility) {
            if (!isSelfPaymentAdd && selfPayments.length == 1 &&
                !this.saleHasExternalTips() && !selfPayTippyEligibility.post) {
                //When tippy unauthorized, this messaging is done as a part of unauthorized message elsewhere
                return (selfPayTippyEligibility.isUnauthorized ? this.$q.resolve(true) : this.modalService.confirmHandler("MESSAGE_SELF_PAYMENT_REHOLD")).then(confirmResponse => {
                    if (confirmResponse) {
                        // should only be one since you're not allowed to hold a sale with multiple self pays
                        this.updateSelfPaymentWithOnHoldId(onHoldId);
                    }
                })
            }
            return this.$q.resolve();
        }

        updateSelfPaymentWithOnHoldId(onHoldId, updateSelfPay: boolean = true) {
            // Only support maintaining self payments when there's just a single one on the sale
            if (this.sale.selfPayments && this.sale.selfPayments.length == 1) {
                this.sale.selfPayments[0].onHoldId = onHoldId;
                if (updateSelfPay) {
                    this.dataService.customMethodData("/api/selfPayment", "put", this.sale.selfPayments[0]);
                }
            }
            else {
                this.sale.selfPayments = [];
            }
        }

        _onHold(deferred: ng.IDeferred<any>, isSelfPaymentAdd: boolean = false) {
            const continueOnHold = (selfPayTippyEligibility: ISelfPayTippyEligibility) => {
                this.busyService.start();
                this.dataService.add("drawer", this.sale, new Guid(this.selectedDrawer.id), "sale")
                    .then((response: any) => {
                        this.busyService.stop();
                        if (response.isWarning) {
                            this.modalService.confirmHandler(response.responseStatus.message, Components.Modal.ModalTranslationModes.DoNotTranslate).
                                then((response: boolean) => {
                                    if (response) {
                                        this.sale.suppressWarnings = true;
                                        this._onHold(deferred, isSelfPaymentAdd);
                                    } else {
                                        this.sale.holdType = null;
                                    }
                                });
                        } else {
                            let onHoldId = Object.keys(response.onHoldIds)[0];
                            this.setSaleOnHoldId(onHoldId, response.onHoldIds[onHoldId]);
                            if (this.hasPaymentAuthorization(response)) {
                                this.printVoidReceipts(response);
                            }
                            this.postProcessSelfPayment(isSelfPaymentAdd, response.selfPayments, onHoldId, selfPayTippyEligibility).then(() => {
                                if (!isSelfPaymentAdd) {
                                    this.reset();
                                }

                                if (this.promptToPrintHoldReceipt) {
                                    this.modalService.yellowConfirm('MESSAGE_PRINT_HOLD_RECEIPT', Components.Modal.ModalTranslationModes.Translate, false, undefined, true)
                                        .then(res => {
                                            if (res) {
                                                this.communicateWithPrinter(null, onHoldId).then(() => {
                                                    deferred.resolve(onHoldId);
                                                    this.checkMembershipOrigination();
                                                });
                                                return;
                                            }
                                            deferred.resolve(onHoldId);
                                            this.checkMembershipOrigination();
                                        })
                                    return;
                                }

                                deferred.resolve(onHoldId);
                                this.checkMembershipOrigination();
                            });
                        }
                    })
                    .catch(() => {
                        this.sale.suppressWarnings = false;
                        this.sale.holdType = null;
                        this.busyService.stop();
                        deferred.reject();
                    });

                this.dataService.trackUsage(Model.NounEnum.RegisterPage, Model.VerbEnum.SaleHoldButtonClicked, null);
            }

            let selfPayTippyEligibility: ISelfPayTippyEligibility = { pre: false, post: false, isUnauthorized: false, continueWithSelfPay: true };
            let unauthorizedConfig: Meevo.Plugins.Tippy.IUnauthorizedConfig;
            if (isSelfPaymentAdd || this.isPuttingOnSelfPaymentHold(isSelfPaymentAdd, this.sale.selfPayments)) {
                unauthorizedConfig = {
                    additionalMessage: "MESSAGE_TIPPY_UNAUTHORIZED_SELF_PAY",
                    modalType: Components.Modal.ModalTypeEnum.Confirm
                }
            }
            this.getSelfPayTippyEligibility(unauthorizedConfig)
                .then(resp => selfPayTippyEligibility = resp)
                .then(() => selfPayTippyEligibility.continueWithSelfPay || !isSelfPaymentAdd ? this.preProcessSelfPayments(isSelfPaymentAdd, this.sale.selfPayments, selfPayTippyEligibility.pre) : false)
                .then(preProcessResponse => {
                    if (preProcessResponse) {
                        if (isSelfPaymentAdd &&
                            this.selfPayDefaultTipPercentage > 0 &&
                            this.sale.tipAmount == null &&
                            this.sale.tipPercentage == null &&
                            this.subtractNormalizedNumbers(this.sale.tip, this.sale.totalPrepaidTipRedeemed) == 0
                        ) {
                            this.sale.tipPercentage = this.selfPayDefaultTipPercentage;
                            this.recalculateTip(this.sale).then(() => {
                                continueOnHold(selfPayTippyEligibility);
                            });
                        } else {
                            continueOnHold(selfPayTippyEligibility);
                        }
                    }
                    else {
                        this.sale.holdType = undefined;
                    }
                });
        }

        checkForItemSellPermission() {
            let keysToCheck: string[] = [
                this.meevoSecurityKeys.REGISTER_REGISTER_SERVICES_SELLSERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                this.meevoSecurityKeys.REGISTER_REGISTER_PRODUCTS_SELLRETAILPRODUCTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                this.meevoSecurityKeys.REGISTER_REGISTER_MEMBERSHIP_ACTION_SELLMEMBERSHIP,
                this.meevoSecurityKeys.REGISTER_REGISTER_PACKAGES_SELLPACKAGES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                this.meevoSecurityKeys.REGISTER_REGISTER_GIFTCARDS_SELLGIFTCARDS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_REFUNDACCOUNTCREDIT
            ];
            return this.securityService.checkAndCache(keysToCheck).then((response) => {
                let securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_SERVICES_SELLSERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                if (securityItem) {
                    this.sellServicePermission = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_PRODUCTS_SELLRETAILPRODUCTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                if (securityItem) {
                    this.sellProductPermission = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_MEMBERSHIP_ACTION_SELLMEMBERSHIP });
                if (securityItem) {
                    this.sellMembershipPermission = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_PACKAGES_SELLPACKAGES + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                if (securityItem) {
                    this.sellPackagePermission = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_GIFTCARDS_SELLGIFTCARDS + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                if (securityItem) {
                    this.sellGiftCardPermission = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
                if (!this.sellGiftCardPermission) {
                    securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_GIFTCARDS_SELLBULKGIFTCARDS + Meevo.Components.Common.SecurityParts.KEY_PART_READ });
                    if (securityItem) {
                        this.sellGiftCardPermission = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                    }
                }
                securityItem = _.findWhere(response, { key: this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_REFUNDACCOUNTCREDIT });
                if (securityItem) {
                    this.refundAccountCreditPermission = (securityItem.securityAccess === Meevo.Model.SecurityAccessEnum.Grant);
                }
            });
        }

        hasPaymentAuthorization(sale: Model.Sale): boolean {
            return _(sale.paymentLines).any(paymentLine => {
                return paymentLine.paymentCategory === Model.PaymentCategoryEnum.CreditDebit
                    && paymentLine.amount > 0
                    && (paymentLine as Model.SaleCreditCardPayment).paymentRequest
                    && (paymentLine as Model.SaleCreditCardPayment).paymentRequest.isAuthorization
            });
        }

        hasProjectedRefund(sale: Model.Sale): boolean {
            return _(sale.paymentLines).any(paymentLine => {
                return paymentLine.paymentCategory === Model.PaymentCategoryEnum.CreditDebit
                    && paymentLine.amount < 0
                    && (paymentLine as Model.SaleCreditCardPayment).paymentRequest
                    && (paymentLine as Model.SaleCreditCardPayment).paymentRequest.isAuthorization
            });
        }

        getRemainingAuthorizationReversalPaymentLines(sale: Model.Sale) {
            const isNonVoidedCreditCardPayment = (paymentLine: Model.SalePayment) => {
                const creditPaymentLine = paymentLine as Model.SaleCreditCardPayment;
                return paymentLine.paymentCategory === Model.PaymentCategoryEnum.CreditDebit
                    && creditPaymentLine
                    && creditPaymentLine.paymentRequest
                    && creditPaymentLine.paymentRequest.amount > 0
                    && !creditPaymentLine.paymentRequest.paymentRequestVoidStatus;
            };

            const isNotProjectedRefund = (paymentLine: Model.SalePayment) => {
                const creditPaymentLine = paymentLine as Model.SaleCreditCardPayment;
                return paymentLine.paymentCategory === Model.PaymentCategoryEnum.CreditDebit
                    && creditPaymentLine
                    && creditPaymentLine.paymentRequest
                    && creditPaymentLine.paymentRequest.amount < 0
                    && !creditPaymentLine.paymentRequest.isAuthorization;
            };

            return sale.paymentLines.filter((paymentLine: Model.SalePayment) => 
                paymentLine.paymentSubCategory === Model.PaymentSubCategoryEnum.DepositCharge ||
                isNonVoidedCreditCardPayment(paymentLine) ||
                isNotProjectedRefund(paymentLine)
            );
        }

        private cleanupMeevoTips(sale: Model.Sale) {            
            sale.externalTipTransactionId = null;
            sale.externalTips = null;
            for (const tipLine of sale.tipLines) {
                if (!tipLine.isRefund) {
                    tipLine.externalTipTransactionId = null;
                    tipLine.externalAmount = 0;
                    tipLine.convenienceFee = 0;
                }
            }
            sale.tipConvenienceFee = 0;
        }

        backToSaleRecalc(): ng.IPromise<boolean> {
            if (this.hasPaymentAuthorization(this.sale) || this.hasProjectedRefund(this.sale)) {
                return this.modalService.yellowConfirm("MESSAGE_BACK_TO_SALE_AUTHORIZED_PAYMENT").then(() => {
                    if (this.hasProjectedRefund(this.sale)) {
                        const refundPaymentLine = this.sale.paymentLines.find(paymentLine => paymentLine.paymentRequest.amount < 0 && paymentLine.paymentRequest.isAuthorization);
                        this.removePaymentLine(refundPaymentLine);
                    }                        
                        
                    if (this.hasPaymentAuthorization(this.sale)) {
                        this.busyService.start();
                        return this.dataService.add("drawer", this.sale, new Guid(this.selectedDrawer.id), "sale")
                            .then((response: Model.Sale) => {
                                this.printVoidReceipts(response);
                                this.sale.paymentLines = this.getRemainingAuthorizationReversalPaymentLines(response);
                                return true;
                            }).finally(() => {
                                this.cleanupMeevoTips(this.sale);
                                this.busyService.stop();
                            });
                    } 

                    this.cleanupMeevoTips(this.sale);
                    return true;
                }).catch(() => {
                    const section = this.selectedSection.sectionType === RegisterSectionTypeEnum.ChangeOptions 
                        ? RegisterSectionTypeEnum.ChangeOptions
                        : RegisterSectionTypeEnum.PaymentOptions;

                    this.selectSection(section).finally(() => {
                        this.finishSection();
                    });
                    return false;
                });
            }
            else {
                this.cleanupMeevoTips(this.sale);
                return this.$q.resolve(true);
            }
        }

        backToSale() {
            this.sale.saleStage = Model.SaleStageEnum.Initial;

            this.backToSaleRecalc().then(proceed => {
                if (!proceed) {
                    return;
                }

                this.updatePoleDisplay(this.getBalanceDue() > 0);

                if (!this.isRefundMode) {
                    this.tippyService.updateTipConvenienceFee(this.sale, this, 0);
                    this.tippyService.deleteTransaction(this.sale);
                    if (this.isBackToSaleVisible()) {
                        this.selectSectionServices(false);
                    }
                    return;
                }

                this.isRefundMode = false;
                this.hideCheckoutButtons = false;

                switch (this.selectedSection.sectionType) {
                    case RegisterSectionTypeEnum.Tips:
                    case RegisterSectionTypeEnum.PaymentPlan:
                        this.selectSection(RegisterSectionTypeEnum.Services);
                        return;

                    case RegisterSectionTypeEnum.Services:
                    case RegisterSectionTypeEnum.Products:
                    case RegisterSectionTypeEnum.GiftCard:
                    case RegisterSectionTypeEnum.Memberships:
                    case RegisterSectionTypeEnum.Package:
                    case RegisterSectionTypeEnum.ClientAccounts:
                        this.selectedSection.reset();
                        break;

                    case RegisterSectionTypeEnum.RefundOptions:
                        this.selectTicketSection(true);
                        break;
                }
            });
        }

        refund() {
            if (this.registerTicketService.isPastTransactionMode) {
                this.modalService.alert('MESSAGE_NO_REFUND_IN_HISTORY_MODE');
                return;
            }

            this.selectSection(RegisterSectionTypeEnum.RefundOptions, true, true);
        }

        onHold(isSelfPaymentAdd: boolean = false) {
            let deferred = this.$q.defer();

            if (this.hasPendingPayment()) {
                this.modalService.alert("MESSAGE_PAYMENT_BEING_PROCESSED");
                deferred.reject();
                return deferred.promise;
            }

            this.checkSectionIsDirty().then(() => {
                const promise = this.hasPaymentAuthorization(this.sale) || this.hasProjectedRefund(this.sale) 
                    ? this.modalService.yellowConfirm("MESSAGE_PLACE_ON_HOLD_SALE_AUTHORIZED_PAYMENT") 
                    : this.$q.resolve(true);

                promise.then(() => {
                    this.sale.holdType = Model.HoldTypeEnum.Register;
                    this._onHold(deferred, isSelfPaymentAdd);
                }).catch(() => {
                    if (this.selectedSection.sectionType !== RegisterSectionTypeEnum.ChangeOptions) {
                        this.selectSection(RegisterSectionTypeEnum.PaymentOptions);
                    }
                    deferred.reject();
                });
            }).catch(() => {
                deferred.reject();
            });

            return deferred.promise;
        }

        openDrawerManager() {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_DRAWER_MANAGER, {
                name: this.appSettings.ROUTE_NAMES.drawerManager,
                fromRegister: true,
                registerContext: this,
            });
            this.showDrawerManager = true;
        }

        closeDrawerManager() {
            this.showDrawerManager = false;
            if (!this.selectedSection) {
                if ((device.mobile() || (device.tablet() && device.portrait() && !device.largeTablet())) && this.isDirty()) {
                    this.selectSection(RegisterSectionTypeEnum.Ticket);
                } else {
                    this.selectSection(RegisterSectionTypeEnum.Client);
                }

            }
        }

        communicateWithPrinter(excludeSaleLineIds: Number[] = null, saleHoldId: string = null): ng.IPromise<any> {
            if (!this.transactionId && !saleHoldId) {
                return this.$q.resolve();
            }

            var labelPaymentCheck = this.$translate.instant("LABEL_PAYMENT_TYPE_2279");
            var localeDictionary = {};
            var method = "GET";
            if (labelPaymentCheck != "LABEL_PAYMENT_TYPE_2279") {
                localeDictionary = {
                    "LABEL_PAYMENT_TYPE_2279": labelPaymentCheck
                };
                method = "POST";
            }
            const receiptUrls = [];
            if (!saleHoldId) {
                receiptUrls.push({
                    url: `/api/Sale/${this.transactionId}/Receipt`,
                    method: method,
                    data: {
                        localeDictionary: localeDictionary,
                    },
                    params: {
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                        numberItemizedReceiptsToPrint: this.selectedDrawer.numberItemizedReceiptsToPrint
                    }
                });
            } else {
                receiptUrls.push({
                    url: `/api/SaleHold/${saleHoldId}/Receipt`,
                    method: 'GET',
                    data: {
                        localeDictionary: localeDictionary,
                    },
                    params: {
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                        numberItemizedReceiptsToPrint: 1
                    }
                });
            }

            if (!saleHoldId && this.isIncludeGiftReceipt) {
                receiptUrls.push({
                    url: `/api/Sale/${this.transactionId}/GiftReceipt`,
                    method: "POST",
                    params: {
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                        excludeSaleLineIds: excludeSaleLineIds
                    }
                });
            }

            return this.printService.printCustom(...receiptUrls);
        }

        private generateClientCreditCardReceiptRequest(
            receiptRequests: Meevo.Components.Common.IHttpRequestObject[],
            paymentRequestId: string,
            isVoid: boolean = false,
            drawerId: string = undefined,
            paymentRequest: Meevo.Model.PaymentRequest = undefined
        ) {
            receiptRequests.push({
                url: isVoid
                    ? `/api/paymentRequest/${paymentRequestId}/clientCreditCardVoidReceipt`
                    : `/api/paymentRequest/${paymentRequestId}/clientCreditCardReceipt`,
                method: !!paymentRequest ? "POST" : "GET",
                params: {
                    id: paymentRequestId,
                    originalPaymentRequest: paymentRequest,
                    locale: this.appSettings.APP_COUNTRYID,
                    timeFormat: this.appSettings.APP_TIME_FORMAT,
                    drawerId: drawerId,
                }
            } as Meevo.Components.Common.IHttpRequestObject);
        }

        private generateMerchantCreditCardReceiptRequest(
            receiptRequests: Meevo.Components.Common.IHttpRequestObject[],
            paymentRequestId: string,
            isVoid: boolean = false,
            drawerId: string = undefined,
            paymentRequest: Meevo.Model.PaymentRequest = undefined
        ) {
            if (this.disablePrintingOfMerchantCreditCardReceipt) {
                return;
            }

            receiptRequests.push({
                url: isVoid
                    ? `/api/paymentRequest/${paymentRequestId}/merchantCreditCardVoidReceipt`
                    : `/api/paymentRequest/${paymentRequestId}/merchantCreditCardReceipt`,
                method: !!paymentRequest ? "POST" : "GET",
                params: {
                    id: paymentRequestId,
                    originalPaymentRequest: paymentRequest,
                    locale: this.appSettings.APP_COUNTRYID,
                    timeFormat: this.appSettings.APP_TIME_FORMAT,
                    drawerId: drawerId,
                }
            } as Meevo.Components.Common.IHttpRequestObject);
        }

        printCreditCardReceipts(paymentRequests: Model.PaymentRequest[], isVoid: boolean = false, printClientReceipt: boolean = null,
            receiptRequests: Meevo.Components.Common.IHttpRequestObject[] = undefined) {

            if (this.disablePrintingOfMerchantCreditCardReceipt) {
                return this.$q.resolve();
            }

            receiptRequests = receiptRequests || [];

            for (const paymentRequest of paymentRequests) {
                // nothing to print for temporary refund authorization
                if (paymentRequest.amount < 0 && paymentRequest.isAuthorization) {
                    continue;
                }

                if (isVoid || printClientReceipt === false) {
                    if (isVoid) {
                        // When voiding print original client credit card sale receipt along with void receipt
                        this.generateClientCreditCardReceiptRequest(receiptRequests, paymentRequest.id, false, this.selectedDrawer.id);
                    }

                    this.generateClientCreditCardReceiptRequest(receiptRequests, paymentRequest.id, isVoid, this.selectedDrawer.id);
                }

                this.generateMerchantCreditCardReceiptRequest(receiptRequests, paymentRequest.id, isVoid, this.selectedDrawer.id);
            }

            if (receiptRequests.length === 0) {
                return this.$q.resolve();
            }

            try {
                return this.printService.printCustom(...receiptRequests);
            } catch (ex) {
                console.error(ex);
                // do not show error for credit card receipts
                return this.$q.reject();
            }
        }

        printCreditCardReceiptsWithData(paymentRequests: Model.PaymentRequest[], isVoid: boolean = false) {
            if (this.disablePrintingOfMerchantCreditCardReceipt) {
                return this.$q.resolve();
            }

            var receiptRequests: Meevo.Components.Common.IHttpRequestObject[] = [];

            for (const paymentRequest of paymentRequests) {
                if (!this.disablePrintingOfMerchantCreditCardReceipt) {
                    this.generateMerchantCreditCardReceiptRequest(receiptRequests, paymentRequest.id, isVoid, undefined, paymentRequest);
                }

                if (isVoid) {
                    this.generateClientCreditCardReceiptRequest(receiptRequests, paymentRequest.id, isVoid, undefined, paymentRequest);
                }
            }

            try {
                return this.printService.printCustom(...receiptRequests);
            }
            catch (ex) {
                console.log(ex);
                // do not show error for credit card receipts
                return this.$q.reject();
            }
        }

        isEmployeeHouseEmployee(employee): boolean {
            return employee
                ? employee.displayName === this.HouseEmployee.displayName && (!employee.id || employee.id === Guid.empty.toString())
                : false;
        }

        isLoggedInEmployee(employee): boolean {
            return employee
                ? employee.id === this.identityService.current().userId
                : false;
        }

        employeeSelectionClass(employee): string {
            return employee
                ? (this.isEmployeeHouseEmployee(employee)
                    ? "house-employee"
                    : this.isLoggedInEmployee(employee)
                        ? "loggedin-employee"
                        : ""
                )
                : "";
        }

        employeeSelectionIcon(employee): string {
            const url = employee
                ? this.isEmployeeHouseEmployee(employee)
                    ? "changeloc_home.svg"
                    : this.isLoggedInEmployee(employee)
                        ? "loggedin_employeephoto.svg"
                        : "walkin_employeephoto.svg"
                : "walkin_employeephoto.svg";

            return `assets/images/icons/${url}`;
        }

        setLoggedInEmployee(employees) {
            var loggedInEmployee: Model.EmployeeListItem = _.findWhere(employees, { id: this.identityService.current().userId });
            if (loggedInEmployee && employees.length > 1) {
                loggedInEmployee.applyStyle = "meevo-typeahead-item-bold";
                employees.splice(employees.indexOf(loggedInEmployee), 1);
                employees.splice(1, 0, loggedInEmployee);
            }
        }

        isHouseEmployeeMatched(filter: string, employeeEntityType?: Model.EmployeeEntityTypeEnum): boolean {
            var isMatched = (filter.length == 0);
            if (!isMatched) {
                var pattern = filter.replace("_", ".").replace("%", "");
                var re = new RegExp(pattern, "i");
                isMatched = re.test((!employeeEntityType || employeeEntityType == Model.EmployeeEntityTypeEnum.Employee) ?
                    this.HouseEmployee.displayName : this.UnspecifiedEmployee.displayName)
                    || ((!employeeEntityType || employeeEntityType == Model.EmployeeEntityTypeEnum.Employee) ? re.test(this.HouseEmployee.code) : false);
            }
            return isMatched;
        }

        employeeTypeAheadPreProcessData(responseData, requestData, isSecondEmployee = false, otherEmployee = null, otherEmployees = null): any[] {
            if (requestData.pageNumber == 0) {
                if (this.isHouseEmployeeMatched(requestData.criteria.filter) &&
                    !this.isEmployeeHouseEmployee(otherEmployee) &&
                    _(otherEmployees).all(employee => !this.isEmployeeHouseEmployee(employee)) &&
                    (isSecondEmployee || !otherEmployee)) {
                    responseData.splice(0, 0, this.HouseEmployee);
                }
                this.setLoggedInEmployee(responseData);

                return responseData;
            }
        }

        normalizeNumber(value: number): number {
            return this.roundingService.normalizeNumber(value);
        }

        normalizeDecimalPlaces(value: number) {
            return this.roundingService.normalizeDecimalPlaces(value);
        }

        subtractNormalizedNumbers(value1: number, value2: number): number {
            return this.roundingService.subtractNormalizedNumbers(value1, value2);
        }

        addNormalizedNumbers(value1: number, value2: number): number {
            return this.roundingService.addNormalizedNumbers(value1, value2);
        }

        performOperationOnNormalizedNumbers(value1: number, value2: number, op: Function): number {
            return this.roundingService.performOperationOnNormalizedNumbers(value1, value2, op);
        }

        isDiscountable(saleLine: Model.SaleLine): boolean {
            return this.registerDiscountService.isDiscountable(saleLine);
        }

        canApplyDiscount(saleLine: Model.SaleLine): boolean {
            return this.registerDiscountService.canApplyDiscount(saleLine);
        }

        addDiscount(saleLine: Model.SaleLine) {
            this.registerDiscountService.addDiscount(this, saleLine);
        }

        editDiscount(saleLine, discountItem) {
            this.registerDiscountService.editDiscount(this, saleLine, discountItem);
        }

        showPromotionalGiftCards(cardId?: string) {
            const promoSection = <PromotionalGiftCardsSection>_.findWhere(this.sections, { sectionType: RegisterSectionTypeEnum.PromotionalGiftCard });
            if (promoSection) {
                promoSection.preselectGiftCardId = cardId;
            }
            this.selectSection(RegisterSectionTypeEnum.PromotionalGiftCard);
        }

        public refundTypeList = [{
            refundTypeEnum: Meevo.Plugins.Register.RefundTypes.History,
            label: 'LABEL_HISTORY'
        }, {
            refundTypeEnum: Meevo.Plugins.Register.RefundTypes.Manual,
            label: 'LABEL_MANUAL'
        }];

        isDiscountRemovable(discountItem: Model.DiscountLine): boolean {
            return this.registerDiscountService.isDiscountRemovable(discountItem);
        }

        getDiscountName(discountItem: Model.DiscountLine): string {
            return this.registerDiscountService.getDiscountName(discountItem);
        }

        getDiscountValue(discountItem: Model.DiscountLine) {
            return this.registerDiscountService.getDiscountValue(discountItem);
        }

        removeDiscountItem(saleLine: Model.SaleLine, discountLineIndex: number) {
            return this.registerDiscountService.removeDiscountItem(this, saleLine, discountLineIndex);
        }

        public getSecurityKeyForApplyDiscount(saleLine: Model.SaleLine) {
            return this.registerDiscountService.getSecurityKeyForApplyDiscount(saleLine);
        }

        public getSecurityKeyForPrice(saleLine: Model.SaleLine) {
            if (!saleLine.isRefund) {
                if (saleLine.saleType === Model.SalesTypeEnum.Membership) {
                    return this.meevoSecurityKeys.REGISTER_REGISTER_MEMBERSHIP_APPLYDISCOUNT;
                }
                else if (saleLine.saleType === Model.SalesTypeEnum.GiftCard) {
                    return this.giftCardPriceKey;
                }
                else {
                    return this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_ALTERPRICINGWITHOUTDISCOUNT;
                }
            }
            else if (this.isSaleLineAService(saleLine)) {
                return Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_REFUNDSERVICEAMOUNTWRITE;
            }
            else if (saleLine.saleType === Model.SalesTypeEnum.Product) {
                return Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_REFUNDPRODUCTAMOUNTWRITE;
            }
            else {
                return Components.Common.SecurityKeys.REGISTER;
            }
        }

        public getSecurityKeyForValue(saleLine: Model.SaleLine) {
            if (saleLine.saleType === Model.SalesTypeEnum.GiftCard && (saleLine.item as GiftCardSaleLineItem).clientGiftCard.giftCardTypeId != undefined) {
                return this.meevoSecurityKeys.REGISTER_REGISTER_GIFTCARD_GIFTCARDTYPE;
            } else {
                return this.meevoSecurityKeys.REGISTER;
            }
        }

        public getSecurityKeyGiftCardType(giftCardType) {
            if ((giftCardType.displayName).toLowerCase() != "standard") {
                return this.meevoSecurityKeys.REGISTER_REGISTER_GIFTCARD_GIFTCARDTYPE;
            } else {
                return this.meevoSecurityKeys.REGISTER;
            }
        }

        public giftCardTypeChanged(giftCardTypeId) {
            this.isStandard = (giftCardTypeId == undefined);
        }

        public openClientPoints(client) {
            this.goToState("clientPoint", Meevo.Model.MaintenanceFormState.Readonly, client.getId(), "SECTION_MAIN", undefined, client.getDisplayName());
        }

        public openClient(client, clientAlertType, clientCallback) {
            if (this.securityService.hasSecurity(this.meevoSecurityKeys.DATA_CLIENT + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.goToState("client", Meevo.Model.MaintenanceFormState.Editing, client.id, "SECTION_CLIENT_MAIN", clientCallback, client.displayName, undefined, clientAlertType);
            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
        }

        public openClientAccount(client) {
            this.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, client.getId(), "SECTION_HISTORY", undefined, client.getDisplayName(), "ACCOUNT_HISTORY");
        }

        public openGiftCardHistory(client) {
            this.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, client.getId(), "SECTION_HISTORY", undefined, client.getDisplayName(), "GIFTCARD_HISTORY");
        }

        public openPackageHistory(client) {
            this.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, client.getId(), "SECTION_HISTORY", undefined, client.getDisplayName(), "PACKAGE_HISTORY");
        }

        public openMembershipManager(client) {
            this.goToState("membershipManager", Meevo.Model.MaintenanceFormState.Readonly, client.client.clientMembershipId, "SECTION_MEMBERSHIPMANAGER_MAIN", undefined);
        }

        public openCancelledOrNoShowAppointmentHistory(client) {
            this.goToState("client", Meevo.Model.MaintenanceFormState.Readonly, client.getId(), "SECTION_HISTORY", undefined, client.getDisplayName(), "APPOINTMENT_HISTORY", null, false, Meevo.Plugins.Client.ClientAppointmentHistoryFilterType.NoShowAndCancelled);
        }

        private goToState(
            stateName: string,
            actionState,
            id: any = undefined,
            initialSection = "Main",
            callback = undefined,
            clientDisplayName = null,
            initialSubSection: string | null = null,
            clientAlertType = null,
            refresh: boolean = false,
            filter: number = undefined) {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: stateName,
                stateParams: {
                    callback: callback,
                    callbackState: "register",
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: actionState,
                    id: id,
                    initialEditSection: initialSection,
                    initialEditSubSection: initialSubSection,
                    clientDisplayName: clientDisplayName,
                    refresh: refresh,
                    filter: filter
                },
                clientAlertType: clientAlertType
            });
        }

        classForPackageIcon(saleLine: Model.SaleLine) {
            let className = "";
            const packageRedemptionType = saleLine.packageRedemptionType;

            if (packageRedemptionType === Model.PackageRedemptionTypeEnum.ExactMatch) {
                className = "exact-match";
            }
            else if (packageRedemptionType === Model.PackageRedemptionTypeEnum.Swap) {
                className = "swaps";
            }
            else if (packageRedemptionType === Model.PackageRedemptionTypeEnum.Split) {
                className = "split";
            }
            else if (packageRedemptionType === Model.PackageRedemptionTypeEnum.Merge) {
                className = "merge";
            }

            const serviceSaleLineItem = (<Model.ServiceSaleLineItem>saleLine.item);
            const hasFlatFee = serviceSaleLineItem
                && serviceSaleLineItem.productUsage
                && serviceSaleLineItem.productUsage.hasFlatFeeProductUsage;
            if (!!hasFlatFee && this.hasPUTPackageRedemptionPath(saleLine)) {
                className += " disabled-icon";
            }

            return className;
        }

        productUsage(saleLine: Model.SaleLine) {
            this.selectSection(RegisterSectionTypeEnum.ProductUsage).then(() => {
                (this.selectedSection as ProductUsageSection).initialize(saleLine);
            });
        }

        isProductUsageIconVisible(saleLine: Model.SaleLine): boolean {
            if (!saleLine || !saleLine.item || !saleLine.item.productUsage) {
                return false;
            }
            if (saleLine.item.productUsage.variants && saleLine.item.productUsage.variants.length > 0) {
                return true;
            }
            if (!this.hasProductUsageVariantsToAddRequested) {
                this.hasProductUsageVariantsToAddRequested = true;

                const request = {
                    criteria: {
                        enableProductUsageTracking: true,
                        includeNotForSale: true,
                        explicitProductInventoryTypes: [
                            Meevo.Model.ProductInventoryTypeEnum.ShopSupply,
                            Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply
                        ],
                    }
                };

                this.dataService.customMethodData("api/productVariant/count", "post", request).then((response) => {
                    this.hasProductUsageVariantsToAdd = response.data > 0;
                });
            }
            return this.hasProductUsageVariantsToAdd;
        }

        hasUnredeemedRemptionPath(saleLine: Model.SaleLine) {
            if (!saleLine.packageRedemptionPath) {
                return false;
            }

            if (saleLine.redeemedPackages && saleLine.redeemedPackages.length > 0) {
                return false;
            }
            return true;
        }

        hasPUTPackageRedemptionPath(saleLine: Model.SaleLine) {
            return saleLine.packageRedemptionPath.clientPackagesUsed &&
                saleLine.packageRedemptionPath.clientPackagesUsed
                    .filter(clientPackage => clientPackage.category === Model.PackageTypeCategoryEnum.ProductUsageTracking)
                    .length > 0;
        }

        showPackageRedemptionIcon(saleLine: Model.SaleLine, isExpired: boolean) {
            if (!this.hasUnredeemedRemptionPath(saleLine))
            {
                return false;
            }

            if (this.hasPUTPackageRedemptionPath(saleLine)) {
                if (isExpired) {
                    return false;
                }

                if (!saleLine.packageRedemptionPath.usesAvailablePackage &&
                    saleLine.packageRedemptionPath.usesExpiredPackage &&
                    this.redeemExpiredPackagesSecurityItem.securityAccess === Model.SecurityAccessEnum.Hide) {
                    return false;
                }

                return saleLine.packageRedemptionPath.usesAvailablePackage ||
                    saleLine.packageRedemptionPath.usesExpiredPackage;
            }
            else {
                return isExpired ? saleLine.packageRedemptionPath.usesExpiredPackage :
                    !saleLine.packageRedemptionPath.usesExpiredPackage;
            }
        }

        redeemPackage(sale: Model.Sale, saleLine: Model.SaleLine) {
            let redeemExpired = false;
            const redeemsExpiredPackage = saleLine.packageRedemptionPath.usesExpiredPackage;
            const secItem = this.redeemExpiredPackagesSecurityItem;
            const isGrant = (secItem.securityAccess == Model.SecurityAccessEnum.Grant);
            const isDeny = (secItem.securityAccess == Model.SecurityAccessEnum.Deny);
            const canElevate = !!secItem.canElevate;
            const shouldPrompt = redeemsExpiredPackage && (isGrant || (isDeny && canElevate));

            const doRedemption = () => {
                var redemptionPath = saleLine.packageRedemptionPath;
                if (saleLine.packageRedemptionType === Model.PackageRedemptionTypeEnum.ExactMatch
                    || (saleLine.packageRedemptionType === Model.PackageRedemptionTypeEnum.Swap && !redemptionPath.createsMerge && !redemptionPath.createsSplit)) {
                    saleLine.packageRedeemed = true;
                    saleLine.packageRedemptionPath.usesExpiredPackage = redeemExpired;
                    if (this.selectedSection.sectionType === RegisterSectionTypeEnum.ProductUsage)
                    {
                        this.selectedSection.delete(saleLine);
                    }
                    this.recalculateSale()
                        .catch(() => {
                            saleLine.packageRedeemed = false;
                        })
                        .finally(() => {
                            this.registerDiscountService.resetDiscounts(this);
                        });
                }
                else {
                    // need to show split/merge/swap detail section
                    this.selectSection(RegisterSectionTypeEnum.PackageRedemption).then(() => {
                        (this.selectedSection as PackageRedemptionSection).initialize(sale, saleLine);
                    });
                }
            };

            const serviceSaleLineItem = (<Model.ServiceSaleLineItem>saleLine.item);
            const hasFlatFee = serviceSaleLineItem
                && serviceSaleLineItem.productUsage
                && serviceSaleLineItem.productUsage.hasFlatFeeProductUsage;
            if (!!hasFlatFee && this.hasPUTPackageRedemptionPath(saleLine)) {
                this.modalService.alert("MESSAGE_SERVICE_INCLUDES_FLAT_FEE_PRODUCT_USAGE");
                return;
            }

            if (this.hasPUTPackageRedemptionPath(saleLine) && this.hasPendingUsageLot(saleLine)) {
                this.modalService.alert("MESSAGE_REGISTER_PRODUCT_USAGE_LOT_REQUIRED_BEFORE_REDEMPTION");
                return;
            }

            if (shouldPrompt) {
                this.modalService.yellowConfirm("MESSAGE_SHOULD_REDEEM_EXPIRED_PACKAGE")
                    .then(() => {
                        redeemExpired = true;
                    })
                    .catch(() => {
                        redeemExpired = false;
                    })
                    .finally(() => {
                        if (redeemExpired && isDeny && canElevate) {
                            let deferred = this.$q.defer();
                            deferred.promise.then(() => {
                                redeemExpired = true;
                            }).catch(() => {
                                redeemExpired = false;
                            }).finally(() => {
                                doRedemption();
                            });
                            this.$rootScope.$emit(
                                Meevo.Components.Common.Messages.ELEVATION_CHALLENGE,
                                deferred,
                                secItem.key.replace(/:/gi, '_'),
                                secItem.displayName,
                                this.identityService.current().userName,
                                secItem.securityKeyPath
                            );
                        }
                        else {
                            doRedemption();
                        }
                    });
            }
            else {
                doRedemption();
            }
        }

        removePackageRedemption(saleLine: Model.SaleLine, recalculate: boolean = true, sale?: Model.Sale) {
            sale = sale || this.sale;
            saleLine.packageRedeemed = false;
            saleLine.prepaidTipRedeemed = 0;

            if (saleLine.item.productUsage && saleLine.item.productUsage.preRedemptionUsageSnapshot) {
                saleLine.item.productUsage = saleLine.item.productUsage.preRedemptionUsageSnapshot;
                saleLine.item.productUsage.preRedemptionUsageSnapshot = null;
            }
            const redeemPackageSplitLineIndex = this.getRedeemPackageSplitLineIndex(saleLine, sale);
            if (redeemPackageSplitLineIndex >= 0) {
                sale.saleLines.splice(redeemPackageSplitLineIndex, 1);
            }

            // find swap fee sale lines "tied" to this sale line and remove them too
            if (saleLine.packageRedemptionPath && saleLine.packageRedemptionPath.totalSwapFee > 0) {
                var swapFeeSaleLineIndex = -1;
                while ((swapFeeSaleLineIndex = _.findIndex(this.sale.saleLines, (sl) => {
                    return (sl.saleType === Model.SalesTypeEnum.PackageServiceSwapFee
                        && _.find(saleLine.redeemedPackages, (cp) => {
                            return _.findWhere(cp.packageServices, { id: (sl.item as Model.PackageServiceSwapFeeSaleLineItem).clientPackageServiceId }) != null;
                        }));
                })) != -1) {
                    sale.saleLines.splice(swapFeeSaleLineIndex, 1);
                }
            }

            this.registerTipService.calculatePrepaidTipMinimums(this, this.sale.tipLines, this.sale.saleLines);

            if (recalculate) {
                this.recalculateSale(false, null, false, sale).finally(() => {
                    this.registerDiscountService.resetDiscounts(this);
                });
            } else {
                this.registerDiscountService.resetDiscounts(this);
            }
        }

        splitSaleLine(saleLine: Model.SaleLine, count: number) {
            var newSaleLine: Model.SaleLine = null;
            if (count > 0 && count < saleLine.quantity) {
                newSaleLine = {
                    appointmentId: saleLine.appointmentId,
                    baseItemPrice: saleLine.baseItemPrice,
                    clientId: saleLine.clientId,
                    clientType: saleLine.clientType,
                    employeeId: saleLine.employeeId,
                    finalItemPrice: saleLine.finalItemPrice,
                    finalPrice: saleLine.finalPrice,
                    isDirty: true,
                    isExpanded: false,
                    isNew: saleLine.isNew,
                    packageRedeemed: saleLine.packageRedeemed,
                    packageRedemptionType: saleLine.packageRedemptionType,
                    prepaidTip: saleLine.prepaidTip,
                    price: saleLine.price,
                    saleType: saleLine.saleType,
                    quantity: saleLine.quantity - count,
                    quantityRequired: saleLine.quantityRequired,
                    quantitySelected: saleLine.quantitySelected,
                    client: _.clone(saleLine.client),
                    employee: _.clone(saleLine.employee),
                    item: _.clone(saleLine.item),
                    isRefund: saleLine.isRefund,
                    showPoleMessage: saleLine.showPoleMessage
                };
                if (saleLine.discountLines) {
                    newSaleLine.discountLines = [];
                    saleLine.discountLines.forEach((item) => {
                        newSaleLine.discountLines.push(_.clone(item));
                    });
                }
                if (saleLine.redeemedPackages) {
                    saleLine.redeemedPackages.forEach((item) => {
                        newSaleLine.redeemedPackages.push(_.clone(item));
                    });
                }
                /*
                NOTE: Don't need to copy the taxes since we will have to recalculate after a split
                newSaleLine.taxes;
                */

                var ndx = _.findIndex(this.sale.saleLines, (item) => { return (item === saleLine); });
                saleLine.quantity = count;
                this.sale.saleLines.splice(ndx + 1, 0, newSaleLine);
            }
            return newSaleLine;
        }

        sectionHasItems(sectionType) {
            var section = _(this.sections).findWhere({ sectionType: sectionType });
            return !section ? false : section.hasItems();
        }

        isPriceDiscounted(saleLine: Model.SaleLine) {
            return this.registerDiscountService.isPriceDiscounted(this, saleLine);
        }

        private updateSaleLineItem(saleType, refundSaleLine, saleLine) {
            let saleLineItem = {
                displayName: saleLine.itemDisplayName || (saleLine.item ? saleLine.item.displayName : ""),
                shortcut: saleLine.item ? saleLine.item.shortcut : "",
                id: saleLine.itemId || (saleLine.item ? saleLine.item.id : ""),
                sku: saleLine.item ? saleLine.item.sku : "",
            };

            switch (saleType) {
                case Model.SalesTypeEnum.Service:
                case Model.SalesTypeEnum.ServiceCancellationFee:
                case Model.SalesTypeEnum.ServiceNoShowFee:
                    var serviceRefundSaleLineItem = new Meevo.Plugins.Register.ServiceSaleLineItem(saleLineItem);
                    var serviceSaleLineItem = <ServiceSaleLineItem>saleLine.item;
                    serviceRefundSaleLineItem.usedClientPackageServiceId = serviceSaleLineItem.usedClientPackageServiceId;
                    serviceRefundSaleLineItem.usedClientPackageId = serviceSaleLineItem.usedClientPackageId;
                    if (refundSaleLine.item) {
                        serviceRefundSaleLineItem.refundClientPackageId = refundSaleLine.item.refundClientPackageId;
                    }
                    serviceRefundSaleLineItem.isRefundClientPackage = serviceSaleLineItem.isRefundClientPackage;
                    refundSaleLine.item = serviceRefundSaleLineItem;
                    break;

                case Model.SalesTypeEnum.Package:
                    refundSaleLine.item = saleLine.item;
                    break;

                case Model.SalesTypeEnum.PackageTransfer:
                    var clientPackageTransferSaleLineItem = new Meevo.Plugins.Register.ClientPackageTransferSaleLineItem(saleLineItem);
                    var packageServices = [];
                    var packageProducts = [];
                    if (saleLine.item.usedClientPackageServiceId) {
                        packageServices = [{
                            clientPackageId: saleLine.item.usedClientPackageId,
                            id: saleLine.item.usedClientPackageServiceId,
                            serviceId: saleLine.itemId,
                            serviceDisplayName: saleLine.itemDisplayName,
                        }]
                    } else {
                        packageProducts = [{
                            clientPackageId: saleLine.item.usedClientPackageId,
                            id: saleLine.item.usedClientPackageProductId,
                            productVariantId: saleLine.itemId,
                            productVariantDisplayName: saleLine.itemDisplayName,
                        }]
                    }
                    clientPackageTransferSaleLineItem.clientPackage = {
                        id: saleLine.item.usedClientPackageId,
                        packageServices: packageServices,
                        packageProducts: packageProducts
                    };
                    refundSaleLine.item = clientPackageTransferSaleLineItem;
                    break;

                case Model.SalesTypeEnum.Membership:
                    var membershipSaleLineItem = new Meevo.Plugins.Register.MembershipSaleLineItem(saleLineItem);
                    membershipSaleLineItem.isTaxExempt = (<MembershipSaleLineItem>saleLine.item).isTaxExempt;
                    membershipSaleLineItem.membershipNumber = (<MembershipSaleLineItem>saleLine.item).membershipNumber;
                    membershipSaleLineItem.clientPackages = (<MembershipSaleLineItem>saleLine.item).clientPackages;
                    if (saleLine.item) {
                        refundSaleLine.finalPrice = refundSaleLine.finalItemPrice = saleLine.item.enrollmentFee;
                    }
                    refundSaleLine.item = membershipSaleLineItem;
                    break;

                case Model.SalesTypeEnum.MembershipPayment:
                    var membershipPaymentSaleLineItem = new Meevo.Plugins.Register.MembershipPaymentSaleLineItem(saleLineItem);
                    membershipPaymentSaleLineItem.clientMembershipBillFeeType = (<MembershipPaymentSaleLineItem>saleLine.item).clientMembershipBillFeeType;
                    membershipPaymentSaleLineItem.clientMembershipBillStatus = (<MembershipPaymentSaleLineItem>saleLine.item).clientMembershipBillStatus;
                    membershipPaymentSaleLineItem.freezeSetting = (<MembershipPaymentSaleLineItem>saleLine.item).freezeSetting;
                    membershipPaymentSaleLineItem.clientMembershipId = (<MembershipPaymentSaleLineItem>saleLine.item).clientMembershipId;
                    membershipPaymentSaleLineItem.isTaxExempt = (<MembershipPaymentSaleLineItem>saleLine.item).isTaxExempt;
                    refundSaleLine.item = membershipPaymentSaleLineItem;
                    break;

                case Model.SalesTypeEnum.Product:
                    let productSaleLineItem = new Meevo.Plugins.Register.ProductSaleLineItem(saleLineItem);
                    productSaleLineItem.productId = saleLine.item.productId;
                    productSaleLineItem.isResell = saleLine.item.isResell;
                    productSaleLineItem.usedClientPackageProductId = saleLine.item.usedClientPackageProductId;
                    productSaleLineItem.usedClientPackageId = saleLine.item.usedClientPackageId;
                    productSaleLineItem.productInventoryType = saleLine.item.productInventoryType;
                    productSaleLineItem.variantDisplayName = saleLine.item.variantDisplayName;
                    productSaleLineItem.variantAttributes = saleLine.item.variantAttributes;
                    productSaleLineItem.refundClientPackageId = saleLine.item.refundClientPackageId;
                    productSaleLineItem.isRefundClientPackage = saleLine.item.isRefundClientPackage
                    // For refunds, treat the line as lot-tracked if either the variant currently
                    // tracks lots OR the historical sale carries lot rows (covers the case where
                    // tracking was turned off on the variant after the sale was completed).
                    productSaleLineItem.isLotTracked = !!saleLine.item.isLotTracked
                        || (refundSaleLine.isRefund && !!saleLine.item.lotAllocations && saleLine.item.lotAllocations.length > 0);
                    if (refundSaleLine.isRefund && saleLine.item.lotAllocations && saleLine.item.lotAllocations.length) {
                        // Snapshot the original sale's lots onto the refund line itself so the
                        // historical option set + per-lot cap travel with the sale through every
                        // recalc round-trip and across hold/restore.
                        productSaleLineItem.historicalLotAllocations = _.map(saleLine.item.lotAllocations, (l: any) => _.clone(l));

                        const historicalOptionLots = this.getDistinctHistoricalLots(productSaleLineItem.historicalLotAllocations);
                        const meevoDate: any = this.$filter("meevoDateFilter");
                        for (const optLot of historicalOptionLots) {
                            Meevo.Components.Common.ProductLotUtil.decorateExpiration(
                                optLot, (d) => meevoDate(d), (k) => this.$translate.instant(k));
                        }
                        const totalHistoricalQty = _.reduce(productSaleLineItem.historicalLotAllocations,
                            (sum: number, l: any) => sum + (+l.quantity || 0), 0);

                        if (historicalOptionLots.length === 1) {
                            const onlyLot = historicalOptionLots[0];
                            productSaleLineItem.lotAllocations = [{
                                variantLotId: onlyLot.variantLot_TId,
                                variantLot: onlyLot,
                                quantity: refundSaleLine.quantity
                            }];
                        } else if (refundSaleLine.quantity === totalHistoricalQty) {
                            // Multi-lot, returning all units — pre-fill every historical lot.
                            productSaleLineItem.lotAllocations = _.map(productSaleLineItem.historicalLotAllocations, (l: any) => ({
                                variantLotId: l.variantLotId,
                                variantLot: l.variantLot,
                                quantity: l.quantity
                            }));
                        } else {
                            productSaleLineItem.lotAllocations = [{
                                variantLotId: null,
                                variantLot: null,
                                quantity: 1
                            }];
                        }
                    }
                    refundSaleLine.item = productSaleLineItem;
                    break;

                case Model.SalesTypeEnum.PackageServiceSwapFee:
                    refundSaleLine.item = new Meevo.Plugins.Register.PackageServiceSwapFeeSaleLineItem(saleLineItem);
                    refundSaleLine.item.displayName = this.$translate.instant("LABEL_PACKAGE_SERVICE_SWAP_FEE");
                    break;

                //case Model.SalesTypeEnum.ReloadGiftCard:
                default:
                    refundSaleLine.item = saleLine.item;
                    break;
            }
        }

        alertPromoGiftCardPaymentType(saleLine: Model.SaleLine) {
            if (!saleLine.transactionId) {
                return this.$q.reject();
            }

            let request = {
                criteria: {
                    isPromoGiftCard: true
                }
            };

            return this.dataService.customMethodData(`api/Sale/${saleLine.transactionId}/Payment/Count`, "POST", request).then((response) => {
                if (response.data > 0) {
                    return this.modalService.alert("MESSAGE_PROMO_GIFT_CARD_USED");
                }
            });
        }

        alertAccountChargePaymentType(saleLine: Model.SaleLine) {
            if (!saleLine.transactionId) {
                return this.$q.reject();
            }

            let request = {
                criteria: {
                    paymentSubCategory: Meevo.Model.PaymentSubCategoryEnum.AccountCharge
                }
            };

            return this.dataService.customMethodData(`api/Sale/${saleLine.transactionId}/Payment/Count`, "POST", request).then((response) => {
                if (response.data > 0) {
                    return this.modalService.alert("MESSAGE_CHARGE_ACCOUNT_REFUND");
                }
            });
        }

        getRedeemedPackageItemPriceCharge(item: Model.IClientPackageItem) {
            let price = item.linePaidPriceEach + this.getRedeemedPackageFinalItemCharge(item);

            return price;
        }

        getRedeemedPackageFinalItemCharge(item: Model.IClientPackageItem) {
            let charges = 0;
            if (item.charges) {
                for (let charge of item.charges) {
                    charges += charge.finalAmount;
                }
            }
            return charges;
        }

        getRedeemedPackageBaseItemCharge(item: Model.IClientPackageItem) {
            let charges = 0;
            if (item.charges) {
                for (let charge of item.charges) {
                    charges += charge.finalAmount;
                }
            }
            return charges;
        }

        getRefundPackageRedemptionPackageItems(saleLine: Model.SaleLine, existingRefundSaleLine: boolean) {
            let items: Model.IClientPackageItem[];
            let refund = _(this.refundPackageRedemptionPackageItems).find(item => {
                return item.refundSaleId == (existingRefundSaleLine ? saleLine.refundSaleId : saleLine.saleId) &&
                    item.refundSaleLineId == (existingRefundSaleLine ? saleLine.refundSaleLineId : saleLine.id) &&
                    item.refundLocationId == (existingRefundSaleLine ? saleLine.refundLocationId : saleLine.locationId) &&
                    item.refundTransactionId == (existingRefundSaleLine ? saleLine.refundTransactionId : saleLine.transactionId)
            });
            if (refund) {
                items = refund.packageItems;
            }
            return items;
        }
        addPackageRedeemedRefundSaleLine(saleLine: Model.SaleLine, saleType: Model.SalesTypeEnum, quantity:number, existingRefundSaleLine: boolean, client: Model.ClientListItem,  addClientFromSaleIntoSmartReceipt: boolean = false, doNotSwitchToServices: boolean = false) {
            let groupedServices = {};
            let relevantRedeemedItems = [];

            let originalMatchingSaleLines = this.getRefundLines(saleLine);

            if (quantity === 0) {
                quantity = _(originalMatchingSaleLines).reduce((total, saleLine) => { return total + saleLine.quantity }, 0);
            }
            if (quantity === 0) {
                return;
            }
            let redeemedPackageItems = this.getRefundPackageRedemptionPackageItems(saleLine, existingRefundSaleLine)
            if (!redeemedPackageItems) {
                this.refundPackageRedemptionPackageItems.push({
                    refundSaleId: saleLine.saleId,
                    refundSaleLineId: saleLine.id,
                    refundTransactionId: saleLine.transactionId,
                    refundLocationId: saleLine.locationId,
                    packageItems:saleLine.redeemedPackageItems
                })
                redeemedPackageItems = saleLine.redeemedPackageItems;
            }

            let multipleQuantitySaleLine: Model.SaleLine;
            for (let i = 0; i < quantity; i++) {
                let item = redeemedPackageItems[i];
                let itemPriceCharge = this.getRedeemedPackageItemPriceCharge(item);
                if (groupedServices[itemPriceCharge]) {
                    let existingSaleLine = groupedServices[itemPriceCharge];
                    existingSaleLine.newQuantity++;
                    existingSaleLine.quantity++;
                    existingSaleLine.finalCharge += this.getRedeemedPackageFinalItemCharge(item);
                    existingSaleLine.baseCharge += this.getRedeemedPackageBaseItemCharge(item);
                    existingSaleLine.redeemedPackageItems.push(item);
                    multipleQuantitySaleLine = existingSaleLine;
                }
                else {
                    let newSaleLine = angular.copy(saleLine);
                    newSaleLine.locationId = existingRefundSaleLine ? saleLine.refundLocationId : saleLine.locationId;
                    newSaleLine.id = existingRefundSaleLine ? saleLine.refundSaleLineId : saleLine.id;
                    newSaleLine.saleDate = existingRefundSaleLine ? saleLine.refundSaleDate : saleLine.saleDate;
                    newSaleLine.saleId = existingRefundSaleLine ? saleLine.refundSaleId : saleLine.saleId;
                    newSaleLine.transactionId = existingRefundSaleLine ? saleLine.refundTransactionId : saleLine.transactionId;
                    newSaleLine.newQuantity = 1;
                    newSaleLine.quantity = 1;
                    newSaleLine.baseItemPrice = item.valueEach;
                    newSaleLine.finalItemPrice = item.linePaidPriceEach;
                    newSaleLine.finalCharge = this.getRedeemedPackageFinalItemCharge(item);
                    newSaleLine.finalItemCharge = newSaleLine.finalCharge;
                    newSaleLine.baseCharge = this.getRedeemedPackageBaseItemCharge(item);
                    newSaleLine.baseItemCharge = newSaleLine.baseCharge;
                    //Gets recalculated on server, but just so you won't see price change if different
                    newSaleLine.finalItemPriceCharge = itemPriceCharge;
                    newSaleLine.redeemedPackageItems = [item];
                    newSaleLine.isRefund = existingRefundSaleLine;
                    groupedServices[itemPriceCharge] = newSaleLine;

                    relevantRedeemedItems.push(item);
                }
            }

            // Raise property to allow user to increase quantity in ticket to include package items that
            // weren't chosen
            let additionalQuantity = redeemedPackageItems.length - quantity;
            if (additionalQuantity > 0) {
                if (!multipleQuantitySaleLine) {
                    multipleQuantitySaleLine = groupedServices[Object.keys(groupedServices)[0]];
                }

                multipleQuantitySaleLine.quantity += additionalQuantity;
                multipleQuantitySaleLine.finalCharge = this.normalizeDecimalPlaces(multipleQuantitySaleLine.finalCharge +
                    (multipleQuantitySaleLine.finalCharge * additionalQuantity));
            }

            for (let key of Object.keys(groupedServices)) {
                if (client) {
                    groupedServices[key].client = client;
                }
                groupedServices[key].authorizationPaymentRequestId = saleLine.authorizationPaymentRequestId;
                this.addRefundSaleLine(groupedServices[key], saleType, addClientFromSaleIntoSmartReceipt, doNotSwitchToServices);
            }

            for (let item of relevantRedeemedItems) {
                let neededSaleLine = _(originalMatchingSaleLines).find(saleLine =>
                    _(saleLine.redeemedPackageItems).pluck("id").indexOf(item.id) > -1);
                if (neededSaleLine) {
                    originalMatchingSaleLines = _(originalMatchingSaleLines).without(neededSaleLine);
                }
            }
            this.sale.saleLines = _(this.sale.saleLines).without(...originalMatchingSaleLines);
        }

        addRefundSaleLine(saleLine: Model.SaleLine, saleType: Model.SalesTypeEnum, addClientFromSaleIntoSmartReceipt: boolean = false, doNotSwitchToServices: boolean = false) {
            // gift card refunds are always Model.SalesTypeEnum.ReloadGiftCard
            if (saleType === Model.SalesTypeEnum.GiftCard || !saleLine) {
                return;
            }

            this.alertPromoGiftCardPaymentType(saleLine).then(() => {
                this.alertAccountChargePaymentType(saleLine);
            });

            let existingSaleLine = this.getExistingSaleLineForRefund(saleLine);

            var useClient, useClientType;
            if (addClientFromSaleIntoSmartReceipt) {
                useClient = saleLine.client;
                useClientType = saleLine.clientType;

                if (saleLine.clientType == Meevo.Model.ClientTypeEnum.Client) {
                    var rClient = new RegisterClient({ client: useClient, clientType: useClientType, appointmentId: null });
                    var existingRegisterClient = this.getRegisterClient(rClient, _.find);
                    if (existingRegisterClient == null) {
                        this.sale.changedClientIds.push({
                            newClient: {
                                clientId: useClient.id,
                                clientType: useClientType,
                                appointmentId: null
                            },
                            oldClient: null
                        });
                        this.sale.mergeClientIds.push(useClient.id);
                    }
                }

                var selectFirstClient = (this.allUniqueClients.length == 0);
                this.addToAllUniqueClients(saleLine.client, saleLine.clientType, null);
                if (selectFirstClient) {
                    this.selectClient(this.allUniqueClients[0], doNotSwitchToServices);
                }
            }
            else {
                useClient = this.selectedClient;
                useClientType = this.selectedClientType;
            }

            let newQuantity = saleLine.newQuantity ? saleLine.newQuantity : saleLine.quantity;

            let originalCharges = angular.copy(saleLine.charges);
            if (originalCharges) {
                originalCharges.forEach((charge) => {
                    if (charge.taxes) {
                        charge.originalTaxes = angular.copy(charge.taxes);
                    }
                });
            }

            // NOTE: item is a historical record of the sale, therefore cannot be used directly
            let refundSaleLine: Model.SaleLine = {
                quantity: newQuantity,
                originalQuantity: saleLine.quantity,
                client: useClient,
                clientId: (useClient) ? useClient.id : null,
                clientType: useClientType,
                employee: {
                    id: saleLine.employeeId || (saleLine.employee ? saleLine.employee.id : this.HouseEmployee.id),
                    displayName: saleLine.employeeDisplayName || (saleLine.employee ? saleLine.employee.displayName : this.HouseEmployee.displayName),
                    allowSales: true,
                    allowTips: true
                },
                employeeId: saleLine.employeeId,
                employeeSplitCommission: saleLine.employeeSplitCommission,
                secondEmployee: saleLine.secondEmployee,
                secondEmployeeId: saleLine.secondEmployeeId,
                secondEmployeeSplitCommission: saleLine.secondEmployeeSplitCommission,
                saleType: saleType,
                basePrice: -Math.abs(saleLine.baseItemPrice * newQuantity),
                finalPrice: -Math.abs(saleLine.finalItemPrice * newQuantity),
                baseItemPrice: -Math.abs(saleLine.baseItemPrice),
                finalItemPrice: -Math.abs(saleLine.finalItemPrice),
                baseItemPriceCharge: -Math.abs(saleLine.baseItemPriceCharge),
                finalItemPriceCharge: -Math.abs(saleLine.finalItemPriceCharge),
                originalBaseItemPrice: -Math.abs(saleLine.baseItemPrice),
                originalFinalItemPrice: -Math.abs(saleLine.finalItemPrice),
                fullCommissionPrice: -Math.abs(saleLine.fullCommissionPrice),
                originalFullCommissionPrice: -Math.abs(saleLine.originalFullCommissionPrice),
                isFullCommissionApplicable: saleLine.isFullCommissionApplicable,
                isNew: true,
                refundLocationId: saleLine.locationId,
                refundSaleLineId: saleLine.id,
                refundSaleDate: saleLine.saleDate,
                refundSaleId: saleLine.saleId,
                originalBaseTax: saleLine.baseTax,
                originalFinalTax: saleLine.finalTax,
                originalTaxes: saleLine.taxes,
                originalBaseCharge: saleLine.baseCharge,
                originalFinalCharge: saleLine.finalCharge,
                originalBaseItemCharge: saleLine.baseItemCharge,
                originalFinalItemCharge: saleLine.finalItemCharge,
                originalCharges: originalCharges,
                baseTax: 0,
                finalTax: 0,
                baseTaxIncluded: 0,
                finalTaxIncluded: 0,
                taxes: angular.copy(saleLine.taxes),
                baseCharge: 0,
                finalCharge: 0,
                baseItemCharge: 0,
                finalItemCharge: 0,
                charges: angular.copy(saleLine.charges),
                priceIncludesTax: saleLine.priceIncludesTax,
                prepaidTip: saleLine.prepaidTip,
                refundTransactionId: saleLine.transactionId,
                isRefund: true,
                showPoleMessage: Model.SaleLineStatusEnum.Added,
                isProductTaxDeclined: saleLine.isProductTaxDeclined,
                isServiceTaxDeclined: saleLine.isServiceTaxDeclined,
                redeemedPackageItems: saleLine.redeemedPackageItems,
                paymentPlanId: saleLine.paymentPlanId,
                externalTipTransactionId: saleLine.externalTipTransactionId,
                isTransactionRefund: saleLine.isTransactionRefund,
                authorizationPaymentRequestId: saleLine.authorizationPaymentRequestId,
            };

            if (this.isSaleLineServiceOrSwapFee(refundSaleLine) && saleLine.linkedSaleLineIds) {
                refundSaleLine.linkedSaleLineIds = saleLine.linkedSaleLineIds;
                refundSaleLine.isLinkedRefundLine = saleLine.isLinkedRefundLine;
            }

            if (refundSaleLine.taxes) {
                refundSaleLine.taxes.forEach((tax) => {
                    tax.baseAmount = this.normalizeDecimalPlaces(-Math.abs(tax.baseAmount) / saleLine.quantity * newQuantity);
                    tax.finalAmount = this.normalizeDecimalPlaces(-Math.abs(tax.finalAmount) / saleLine.quantity * newQuantity);
                    refundSaleLine.baseTax += tax.baseAmount;
                    refundSaleLine.finalTax += tax.finalAmount;
                });
            }

            if (refundSaleLine.charges) {
                refundSaleLine.charges.forEach((charge) => {
                    let baseAmount = -Math.abs(charge.baseAmount) / saleLine.quantity;
                    let finalAmount = -Math.abs(charge.finalAmount) / saleLine.quantity;
                    refundSaleLine.baseItemCharge += baseAmount;
                    refundSaleLine.finalItemCharge += finalAmount;
                    refundSaleLine.baseCharge += baseAmount * newQuantity;
                    refundSaleLine.finalCharge += finalAmount * newQuantity;
                    charge.baseAmount = this.normalizeDecimalPlaces(baseAmount * newQuantity);
                    charge.finalAmount = this.normalizeDecimalPlaces(finalAmount * newQuantity);

                    if (charge.taxes) {
                        charge.originalTaxes = angular.copy(charge.taxes);
                        for (let chargeTax of charge.taxes) {
                            chargeTax.baseAmount = this.normalizeDecimalPlaces(-Math.abs(chargeTax.baseAmount) / saleLine.quantity * newQuantity);
                            chargeTax.finalAmount = this.normalizeDecimalPlaces(-Math.abs(chargeTax.finalAmount) / saleLine.quantity * newQuantity);
                            refundSaleLine.baseTax += chargeTax.baseAmount;
                            refundSaleLine.finalTax += chargeTax.finalAmount;
                        }
                    }
                });
            }

            refundSaleLine.baseTax = this.normalizeDecimalPlaces(refundSaleLine.baseTax);
            refundSaleLine.finalTax = this.normalizeDecimalPlaces(refundSaleLine.finalTax);
            refundSaleLine.baseItemCharge = this.normalizeDecimalPlaces(refundSaleLine.baseItemCharge);
            refundSaleLine.finalItemCharge = this.normalizeDecimalPlaces(refundSaleLine.finalItemCharge);
            refundSaleLine.baseCharge = this.normalizeDecimalPlaces(refundSaleLine.baseCharge);
            refundSaleLine.finalCharge = this.normalizeDecimalPlaces(refundSaleLine.finalCharge);

            if (!saleLine.employeeId) {
                refundSaleLine.employeeId = this.HouseEmployee.id;
                refundSaleLine.employee = this.HouseEmployee;
            }
            else if (saleLine.employee) {
                refundSaleLine.employee.code = saleLine.employee.code;
                refundSaleLine.employee.firstName = saleLine.employee.firstName;
                refundSaleLine.employee.lastName = saleLine.employee.lastName;
                refundSaleLine.employee.gender = saleLine.employee.gender;
                refundSaleLine.employee.isEmployee = saleLine.employee.isEmployee;
            }

            if (existingSaleLine) {
                if (saleType === Model.SalesTypeEnum.Package) {
                    // packageServices is cached and used for displaying a label
                    // it will be rebuilt whenever refund line is updated
                    refundSaleLine['packageItems'] = null;
                }

                angular.merge(existingSaleLine, refundSaleLine);
                this.updateSaleLineItem(saleType, existingSaleLine, saleLine);
            }
            else {

                this.updateSaleLineItem(saleType, refundSaleLine, saleLine);
                this.sale.saleLines.push(refundSaleLine);
            }
            if (saleLine.paymentPlanId && this.paymentPlanService.refundPaymentPlanIds.indexOf(saleLine.paymentPlanId) === -1) {
                this.paymentPlanService.refundPaymentPlanIds.push(saleLine.paymentPlanId);
            }
        }

        addRefundTipLine(tipLine: Model.TipLine) {
            const employeeId = tipLine.employeeId;
            const employee = {
                id: tipLine.employeeId,
                code: tipLine.employeeCode,
                displayName: tipLine.employeeDisplayName
            };

            this.sale.tipLines.push({
                employeeId: employeeId,
                employee: employee,
                originalEmployeeId: employeeId,
                originalEmployee: employee,
                amount: -Math.abs(tipLine.amount),
                percentage: 0,
                tempId: this.getTempId(tipLine),
                isRefund: true,
                refundSaleId: tipLine.saleId,
                refundSaleDate: tipLine.saleDate,
                refundTipLineId: tipLine.id,
                refundLocationId: tipLine.locationId,
                clientIds: tipLine.clientIds,
                registerClients: tipLine.registerClients,
                transactionId: tipLine.transactionId,
                externalTipTransactionId: tipLine.externalTipTransactionId,
                prepaidTipMinimum: -Math.abs(tipLine.prepaidTipMinimum),
                authorizationPaymentRequestId: tipLine.authorizationPaymentRequestId,
            });
        }

        getTempId(tipLine: Model.TipLine): string {
            const locationId = tipLine.locationId || tipLine.refundLocationId;
            const saleLineId = tipLine.id || tipLine.refundTipLineId;

            return locationId + tipLine.transactionId + saleLineId;
        }

        getPackageRedemptionIcon(saleLine: Model.SaleLine) {
            const baseUrl = "assets/images/icons/";

            let iconUrl: string = null;
            if (saleLine.packageRedemptionPath) {
                if (!saleLine.packageRedemptionPath.createsMerge && !saleLine.packageRedemptionPath.createsSplit && !saleLine.packageRedemptionPath.usesSwap) {
                    saleLine.packageRedemptionType = Model.PackageRedemptionTypeEnum.ExactMatch;
                    iconUrl = baseUrl + "package_match";
                }
                else if (!saleLine.packageRedemptionPath.createsMerge && !saleLine.packageRedemptionPath.createsSplit && saleLine.packageRedemptionPath.usesSwap) {
                    saleLine.packageRedemptionType = Model.PackageRedemptionTypeEnum.Swap;
                    iconUrl = baseUrl + "package";
                }
                else if (!saleLine.packageRedemptionPath.createsMerge && saleLine.packageRedemptionPath.createsSplit) {
                    saleLine.packageRedemptionType = Model.PackageRedemptionTypeEnum.Split;
                    iconUrl = baseUrl + "package";
                }
                else if (saleLine.packageRedemptionPath.createsMerge && !saleLine.packageRedemptionPath.createsSplit) {
                    saleLine.packageRedemptionType = Model.PackageRedemptionTypeEnum.Merge;
                    iconUrl = baseUrl + "package";
                }
                if (iconUrl != null) {
                    return iconUrl
                        + ((saleLine.packageRedemptionPath.usesExpiredPackage &&
                        !this.hasPUTPackageRedemptionPath(saleLine)) ? "_expired" : "")
                        + ((saleLine.packageRedemptionPath.totalSwapFee > 0) ? "_upgrade" : "")
                        + ".svg";
                }
            }
        }

        getPackageRedemptionLabel(saleLine: Model.SaleLine) {
            if (saleLine && saleLine.redeemedPackages && saleLine.redeemedPackages.length > 0) {
                const productUnitRedeemedPackages = this.getRedeemedPUTPackages(saleLine);
                if (productUnitRedeemedPackages.length > 1) {
                    return this.$translate.instant("LABEL_PACKAGE_MULTIPLE_REDEEMED", { count: productUnitRedeemedPackages.length })
                };
                return `${this.$translate.instant("LABEL_PACKAGE_REDEEMED")} ${saleLine.redeemedPackages[saleLine.redeemedPackages.length - 1].clientPackageNumber}`;
            }
            else {
                return "";
            }
        }

        getPaymentCatPhotoUrl(paymentCategory: Model.PaymentCategoryEnum) {
            const baseUrl = "assets/images/icons/";

            switch (paymentCategory) {
                case Model.PaymentCategoryEnum.Cash:
                    return baseUrl + "paytype_cash.svg";
                case Model.PaymentCategoryEnum.Check:
                    return baseUrl + "paytype_check.svg";
                case Model.PaymentCategoryEnum.GiftCard:
                    return baseUrl + "paytype_giftcard.svg";
                case Model.PaymentCategoryEnum.CreditDebit:
                    return baseUrl + "paytype_creditdebit.svg";
                case Model.PaymentCategoryEnum.PointsRewards:
                    return baseUrl + "points.svg";
                case Model.PaymentCategoryEnum.Other:
                    return baseUrl + "paytype_other.svg";
            }
        }

        formatClientDisplayName(firstName: string, lastName: string, clientType?: Meevo.Model.ClientTypeEnum) {
            if (clientType) {
                switch (clientType) {
                    case Meevo.Model.ClientTypeEnum.AnonymousMale:
                        return this.$translate.instant("LABEL_ANONYMOUS_MALE");
                    case Meevo.Model.ClientTypeEnum.AnonymousFemale:
                        return this.$translate.instant("LABEL_ANONYMOUS_FEMALE");
                    case Meevo.Model.ClientTypeEnum.AnonymousOther:
                        return this.$translate.instant("LABEL_ANONYMOUS_OTHER");
                }
            }

            switch (this.defaultClientSortOrder) {
                case Meevo.Model.DefaultSortTypeEnum.FirstNameLastName:
                    return `${firstName} ${lastName}`;
                default:
                    return `${lastName}, ${firstName}`;
            }
        }

        addClientPackageTransferSaleLineWorker(clientPackage, donorClientPackageItemIds: string[], amount: number,
            isPackageTransferOverride: boolean, donorClientId: string, isService: boolean) {
            clientPackage.client = {
                id: clientPackage.clientId,
                firstName: clientPackage.clientFirstName,
                lastName: clientPackage.clientLastName,
                displayName: this.formatClientDisplayName(clientPackage.clientFirstName, clientPackage.clientLastName),
                primaryPhoneNumber: clientPackage.clientPhoneNumber,
                isCreatedOutsideOfRegister: true
            }

            this.addToAllUniqueClients(clientPackage.client, Model.ClientTypeEnum.Client, null);

            let rClient = new RegisterClient({ client: clientPackage.client, clientType: Model.ClientTypeEnum.Client, appointmentId: null });
            let existingRegisterClient = this.getRegisterClient(rClient, _.find);
            this.selectClient(existingRegisterClient || this.allUniqueClients[0], false, false);

            let clientPackageTransferSaleLineItem = new Meevo.Plugins.Register.ClientPackageTransferSaleLineItem({
                id: clientPackage.id
            });

            clientPackageTransferSaleLineItem.clientPackage = clientPackage;
            if (isService) {
                clientPackageTransferSaleLineItem.donorClientPackageServiceId = donorClientPackageItemIds[0];
            } else {
                clientPackageTransferSaleLineItem.donorClientPackageProductId = donorClientPackageItemIds[0];
            }

            clientPackageTransferSaleLineItem.donorClientId = donorClientId;
            clientPackageTransferSaleLineItem.isPackageTransferOverride = isPackageTransferOverride;

            let saleLine = {
                item: clientPackageTransferSaleLineItem,
                quantity: 1,
                client: this.selectedClient,
                clientId: this.selectedClient ? this.selectedClient.id : undefined,
                clientType: this.selectedClientType,
                saleType: Model.SalesTypeEnum.PackageTransfer,
                finalItemPrice: amount,
                baseItemPrice: amount,
                finalItemPriceCharge: amount,
                baseItemPriceCharge: amount,
                employee: this.HouseEmployee,
                employeeId: this.HouseEmployee.id,
                isNew: true
            };

            this.sale.saleLines.push(saleLine);
        }

        addClientPackageTransferSaleLine(params) {
            const promises = params.transferredServices
                .map(transferredService => this.dataService.getItem("clientpackage", new Guid(transferredService.clientPackageId))
                .then((clientPackage: any) => {
                        this.addClientPackageTransferSaleLineWorker(
                            clientPackage,
                            [ transferredService.donorClientPackageServiceId ],
                            transferredService.amount,
                            params.isPackageTransferOverride,
                            params.sourceClient.id,
                            true);
                }));

            this.$q.all(promises).then(() => this.recalculateSale(false, null, false, null, true));
            this.returnStateClient = params.sourceClient;
            this.returnStateSection = params.section;
        }

        addManualBillClient(parentEntity) {
            let client = {
                id: parentEntity.clientId,
                firstName: parentEntity.clientFirstName,
                lastName: parentEntity.clientLastName,
                displayName: this.formatClientDisplayName(parentEntity.clientFirstName, parentEntity.clientLastName),
                isCreatedOutsideOfRegister: true
            }
            this.addToAllUniqueClients(client, Model.ClientTypeEnum.Client, null);
        }

        buildManualBillEmployee(parentEntity) {
            let employee;
            if (parentEntity.employeeId) {
                employee = {
                    id: parentEntity.employeeId,
                    firstName: parentEntity.employeeFirstName,
                    lastName: parentEntity.employeeLastName,
                    code: parentEntity.employeeCode,
                    displayName: `${parentEntity.employeeCode}: ${parentEntity.employeeLastName}, ${parentEntity.employeeFirstName}`
                }
            } else {
                employee = this.HouseEmployee;
            }
            return employee;
        }

        buildManualBillSaleLine(bill, item, employee, isRefund, itemId: string, saleType: Model.SalesTypeEnum) {
            return {
                item: item,
                quantity: 1,
                itemId: itemId,
                client: this.selectedClient,
                clientId: this.selectedClient ? this.selectedClient.id : undefined,
                clientType: this.selectedClientType,
                saleType: saleType,
                finalItemPrice: bill.amount,
                baseItemPrice: bill.amount,
                finalPrice: bill.amount,
                basePrice: bill.amount,
                finalItemPriceCharge: bill.amount,
                baseItemPriceCharge: bill.amount,
                originalBaseItemPrice: bill.amount,
                originalFinalItemPrice: bill.amount,
                employee: employee,
                employeeId: employee.id,
                isRefund: isRefund,
                refundSaleId: bill.saleId,
                refundSaleLineId: bill.saleLineId,
                refundLocationId: bill.saleLocationId,
                refundSaleDate: bill.saleDate
            };
        }

        addManualPaymentPlanBillPaymentSaleLine(params) {
            this.addManualBillClient(params.paymentPlan)
            let employee = this.buildManualBillEmployee(params.paymentPlan);

            this.selectClient(this.allUniqueClients[0], true, false);
            params.paymentPlanBills.forEach(bill => {
                var paymentPaymentPaymentSaleLineItem = new Meevo.Plugins.Register.PaymentPlanPaymentSaleLineItem({
                    displayName: this.$translate.instant("LABEL_PAYMENT_PLAN_PAYMENT_SALE_LINE_DISPLAY_NAME", {
                        saleTransactionId: params.paymentPlan.saleTransactionId,
                        billDate: moment(bill.paymentDate).format("D MMM YYYY")
                    }),
                    id: params.paymentPlan.id,
                    paymentPlanEntityVersion: bill.entityVersion,
                    paymentDate: bill.paymentDate,
                    saleTransactionId: params.paymentPlan.saleTransactionId
                });
                let saleLine: Model.SaleLine = this.buildManualBillSaleLine(bill, paymentPaymentPaymentSaleLineItem,
                    employee, false, params.paymentPlan.id, Model.SalesTypeEnum.PaymentPlanPayment);
                this.sale.saleLines.push(saleLine);
            });

            this.recalculateSale().then(() => {
                this.selectSection(RegisterSectionTypeEnum.Services);
            });
        }

        addPaymentRequestToSale(paymentRequest: Model.PaymentRequest) {
            let paymentLine = {
                __type: "Millennium.Meevo.Register.Contracts.Model.SalePaymentCreditCard, Millennium.Meevo.Register.Contracts.Model",
                paymentCategory: Model.PaymentCategoryEnum.CreditDebit,
                amount: 0,
                skipPreserve: true
            };
            this.updatePaymentLineWithPaymentRequest(paymentRequest, paymentLine);
            this.sale.paymentLines.push(paymentLine);
            this.recalculateSale();
        }

        addManualBillPaymentSaleLine(params, isRefund) {
            this.addManualBillClient(params.clientMembership)
            let employee = this.buildManualBillEmployee(params.clientMembership);

            this.selectClient(this.allUniqueClients[0], true, false);
            params.clientMembershipBills.forEach(bill => {
                var membershipPaymentSaleLineItem = new Meevo.Plugins.Register.MembershipPaymentSaleLineItem({
                    displayName: this.getMembershipPaymentDisplayName(bill),
                    id: bill.clientMembershipBillId,
                    clientMembershipBillFeeType: bill.clientMembershipBillFeeType,
                    entityVersion: bill.entityVersion,
                    freezeSetting: bill.freezeSetting,
                    freezeStartDate: bill.freezeStartDate,
                    freezeReactivationDate: bill.freezeReactivationDate,
                    freezeReason: bill.freezeReason,
                    clientMembershipId: params.clientMembership.id,
                    billPackages: bill.billPackages,
                    membershipName: params.clientMembership.membershipDisplayName,
                    membershipShortcut: params.clientMembership.membershipShortcut
                });

                let saleLine: Model.SaleLine = this.buildManualBillSaleLine(bill, membershipPaymentSaleLineItem,
                    employee, isRefund, bill.clientMembershipBillId, Model.SalesTypeEnum.MembershipPayment);
                this.sale.saleLines.push(saleLine);
            });

            this.recalculateSale().then(() => {
                this.returnStateClient = this.selectedClient;
                this.returnStateClient.clientMembershipId = params.clientMembership.id;
                this.returnStateSection = params.section;
                this.selectSection(RegisterSectionTypeEnum.Services);
            });
        }

        addManualSaleLine(params) {
            let promises = [];
            promises.push(this.dataService.getItem("client", params.clientId));
            promises.push(this.dataService.getItem("service", params.serviceId));
            if (params.employeeId) {
                promises.push(this.dataService.getItem("employee", params.employeeId));
            }
            this.$q.all(promises).then((response: any) => {
                let client = {
                    id: params.clientId,
                    firstName: response[0].firstName,
                    lastName: response[0].lastName,
                    displayName: this.formatClientDisplayName(response[0].firstName, response[0].lastName),
                    isCreatedOutsideOfRegister: true
                }

                this.addToAllUniqueClients(client, Model.ClientTypeEnum.Client, null);
                this.selectClient(this.allUniqueClients[0], true, false);

                let serviceSaleLineItem = new Meevo.Plugins.Register.ServiceSaleLineItem({
                    displayName: response[1].displayName,
                    shortcut: response[1].shortcut,
                    id: params.serviceId,
                    appointmentServiceId: params.appointmentServiceId,
                    doNotAllowTips: response[1].doNotAllowTips,
                });
                let employee;
                if (params.employeeId) {
                    employee = response[2];
                }

                let saleLine: Model.SaleLine = {
                    item: serviceSaleLineItem,
                    quantity: 1,
                    client: client,
                    clientId: client.id,
                    clientType: Model.ClientTypeEnum.Client,
                    saleType: Model.SalesTypeEnum.Service,
                    employeeId: params.employeeId,
                    employee: employee,
                    isNew: true,
                    showPoleMessage: Model.SaleLineStatusEnum.Added
                };
                this.sale.saleLines.push(saleLine);

                this.recalculateSale().then(() => {
                    this.selectSection(params.selectSection || RegisterSectionTypeEnum.Services);
                });
            });
        }

        addManualSaleLines(params) {
            let employeeData = null;
            let clientData = null;

            this.dataService.getItem('client', params.clientId)
                .then((clientResp) => {
                    clientData = clientResp;

                    if (params.employeeId) {
                        return this.dataService.getItem('employee', params.employeeId);
                    } else {
                        return this.$q.resolve(null);
                    }
                })
                .then((employeeResp) => {
                    employeeData = employeeResp;

                    return this.$q.all(params.services.map((service) => this.dataService.getItem('service', service.serviceId)));
                })
                .then((services) => {
                    let client = {
                        id: params.clientId,
                        firstName: clientData.firstName,
                        lastName: clientData.lastName,
                        displayName: this.formatClientDisplayName(clientData.firstName, clientData.lastName),
                        isCreatedOutsideOfRegister: true
                    };

                    this.addToAllUniqueClients(client, Model.ClientTypeEnum.Client, null);
                    this.selectClient(this.allUniqueClients[0], true, false);

                    services.forEach((service: any) => {
                        let serviceSaleLineItem = new Meevo.Plugins.Register.ServiceSaleLineItem({
                            displayName: service.displayName,
                            shortcut: service.shortcut,
                            id: service.id,
                            appointmentServiceId: params.services.find((serv) => serv.serviceId === service.id).appointmentServiceId,
                            doNotAllowTips: service.doNotAllowTips,
                        });

                        let saleLine: Model.SaleLine = {
                            item: serviceSaleLineItem,
                            quantity: 1,
                            client: client,
                            clientId: client.id,
                            clientType: Model.ClientTypeEnum.Client,
                            saleType: Model.SalesTypeEnum.Service,
                            employeeId: params.employeeId,
                            employee: params.employeeId ? employeeData : null,
                            isNew: true,
                            showPoleMessage: Model.SaleLineStatusEnum.Added
                        };
                        this.sale.saleLines.push(saleLine);
                    });

                    this.recalculateSale().then(() => {
                        this.selectSection(params.selectSection || RegisterSectionTypeEnum.Services);
                    });
                });
        }

        getMembershipPaymentDisplayName(membershipBill: any) {
            var displayName: string;
            switch (membershipBill.clientMembershipBillFeeType) {
                case Model.ClientMembershipBillFeeTypeEnum.PaidInFullFreezeFee:
                    displayName = "Freeze payment";
                    break;
                case Model.ClientMembershipBillFeeTypeEnum.FreezeFee:
                    displayName = "Freeze payment";
                    break;
                case Model.ClientMembershipBillFeeTypeEnum.RecurringFee:
                    displayName = "Recurring payment";
                    break;
                case Model.ClientMembershipBillFeeTypeEnum.RenewalFee:
                    displayName = "Renewal payment";
                    break;
                default:
                    displayName = "Membership payment";
                    break;
            }
            return displayName + " " + moment(membershipBill.paymentDate).format("D MMM YYYY");
        }

        isQuantityDisabledOnEditor(saleLine: Model.SaleLine, fromPaymentPlanRefund: boolean = false): boolean {
            return !this.isSelectedDrawerOpen()
                || (!this.isSaleLineAService(saleLine) && saleLine.saleType !== Meevo.Model.SalesTypeEnum.Product)
                || (saleLine.isRefund && angular.isDefined(saleLine.paymentPlanId) && !fromPaymentPlanRefund);
        }

        isQuantityVisibleOnEditor(saleLine: Model.SaleLine): boolean {
            if (!saleLine) {
                return false;
            }

            switch (saleLine.saleType) {
                case Meevo.Model.SalesTypeEnum.Package:
                    if (saleLine.isRefund) {
                        return false;
                    }
                    break;

                case Meevo.Model.SalesTypeEnum.GiftCard:
                case Meevo.Model.SalesTypeEnum.ReloadGiftCard:
                case Meevo.Model.SalesTypeEnum.TicketCharge:
                case Meevo.Model.SalesTypeEnum.ClientAccountCredit:
                case Meevo.Model.SalesTypeEnum.ClientAccountPayment:
                case Meevo.Model.SalesTypeEnum.DepositCredit:
                case Meevo.Model.SalesTypeEnum.PackageServiceSwapFee:
                case Meevo.Model.SalesTypeEnum.PaymentSurcharge:
                    return false;
            }

            if (this.isPartialRedemptionRemainder(saleLine)) {
                return false;
            }

            return true;
        }

        isAmountDisabledOnEditor(saleLine: Model.SaleLine, fromPaymentPlanRefund: boolean = false): boolean {
            if (!saleLine || !this.isSelectedDrawerOpen()) {
                return true;
            }

            if (saleLine.isRefund && saleLine.paymentPlanId && !fromPaymentPlanRefund) {
                return true;
            }

            if (this.saleLineHasTippyServiceCharge(saleLine)) {
                return true;
            }

            switch (saleLine.saleType) {
                case Model.SalesTypeEnum.Membership:
                    if (saleLine.isRefund || !(<MembershipSaleLineItem>saleLine.item).isBillable) {
                        return true;
                    }
                    break;

                case Model.SalesTypeEnum.GiftCard:
                    if ((<GiftCardSaleLineItem>saleLine.item).clientGiftCard.giftCardType.isPromo) {
                        return true;
                    }
                    break;

                case Model.SalesTypeEnum.ReloadGiftCard:
                    if (saleLine.isRefund) {
                        return true;
                    }
                    break;

                case Model.SalesTypeEnum.PackageRefund:
                case Model.SalesTypeEnum.ClientAccountCredit:
                case Model.SalesTypeEnum.ClientAccountPayment:
                case Model.SalesTypeEnum.DepositCredit:
                case Model.SalesTypeEnum.BulkGiftCard:
                case Model.SalesTypeEnum.PaymentPlanPayment:
                    return true;
            }

            return false;
        }

        isAmountVisibleOnEditor(saleLine: Model.SaleLine): boolean {
            if (!saleLine) {
                return false;
            }

            if (saleLine.isRefund && (saleLine.saleType === Meevo.Model.SalesTypeEnum.Package ||
                saleLine.saleType === Meevo.Model.SalesTypeEnum.Membership ||
                saleLine.saleType === Meevo.Model.SalesTypeEnum.ReloadGiftCard ||
                saleLine.saleType === Meevo.Model.SalesTypeEnum.ClientAccountCredit)) {
                return false;
            }

            if ((saleLine as any).hideAmount) {
                return false;
            }

            return true;
        }

        isChargeDisabledOnEditor(saleLine: Model.SaleLine): boolean {
            return true;
        }

        isChargeVisibleOnEditor(saleLine: Model.SaleLine): boolean {
            if (!saleLine || saleLine.isRefund || saleLine.finalItemCharge === 0) {
                return false;
            }

            return true;
        }

        isDepositDisabledOnEditor(saleLine: Model.SaleLine): boolean {
            return true;
        }

        isDepositVisibleOnEditor(saleLine: Model.SaleLine): boolean {
            if (!saleLine || !saleLine.item) {
                return false;
            }

            const saleLineItem = saleLine.item as Model.ServiceSaleLineItem;
            if (saleLineItem && saleLineItem.depositAmount) {
                return true;
            }

            return false;
        }

        isRemainingAmountVisibleOnEditor(saleLine): boolean {
            return (saleLine.saleType === Meevo.Model.SalesTypeEnum.GiftCard || saleLine.saleType === Meevo.Model.SalesTypeEnum.ReloadGiftCard) &&
                !this.isReloadGiftCardRefund(saleLine);
        }

        isEmployeeVisibleOnEditor(saleLine: Model.SaleLine): boolean {
            if (!saleLine) {
                return false;
            }

            switch (saleLine.saleType) {
                case Meevo.Model.SalesTypeEnum.TicketCharge:
                case Meevo.Model.SalesTypeEnum.PackageServiceSwapFee:
                case Meevo.Model.SalesTypeEnum.PaymentSurcharge:
                    return false;
            }

            if (this.isPartialRedemptionRemainder(saleLine)) {
                return false;
            }

            return true;
        }

        isEmployeeDisabledOnEditor(saleLine: Model.SaleLine): boolean {
            if (!this.isSelectedDrawerOpen()) {
                return true;
            }
            if (!!saleLine.externalTipTransactionId) {
                return true;
            }

            switch (saleLine.saleType) {
                case Meevo.Model.SalesTypeEnum.TicketCharge:
                case Meevo.Model.SalesTypeEnum.DepositCredit:
                case Meevo.Model.SalesTypeEnum.ClientAccountCredit:
                case Meevo.Model.SalesTypeEnum.ClientAccountPayment:
                    return true;
            }

            return false;
        }

        isServiceVisibleOnEditor(saleLine: Model.SaleLine): boolean {
            if (this.isPartialRedemptionRemainder(saleLine)) {
                return false;
            }

            return this.isSaleLineAService(saleLine) && !saleLine.isRefund;
        }

        private excludeNoRefundItems(sale: Model.Sale) {
            let excludedSaleLines: Model.SaleLine[] = [];
            let includedSaleLines: Model.SaleLine[] = [];

            _(sale.saleLines).each((saleLine: Model.SaleLine) => {
                !!saleLine.noRefundReason
                    ? excludedSaleLines.push(saleLine)
                    : includedSaleLines.push(saleLine);
            });

            sale.saleLines = includedSaleLines;

            return excludedSaleLines;
        }

        private showNoRefundReasons(excludedSaleLines: Model.SaleLine[]) {
            if (!excludedSaleLines || excludedSaleLines.length === 0) {
                return this.$q.resolve(true);
            }

            let unlimitedServices = _.chain(excludedSaleLines)
                .filter((saleLine: Model.SaleLine) => saleLine.noRefundReason === Model.SaleLineNoRefundReasonEnum.UnlimitedPackage)
                .map((saleLine: Model.SaleLine) => saleLine.item)
                .filter(item => !!(item as ServiceSaleLineItem))
                .map(item => (<ServiceSaleLineItem>item).shortcut + ': ' + (<ServiceSaleLineItem>item).displayName)
                .value();

            if (unlimitedServices.length > 0) {
                this.busyService.stop();

                const services = unlimitedServices.join(', ');
                const contentKey = unlimitedServices.length > 1 ? 'MESSAGE_NO_REFUND_UNLIMITED_PACKAGE_PLURAL' : 'MESSAGE_NO_REFUND_UNLIMITED_PACKAGE';
                const message = this.$translate.instant(contentKey, { 'serviceName': services });

                return this.modalService.alert(message);
            }

            return this.$q.resolve(true);
        }

        enterRegisterPastTransactionMode(pastTransactionContext: Meevo.Model.PastTransactionContext) {
            return this.registerTicketService.enterPastTransactionMode(this, pastTransactionContext);
        }

        exitRegisterPastTransactionMode() {
            return this.registerTicketService.exitPastTransactionMode(this);
        }

        getSaleLinesToRefundFromTransactionId(transactionId: string, addOriginalClientsToSale: boolean = true, skipAutoAddExistingServices = false) {
            if (!transactionId) {
                return this.$q.reject();
            }

            this.busyService.start();

            return this.dataService
                .customMethodData(`api/Sale/${transactionId}/SaleLine/List`, "POST", { criteria: { isRefundEligible: true } })
                .then((response) => {
                    if (!response || !response.data) {
                        this.busyService.stop();
                        return this.modalService.alert("MESSAGE_REGISTER_NO_REFUNDABLE_ITEMS");
                    }

                    const newSale: Model.Sale = response.data;

                    let excludedSaleLines = this.excludeNoRefundItems(newSale);

                    this.showNoRefundReasons(excludedSaleLines).then(() => {
                        const hasLines = (newSale.saleLines && newSale.saleLines.length > 0) || (newSale.tipLines && newSale.tipLines.length > 0);
                        if (!hasLines) {
                            this.busyService.stop();
                            return this.modalService.alert("MESSAGE_REGISTER_NO_REFUNDABLE_ITEMS");
                        }

                        const authorizationPaymentRequestId = this.getAuthorizationPaymentRequestId(this.sale);

                        const newAuthorizationPaymentLine = newSale.paymentLines.find(paymentLine => paymentLine.paymentRequest && paymentLine.paymentRequest.isAuthorization);
                        const newAuthorizationPaymentRequestId = newAuthorizationPaymentLine && newAuthorizationPaymentLine.paymentRequest
                            ? newAuthorizationPaymentLine.paymentRequest.id
                            : null;
                        
                        if (authorizationPaymentRequestId && 
                            newAuthorizationPaymentRequestId &&
                            authorizationPaymentRequestId !== newAuthorizationPaymentRequestId
                        ) {
                            return this.displayRefundMismatchMessage(false, true);
                        }

                        this.sale.mergeClientIds = [];
                        this.sale.changedClientIds = [];

                        const externalRefundTransactionId = this.tippyService.getExternalRefundTransactionId(this.sale);
                        let hasInvalidExternalTipLine = false;

                        _(newSale.saleLines).each((saleLine: Model.SaleLine) => {
                            if (this.isMismatch(externalRefundTransactionId, saleLine.externalTipTransactionId)) {
                                hasInvalidExternalTipLine = true;
                                return;
                            }

                            saleLine.authorizationPaymentRequestId = newAuthorizationPaymentRequestId;

                            saleLine.isTransactionRefund = true;
                            if (saleLine.saleType === Model.SalesTypeEnum.GiftCard || saleLine.saleType === Model.SalesTypeEnum.ReloadGiftCard) {
                                let giftCardSaleLineItem = new Meevo.Plugins.Register.GiftCardSaleLineItem(saleLine.item);
                                if (giftCardSaleLineItem) {
                                    const offset = this.registerGiftCardService.calculateGiftCardRefundOffset(saleLine, giftCardSaleLineItem.clientGiftCard);
                                    saleLine.baseItemPrice = saleLine.basePrice = offset.remainingAmount;
                                    saleLine.finalItemPrice = saleLine.finalPrice = offset.remainingRefundAmount;
                                }
                            } else if (saleLine.saleType == Model.SalesTypeEnum.ClientAccountCredit && !this.refundAccountCreditPermission) {
                                return false;
                            }
                            const saleType = saleLine.saleType === Model.SalesTypeEnum.GiftCard ? Model.SalesTypeEnum.ReloadGiftCard : saleLine.saleType;
                            // put packages redemptions can only have a sale line quantity of 1 so can treat as normal sale line refund
                            if (saleLine.redeemedPackageItems != null &&
                                !saleLine.redeemedPackageItems.find(item => item.itemType == Model.PackageItemTypeEnum.ProductUnit)) {
                                this.addPackageRedeemedRefundSaleLine(saleLine, saleType, saleLine.quantity, false, null, addOriginalClientsToSale, true)
                            }
                            else {
                                if (saleLine.saleType === Model.SalesTypeEnum.Product) {
                                    let item: ProductSaleLineItem = <ProductSaleLineItem>saleLine.item;
                                    item.isResell = this.allowProductRefundingResell;
                                }

                                this.addRefundSaleLine(saleLine, saleType, addOriginalClientsToSale, true);
                            }
                        });

                        _(newSale.tipLines).each((tipLine: Model.TipLine) => {
                            if (this.isMismatch(externalRefundTransactionId, tipLine.externalTipTransactionId)) {
                                hasInvalidExternalTipLine = true;
                                return;
                            }

                            tipLine.authorizationPaymentRequestId = newAuthorizationPaymentRequestId;

                            this.addRefundTipLine(tipLine);
                        });

                        this.updateTip();
                        
                        return this.displayRefundMismatchMessage(hasInvalidExternalTipLine).then(() => {
                            return this.recalculateSale(false, null, true, null, skipAutoAddExistingServices).then(() => {
                                this.tippyService.partialRefundTransaction(this).then(() => {
                                    this.backToSale();
                                    if (!this.switchToPaymentPlanRefund) {
                                        this.selectTicketSection(true);
                                    }
                                });
                                return true;
                            });
                        });
                    });
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        getAuthorizationPaymentRequestId(sale: Model.Sale): string {
            const authorizationSaleLines = _(sale.saleLines).filter(saleLine => saleLine.isRefund && !!saleLine.authorizationPaymentRequestId);
            if (authorizationSaleLines.length > 0) {
                return authorizationSaleLines[0].authorizationPaymentRequestId;
            }
            const authorizationTipLines = _(sale.tipLines).filter(tipLine => tipLine.isRefund && !!tipLine.authorizationPaymentRequestId);
            if (authorizationTipLines.length > 0) {
                return authorizationTipLines[0].authorizationPaymentRequestId;
            }
            return null;
        }

        isMismatch(existingId: string, newId: string) {
            return existingId && newId && existingId !== newId;
        }        

        displayRefundMismatchMessage(hasInvalidExternalTipLine: boolean, hasInvalidPaymentAuthorization: boolean = false) {
            if (hasInvalidExternalTipLine) {
                return this.modalService.alert("MESSAGE_MEEVO_TIPS_MULTIPLE_REFUND_TRANSACTION_RESTRICTION");
            }
            if (hasInvalidPaymentAuthorization) {
                return this.modalService.alert("MESSAGE_MEEVO_TIPS_MULTIPLE_PAYMENT_AUTHORIZATION_RESTRICTION");
            }
            return this.$q.resolve(true);
        }

        getEmployeeDisplayName(saleLine: Model.SaleLine): string {
            if (!saleLine) {
                return "";
            }

            if (saleLine.isRefund && saleLine.saleType === Model.SalesTypeEnum.Membership) {
                return this.$translate.instant("LABEL_CREDITED_TO");
            }
            else if (this.isSaleLineAService(saleLine)) {
                return this.$translate.instant("LABEL_PERFORMED_BY");
            }
            else {
                return this.$translate.instant("LABEL_SOLD_BY");;
            }
        }

        getPackageServices(saleLine) {
            if (!saleLine.packageServices) {
                saleLine.packageServices = _.groupBy(saleLine.item.clientPackage.packageServices, 'serviceId');
            }
            return saleLine.packageServices;
        }

        getPackageProducts(saleLine) {
            if (!saleLine.packageProducts) {
                saleLine.packageProducts = _.groupBy(saleLine.item.clientPackage.packageProducts, 'productVariantId');
            }
            return saleLine.packageProducts;
        }

        getPackageItems(saleLine) {
            if (!saleLine.packageItems && saleLine.item.clientPackage && saleLine.item.clientPackage.packageItems) {
                saleLine.packageItems = _.groupBy(saleLine.item.clientPackage.packageItems, 'itemId');
            }
            return saleLine.packageItems;
        }

        isEditSaleItemAllowed(saleLine: Model.SaleLine): boolean {
            if (saleLine.saleType === Model.SalesTypeEnum.Package) {
                return true;
            }

            if (saleLine.isRefund) {
                return false;
            }

            if (saleLine.saleType === Model.SalesTypeEnum.Membership) {
                return true;
            }

            return false;
        }

        showPackageTransfer(saleLine: Model.SaleLine) {
            this.selectSection(RegisterSectionTypeEnum.PackageTransfer).then(() => {
                this.selectedSection.edit(saleLine);
            });
        }

        gotoNextSection() {
            if (this.selectedClientType === Model.ClientTypeEnum.Client) {
                if (Object.keys(this.sale.onHoldIds).length < 1) {
                    this.checkClientBirthday([this.selectedClient]);
                    this.checkClientRestrictedWarning([this.selectedClient]).then(() => {
                        this.checkClientMembershipCreditCardZipMissing([this.selectedClient]);
                    });
                }
                if (this.showProductRecommendations && !this.isRefundMode && !this.registerTicketService.isPastTransactionMode) {
                    this.productContext.getProductRecommendations().then((numberOfProducts) => {
                        if (numberOfProducts > 0) {
                            this.selectSection(RegisterSectionTypeEnum.Products).then(() => {
                                this.productContext.selectProductRecommendations();
                            });
                        } else {
                            this.selectSection(RegisterSectionTypeEnum.Services);
                        }
                    });
                } else {
                    this.selectSection(RegisterSectionTypeEnum.Services);
                }
            } else {
                this.selectSection(RegisterSectionTypeEnum.Services);
            }
        }

        startSplitCommission(saleLine: Model.SaleLine) {
            if (this.isEmployeeHouseEmployee(saleLine.employee)) {
                this.modalService.alert(this.$translate.instant("MESSAGE_NO_SPLIT_COMMISSION_HOUSE"));
            } else {
                this.postStartSplitCommission(saleLine);
            }
        }

        postStartSplitCommission(saleLine: Model.SaleLine) {
            this.selectSection(RegisterSectionTypeEnum.SplitCommission).then(() => {
                this.selectedSection.edit(saleLine);
                this.dataService.trackUsage(Model.NounEnum.RegisterPage, Model.VerbEnum.SplitCommissionButtonClicked, null);
            });
        }

        isSecondEmployeeActive(saleLine: Model.SaleLine) {
            return saleLine && saleLine.secondEmployeeId &&
                saleLine.saleType !== Meevo.Model.SalesTypeEnum.PackageServiceSwapFee &&
                !this.isPartialRedemptionRemainder(saleLine);
        }

        removeSecondEmployee(saleLine: Model.SaleLine) {
            saleLine.secondEmployee = null;
            saleLine.secondEmployeeId = null;
            saleLine.employeeSplitCommission = null;
            saleLine.secondEmployeeSplitCommission = null;

            this.resetPrepaidTipMinimums(this.sale);

            this.recalculateTip();
        }

        resetPrepaidTipMinimums(sale: Model.Sale) {
            // employee tip structure is changing, reset prepaid tip minimums to recalculate

            for (const tipLine of sale.tipLines) {
                tipLine.prepaidTipMinimum = 0;
            }
        }

        checkClientMembershipCreditCardZipMissing(clients: Model.SaleClient[]): ng.IPromise<any> {
            if (!this.clientCCFileMissingZipCode) {
                return this.$q.resolve();
            }

            if (!clients || clients.length === 0) {
                return this.$q.resolve();
            }


            var clientIds = _(clients).map(client => client.id);

            let request = {
                criteria: {
                    isApproved: true,
                    clientIds: clientIds,
                    IncludeClientPaymentAccounts: false,
                    IncludeMembershipPaymentAccounts: true
                }
            };

            this.dataService.customMethodData(`api/PaymentAccount/List`, "POST", request).then((response) => {
                const paymentAccounts = response.data;

                const missingZip = _(paymentAccounts).filter(x => !x.zipCode || x.zipCode.length === 0 || x.zipCode === '');

                if (missingZip.length === 0) {
                    return this.$q.resolve();
                }

                const clientList = clients.filter(client => _(missingZip).any(x => x.clientGlobalId === client.id));

                let message = [];
                message.push('<div>');
                message.push(this.$translate.instant("MESSAGE_CLIENT_MEMBERSHIP_CREDIT_CARD_ZIP_MISSING"));
                message.push('</div>');
                message.push('<br>');

                const clientNames = clientList.map(client => `<div>${client.lastName}, ${client.firstName}</div>`);
                message = message.concat(clientNames);

                const options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/AppointmentBook/views/Message.html",
                    controller: "meevo.plugins.appointmentBook.MessageController",
                    controllerAs: "vm",
                    bindToController: true,
                    multiple: true,
                    skipHide: true,
                    onComplete: undefined,
                    locals: { message: message.join(''), config: { messageClass: "high" } }
                }
                return this.modalService.showCustom(options);
            });
        }

        checkClientRestrictedWarning(clients: Model.SaleClient[]): ng.IPromise<any> {
            const clientList = _.filter(clients, (client) => { return client && client.isRestricted });

            if (clientList.length > 0) {
                const options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/AppointmentBook/views/Message.html",
                    controller: "meevo.plugins.appointmentBook.MessageController",
                    controllerAs: "vm",
                    bindToController: true,
                    multiple: true,
                    skipHide: true,
                    onComplete: undefined,
                    locals: { message: this.$translate.instant("MESSAGE_CLIENT_RESTRICTED"), config: { messageClass: "high" } }
                }
                return this.modalService.showCustom(options);
            }
            else {
                return this.$q.resolve({});
            }
        }

        checkClientBirthday(clients) {
            let messages: string[] = [];
            let years = [moment().year() - 1, moment().year(), moment().year() + 1];
            clients.forEach((client) => {
                if (client && client.birthMonth && client.birthDay) {
                    years.forEach((year) => {
                        let birthDate = moment().month(client.birthMonth - 1).date(client.birthDay).year(year);
                        if (birthDate >= moment().subtract(15, 'days') &&
                            birthDate <= moment().add(15, 'days')) {

                            let message = client.firstName + "'s birthday ";

                            if (birthDate < moment().startOf('day')) {
                                message += "was";
                            } else {
                                message += "is";
                            }

                            message += ": " + birthDate.format("dddd, MMMM D");

                            messages.push(message);
                        }
                    });
                }
            });

            if (messages.length > 0) {
                this.$timeout(() => {
                    this.$mdToast.show({
                        hideDelay: 3000,
                        controller: "meevo.plugins.register.ClientBirthdayController",
                        position: "top right",
                        parent: angular.element("div#register-section-ticket"),
                        templateUrl: "app/plugins/register/modals/clientBirthdayModal.template.html",
                        controllerAs: "vm",
                        locals: {
                            messages: messages
                        }
                    });
                });
            }
        }

        hasDiscountAffectingCommissions(saleLine: Model.SaleLine): boolean {
            return this.registerDiscountService.hasDiscountAffectingCommissions(saleLine);
        }

        giftCardRecipientClientChanged(saleLine: Model.SaleLine, setToAnonymous: boolean = false) {
            var giftCardItem = saleLine.item as Model.GiftCardSaleLineItem;
            if (setToAnonymous && giftCardItem && giftCardItem.clientGiftCard) {
                giftCardItem.clientGiftCard.clientId = undefined;
                giftCardItem.clientGiftCard.client = this.AnonymousGiftCardPurchasedFor;
                giftCardItem.clientGiftCard.clientType = Model.ClientTypeEnum.AnonymousOther;
            }
            else if (giftCardItem && giftCardItem.clientGiftCard && giftCardItem.clientGiftCard.client) {
                giftCardItem.clientGiftCard.clientId = giftCardItem.clientGiftCard.client.id;
                giftCardItem.clientGiftCard.clientType = Model.ClientTypeEnum.Client;
            }
        }

        packageClientChanged(saleLine: Model.SaleLine) {
            const packageItem = saleLine.item as Model.PackageSaleLineItem;

            if (packageItem && packageItem.clientPackage && packageItem.clientPackage.client) {
                packageItem.clientPackage.clientId = packageItem.clientPackage.client.id;
                packageItem.clientPackage.clientType = Model.ClientTypeEnum.Client;
            }
        }

        isSaleLineGiftCard(saleLine: Model.SaleLine): boolean {
            return saleLine.saleType === Model.SalesTypeEnum.GiftCard
                || saleLine.saleType === Model.SalesTypeEnum.ReloadGiftCard
                || saleLine.saleType === Model.SalesTypeEnum.BulkGiftCard;
        }

        isSaleLineGiftCardReload(saleLine: Model.SaleLine): boolean {
            return saleLine.saleType === Model.SalesTypeEnum.ReloadGiftCard;
        }

        isSaleLineEmployeeVisible(saleLine: Model.SaleLine): boolean {
            if (saleLine.saleType === Model.SalesTypeEnum.PaymentSurcharge && saleLine.isRefund) {
                return false;
            }

            return true;
        }

        isTeacherSaleLine(saleLine: Model.SaleLine): boolean {
            return (this.isSaleLineAService(saleLine) || saleLine.saleType === Model.SalesTypeEnum.Product) &&
                (
                    (saleLine.employee && saleLine.employee.employeeEntityType === Model.EmployeeEntityTypeEnum.Student) ||
                    (saleLine.secondEmployee && saleLine.secondEmployee.employeeEntityType === Model.EmployeeEntityTypeEnum.Student)
                );
        }

        isTeacherVisibleOnEditor(saleLine: Model.SaleLine): boolean {
            if (this.isPartialRedemptionRemainder(saleLine)) {
                return false;
            }

            return this.isTeacherSaleLine(saleLine);
        }

        isPackageTransferVisibleOnEditor(client: RegisterClient, saleLine: Model.SaleLine): boolean {
            return !saleLine.isRefund &&
                client.clientType == Model.ClientTypeEnum.Client &&
                this.isSaleLineItemRedeemableWithPackage(saleLine) &&
                !saleLine.packageRedeemed &&
                !this.isPartialRedemptionRemainder(saleLine)
        }

        applyFullCommision(saleLine: Model.SaleLine) {
            saleLine.isFullCommissionApplicableManuallyChecked = saleLine.isFullCommissionApplicable;
        }

        getMerchantAccountId(): string {
            return this.selectedMerchantAccount && this.selectedMerchantAccount.id;
        }

        getMerchantTerminalId(): string {
            return this.selectedTerminal && this.selectedTerminal.id;
        }

        getMerchantProviderId(): number {
            return this.selectedMerchantAccount && this.selectedMerchantAccount.merchantProviderId;
        }

        getMerchantAccountDirectManualEntry(merchantAccount: Meevo.Model.MerchantAccount = null): boolean {
            merchantAccount = merchantAccount || this.selectedMerchantAccount;
            return merchantAccount && merchantAccount.directManualEntry;
        }

        getMerchantAccountHasLinkedRefundSupport(merchantAccount: Meevo.Model.MerchantAccount = null): boolean {
            merchantAccount = merchantAccount || this.selectedMerchantAccount;
            return merchantAccount && merchantAccount.hasLinkedRefundSupport;
        }

        getMerchantAccountCanVoidTransactions(merchantAccount: Meevo.Model.MerchantAccount = null): boolean {
            merchantAccount = merchantAccount || this.selectedMerchantAccount;
            return merchantAccount && merchantAccount.canVoidTransactions;
        }

        getMerchantAccountCanVoidRefunds(merchantAccount: Meevo.Model.MerchantAccount = null): boolean {
            merchantAccount = merchantAccount || this.selectedMerchantAccount;
            return merchantAccount && merchantAccount.canVoidRefunds;
        }

        getMerchantAccountCanCreateTokens(merchantAccount: Meevo.Model.MerchantAccount = null): boolean {
            merchantAccount = merchantAccount || this.selectedMerchantAccount;
            return merchantAccount && merchantAccount.canCreateTokens;
        }

        getMerchantAccountHasHostedPageSupport(merchantAccount: Meevo.Model.MerchantAccount = null): boolean {
            merchantAccount = merchantAccount || this.selectedMerchantAccount;
            return merchantAccount && merchantAccount.hasHostedPageSupport;
        }

        getMerchantAccountHasHostedPageUnlinkedRefundSupport(merchantAccount: Meevo.Model.MerchantAccount = null): boolean {
            merchantAccount = merchantAccount || this.selectedMerchantAccount;
            return merchantAccount && merchantAccount.hasHostedPageUnlinkedRefundSupport;
        }

        getMerchantAccountHasCardOnFileUnlinkedRefundSupport(merchantAccount: Meevo.Model.MerchantAccount = null): boolean {
            merchantAccount = merchantAccount || this.selectedMerchantAccount;
            return merchantAccount && merchantAccount.hasCardOnFileUnlinkedRefundSupport;
        }

        getMerchantAccountIsHostedPageEnabled(merchantAccount: Meevo.Model.MerchantAccount = null): boolean {
            merchantAccount = merchantAccount || this.selectedMerchantAccount;
            return merchantAccount && merchantAccount.isHostedPageEnabled;
        }

        getMerchantAccountHasRegisterSupport(merchantAccount: Meevo.Model.MerchantAccount = null): boolean {
            merchantAccount = merchantAccount || this.selectedMerchantAccount;
            return merchantAccount && merchantAccount.hasRegisterSupport;
        }

        getMerchantAccountHasCardOnFileSecurityCodeSupport() {
            return this.selectedMerchantAccount && this.selectedMerchantAccount.hasCardOnFileSecurityCodeSupport;
        }

        getTotalTipFromDevice(): number {
            if (!this.creditCardProcessingEnabled) {
                return 0;
            }

            if (!this.sale.deviceTip) {
                return 0;
            }

            return this.normalizeDecimalPlaces(this.sale.deviceTip);
        }

        getTotalTipPercentageFromDevice(): number {
            if (!this.creditCardProcessingEnabled) {
                return 0;
            }

            return this.sale.deviceTipPercentage;
        }

        getServiceTotalFromDevice(): number {
            if (!this.creditCardProcessingEnabled) {
                return 0;
            }

            return this.sale.deviceServiceTotal;
        }

        getTotalTipFromPrepaid(): number {
            return Math.max(0, this.normalizeDecimalPlaces(this.sale.totalPrepaidTipRedeemed));
        }

        getIsHostedPageAutomaticallySwitch(): boolean {
            if (this.selectedMerchantAccount) {
                return this.selectedMerchantAccount.isHostedPageAutomaticallySwitch;
            }

            return false;                
        }

        isService(saleLine: Model.SaleLine): boolean {
            return saleLine && saleLine.saleType === Model.SalesTypeEnum.Service;
        }

        isProduct(saleLine: Model.SaleLine): boolean {
            return saleLine && saleLine.saleType === Model.SalesTypeEnum.Product;
        }

        getLotExpirationDisplay(variantLot: any): string {
            if (!variantLot || !variantLot.expirationDate) {
                return "";
            }
            const filter: any = this.$filter;
            const meevoDate = filter("meevoDateFilter");
            if (!meevoDate) {
                return "";
            }
            const isExpired = moment(variantLot.expirationDate).isBefore(moment().startOf("day"));
            return this.$translate.instant("LABEL_EXPIRATION_DATE_PREFIX")
                + meevoDate(variantLot.expirationDate)
                + (isExpired ? " (" + this.$translate.instant("LABEL_EXPIRED") + ")" : "");
        }

        getDistinctHistoricalLots(historicalLotAllocations: Model.SaleLineProductLot[]): any[] {
            if (!historicalLotAllocations) {
                return [];
            }
            const out: any[] = [];
            const seen: { [id: string]: boolean } = {};
            _.each(historicalLotAllocations, (l: any) => {
                if (l && l.variantLot && l.variantLotId != null && !seen[l.variantLotId]) {
                    seen[l.variantLotId] = true;
                    out.push(l.variantLot);
                }
            });
            return out;
        }

        getHistoricalLotAllocations(saleLine: Model.SaleLine): Model.SaleLineProductLot[] {
            const item = <any>(saleLine && saleLine.item);
            return (item && item.historicalLotAllocations) || [];
        }

        isSingleHistoricalLot(saleLine: Model.SaleLine): boolean {
            if (!saleLine.isRefund) {
                return false;
            }
            const distinct = this.getDistinctHistoricalLots(this.getHistoricalLotAllocations(saleLine));
            return distinct.length === 1;
        }

        getTotalHistoricalLotQty(saleLine: Model.SaleLine): number {
            return _.reduce(this.getHistoricalLotAllocations(saleLine),
                (sum: number, l: any) => sum + (+l.quantity || 0), 0);
        }

        isReturningAllHistoricalLots(saleLine: Model.SaleLine): boolean {
            if (!saleLine.isRefund) {
                return false;
            }
            const distinct = this.getDistinctHistoricalLots(this.getHistoricalLotAllocations(saleLine));
            if (distinct.length <= 1) {
                return false;
            }
            return saleLine.quantity === this.getTotalHistoricalLotQty(saleLine);
        }

        isReadOnlyLotDisplay(saleLine: Model.SaleLine): boolean {
            return this.isSingleHistoricalLot(saleLine) || this.isReturningAllHistoricalLots(saleLine);
        }

        syncRefundLotAllocations(saleLine: Model.SaleLine): void {
            if (!saleLine || !saleLine.isRefund) {
                return;
            }
            const item = <any>saleLine.item;
            if (!item) {
                return;
            }

            if (this.isSingleHistoricalLot(saleLine)) {
                const allocations = item.lotAllocations;
                if (allocations && allocations.length) {
                    const lot = allocations[0];
                    lot.quantity = saleLine.quantity;
                    lot.lastQuantity = saleLine.quantity;
                }
                return;
            }

            const historical = this.getHistoricalLotAllocations(saleLine);
            if (historical.length <= 1) {
                return;
            }

            const totalHistoricalQty = this.getTotalHistoricalLotQty(saleLine);
            if (saleLine.quantity === totalHistoricalQty) {
                // Spinner is at full — show every historical lot read-only.
                item.lotAllocations = _.map(historical, (l: any) => ({
                    variantLotId: l.variantLotId,
                    variantLot: l.variantLot,
                    quantity: l.quantity
                }));
                return;
            }

            // Spinner dropped below full. If we're transitioning out of the "returning all"
            // read-only state, reset to a single empty row so the user starts the partial
            // allocation from scratch.
            const allocations = item.lotAllocations || [];
            const wasReturningAll = allocations.length === historical.length
                && _.every(allocations, (l: any) => l && l.variantLotId);
            if (wasReturningAll) {
                item.lotAllocations = [{
                    variantLotId: null,
                    variantLot: null,
                    quantity: 1
                }];
            }
        }

        getHistoricalLotOptions(saleLine: Model.SaleLine, currentLot?: any): any[] {
            const options = this.getDistinctHistoricalLots(this.getHistoricalLotAllocations(saleLine));
            if (!options.length) {
                return [];
            }
            const chosen: { [id: string]: boolean } = {};
            const item = <any>(saleLine.item);
            _.each((item && item.lotAllocations) || [], (l: any) => {
                if (l && l !== currentLot && l.variantLotId) {
                    chosen[l.variantLotId] = true;
                }
            });
            return _.filter(options, (opt: any) => !chosen[opt && opt.variantLot_TId]);
        }

        getHistoricalLotMaxQty(saleLine: Model.SaleLine, variantLotId: any): number | null {
            if (!variantLotId) {
                return null;
            }
            const historical = this.getHistoricalLotAllocations(saleLine);
            if (!historical.length) {
                return null;
            }
            let total = 0;
            let found = false;
            _.each(historical, (l: any) => {
                if (l && l.variantLotId === variantLotId) {
                    total += +l.quantity || 0;
                    found = true;
                }
            });
            return found ? total : null;
        }

        onHistoricalLotSelected(saleLine: Model.SaleLine, lot: any): void {
            if (!saleLine || !lot) {
                return;
            }
            // md-select binds to lot.variantLotId (a primitive) to survive recalc round-trips
            // without losing object reference equality. Re-derive the nav object for display.
            const options = this.getDistinctHistoricalLots(this.getHistoricalLotAllocations(saleLine));
            lot.variantLot = _.find(options, (opt: any) => opt && opt.variantLot_TId === lot.variantLotId) || null;
            // Reset the row's qty whenever the lot changes — the user must explicitly state
            // how many of the newly selected lot they want to refund.
            lot.quantity = 1;
            lot.lastQuantity = 1;
        }

        onLotQuantityChanged(saleLine: Model.SaleLine, lot: any): void {
            if (!lot) {
                return;
            }
            if (saleLine && saleLine.isRefund) {
                const max = this.getHistoricalLotMaxQty(saleLine, lot.variantLotId);
                if (max != null && +lot.quantity > max) {
                    this.modalService.alert(
                        this.$translate.instant("MESSAGE_REFUND_LOT_QTY_EXCEEDS_MAX", { max: max }),
                        Components.Modal.ModalTranslationModes.DoNotTranslate
                    );
                    lot.quantity = lot.lastQuantity != null ? lot.lastQuantity : max;
                    return;
                }
            }
            lot.lastQuantity = lot.quantity;
        }

        addLotAllocation(saleLine: Model.SaleLine): void {
            const item = <any>saleLine.item;
            if (!item.lotAllocations) {
                item.lotAllocations = [];
            }
            this.lotUtil.addRow(item.lotAllocations);
        }

        resetLotLastQuantities(saleLine: Model.SaleLine): void {
            if (!saleLine || !saleLine.isRefund) {
                return;
            }
            const item = <any>saleLine.item;
            if (!item || !item.lotAllocations) {
                return;
            }
            _.each(item.lotAllocations, (l: any) => {
                if (l) {
                    l.lastQuantity = l.quantity;
                }
            });
        }

        canAddLotAllocation(saleLine: Model.SaleLine): boolean {
            if (saleLine.quantity <= 1 || !this.hasLotQtyMismatch(saleLine)) {
                return false;
            }
            if (saleLine.isRefund && (<any>saleLine).refundSaleLineId) {
                const options = this.getDistinctHistoricalLots(this.getHistoricalLotAllocations(saleLine));
                const rows = (<any>saleLine.item).lotAllocations || [];
                return rows.length < options.length;
            }
            return true;
        }

        hasLotQtyMismatch(saleLine: Model.SaleLine): boolean {
            const item = <any>saleLine.item;
            if (!item || !item.isLotTracked) {
                return false;
            }
            // Pre-tracking refund (tied to a historical sale): variant tracks lots now but the
            // original sale has no historical lot rows. No allocations expected, no mismatch.
            // Manual-mode refunds (no refundSaleLineId) use normal qty-match behavior.
            if (saleLine.isRefund && (<any>saleLine).refundSaleLineId && (!item.historicalLotAllocations || item.historicalLotAllocations.length === 0)) {
                return false;
            }
            return this.lotUtil.isQtyMismatch(item.lotAllocations, saleLine.quantity);
        }

        getLotQtyMismatchMessage(saleLine: Model.SaleLine): string {
            const item = <any>saleLine.item;
            if (!item || !item.isLotTracked) {
                return "";
            }
            if (saleLine.isRefund && !(<any>saleLine).refundSaleLineId) {
                if (this.lotUtil.qtyTotalForSelected((<any>saleLine.item).lotAllocations) > saleLine.quantity) {
                    return this.$translate.instant("LABEL_LOT_QTY_TOTAL_EXCEEDS",
                        { lotTotal: this.lotUtil.qtyTotalForSelected((<any>saleLine.item).lotAllocations), itemQty: saleLine.quantity });
                }
                return "";
            }
            if (this.hasLotQtyMismatch(saleLine)) {
                return this.$translate.instant("LABEL_LOT_QTY_TOTAL_MISMATCH",
                    { itemQty: saleLine.quantity });
            }
            return "";
        }

        areLotsValid(saleLine: Model.SaleLine): boolean {
            const item = <any>saleLine.item;
            // Service product-usage lots (WI 124157): a service line carries lot-tracked product
            // usage rather than item-level lot allocations. Gate Pay Now on those too.
            if (item && item.productUsage && !this.areUsageLotsValid(saleLine)) {
                return false;
            }
            if (!item || !item.isLotTracked) {
                return true;
            }
            if (saleLine.isRefund && !(<any>saleLine).refundSaleLineId) {
                return this.lotUtil.qtyTotalForSelected((<any>saleLine.item).lotAllocations) <= saleLine.quantity;
            }
            const allocations = item.lotAllocations || [];
            if (allocations.length === 0) {
                // Pre-tracking refund: variant tracks lots now, but the original sale was
                // made before tracking was enabled so there's no history to validate against.
                // Per spec §3e / §5, Apply Refund must not be blocked in this case.
                if (saleLine.isRefund) {
                    const historical = item.historicalLotAllocations || [];
                    return historical.length === 0;
                }
                return false;
            }
            if (!this.lotUtil.allRowsHaveLot(allocations)) {
                return false;
            }
            return !this.hasLotQtyMismatch(saleLine);
        }

        areAllLotsValid(): boolean {
            if (!this.sale || !this.sale.saleLines) {
                return true;
            }
            return _.every(this.sale.saleLines, (sl: Model.SaleLine) => this.areLotsValid(sl));
        }

        areUsageLotsValid(saleLine: Model.SaleLine): boolean {
            const item = <any>(saleLine && saleLine.item);
            const productUsage = item && item.productUsage;
            if (!productUsage || !productUsage.variants) {
                return true;
            }
            return _.every(productUsage.variants, (v: any) =>
                !v.isLotTracked || this.lotUtil.areAllocationsValidForQty(v.lotAllocations, v.usageAmount));
        }

        hasPendingUsageLot(saleLine: Model.SaleLine): boolean {
            return !this.areUsageLotsValid(saleLine);
        }

        getProductUsageTooltip(saleLine: Model.SaleLine): string {
            return this.hasPendingUsageLot(saleLine)
                ? this.$translate.instant("TOOLTIP_REGISTER_PRODUCT_USAGE_LOT_REQUIRED")
                : this.$translate.instant("TOOLTIP_REGISTER_PRODUCT_USAGE");
        }

        private scrollToFirstInvalidLot(): void {
            const invalidLine = _.find(this.sale.saleLines, (sl: Model.SaleLine) => !this.areLotsValid(sl));
            if (!invalidLine) {
                return;
            }

            const rClient = new RegisterClient({
                clientType: invalidLine.clientType,
                client: invalidLine.client,
                appointmentId: invalidLine.appointmentId
            });
            this.selectClient(rClient, true);

            const rClientIndex = this.getRegisterClient(rClient, _.findIndex);
            let clientLineIndex = 0;
            for (let i = 0; i < this.sale.saleLines.length; i++) {
                const sl = this.sale.saleLines[i];
                if (rClient.isMatch(sl)) {
                    if (sl === invalidLine) {
                        break;
                    }
                    clientLineIndex++;
                }
            }

            this.$timeout(() => {
                const registerClient = $(".register-items" + rClientIndex);
                const clientSaleLine = registerClient.find(".vAccordion--default .vPane" + clientLineIndex);
                if (clientSaleLine.length > 0 && typeof clientSaleLine[0].scrollIntoView === "function") {
                    clientSaleLine[0].scrollIntoView({ behavior: "smooth", block: "center" });
                }
            });
        }

        isPackageTransfer(saleLine: Model.SaleLine): boolean {
            return saleLine && saleLine.saleType === Model.SalesTypeEnum.PackageTransfer;
        }

        isServiceType(saleLine: Model.SaleLine): boolean {
            return saleLine && (
                this.isService(saleLine) ||
                saleLine.saleType === Model.SalesTypeEnum.ServiceCancellationFee ||
                saleLine.saleType === Model.SalesTypeEnum.ServiceNoShowFee
            );
        }

        isSaleLineAService(saleLine: Model.SaleLine): boolean {
            return this.isServiceType(saleLine);
        }

        isSaleLineItemRedeemableWithPackage(saleLine: Model.SaleLine): boolean {
            return this.isServiceType(saleLine) || this.isProduct(saleLine);
        }

        isPackageType(saleLine: Model.SaleLine): boolean {
            return saleLine && (
                saleLine.saleType === Meevo.Model.SalesTypeEnum.Package ||
                saleLine.saleType === Meevo.Model.SalesTypeEnum.PackageTransfer ||
                saleLine.saleType === Meevo.Model.SalesTypeEnum.PackageSplit ||
                saleLine.saleType === Meevo.Model.SalesTypeEnum.PackageMerge
            );
        }

        isSaleLineAPackageRefund(saleLine: Model.SaleLine): boolean {
            return saleLine && saleLine.saleType === Meevo.Model.SalesTypeEnum.PackageRefund;
        }

        getEmployeeFieldContentKey(saleLine: Model.SaleLine): string {
            if (this.isSaleLineAPackageRefund(saleLine)) {
                return 'LABEL_SOLD_BY';
            }

            return this.canViewStudentTeacherModule ?
                'LABEL_LOOKUP_EMPLOYEE_STUDENT' :
                'LABEL_LOOKUP_EMPLOYEE';
        }

        isTicketCharge(saleLine: Model.SaleLine): boolean {
            return saleLine && saleLine.saleType === Model.SalesTypeEnum.TicketCharge;
        }

        isSaleLineEditable(saleLine: Model.SaleLine, forRefund: boolean = false): boolean {
            if (saleLine.isRefund && !forRefund) {
                return false;
            }

            return saleLine && (
                saleLine.saleType === Meevo.Model.SalesTypeEnum.Package ||
                saleLine.saleType === Meevo.Model.SalesTypeEnum.Membership ||
                saleLine.saleType === Meevo.Model.SalesTypeEnum.ClientAccountCredit ||
                (saleLine.saleType === Model.SalesTypeEnum.Product && (<CustomProductBundleSaleLineItem>saleLine.item).productBundle) ||
                saleLine.saleType === Meevo.Model.SalesTypeEnum.BulkGiftCard
            );
        }

        removeRedemptionForPackage(packageIdBeingSold, sale?: Model.Sale) {
            sale = sale || this.sale;
            let newPackageIds = [packageIdBeingSold];
            let morePackagesFound = true;
            while (morePackagesFound) {
                morePackagesFound = false;
                _(sale.saleLines).each(packageSaleLine => {
                    if (packageSaleLine.packageRedemptionPath &&
                        packageSaleLine.packageRedemptionPath.clientPackagesCreated &&
                        packageSaleLine.packageRedemptionPath.clientPackagesUsed &&
                        _(packageSaleLine.packageRedemptionPath.clientPackagesUsed).any(usedPackage => newPackageIds.indexOf(usedPackage.id) !== -1)) {
                        packageSaleLine.packageRedemptionPath.clientPackagesCreated.forEach(createdPackage => {
                            if (newPackageIds.indexOf(createdPackage.id) === -1) {
                                newPackageIds.push(createdPackage.id);
                                morePackagesFound = true;
                            }
                        });
                    }
                });
            }

            _(sale.saleLines).each(packageSaleLine => {
                if (!packageSaleLine) {
                    // potentially removed saleline by removePackageRedemption
                    return;
                }
                if (packageSaleLine.redeemedPackages &&
                    _(packageSaleLine.redeemedPackages).any(usedPackage => newPackageIds.indexOf(usedPackage.id) !== -1)) {
                    this.removePackageRedemption(packageSaleLine, false);
                }
            });
        }

        getAccountBalanceColor(balance: number): string {
            if (balance > 0) {
                return 'green';
            }
            else if (balance < 0) {
                return 'red';
            } else {
                return 'black';
            }
        }

        getRefundItemCreditCardPayments(): ng.IPromise<boolean> {
            return this.getPaymentRequestBasedOnRefundItems(true).then((requests) => {
                this.paymentRequestsBasedOnRefundItems = requests;
                return requests.length > 0;
            });
        }

        getPaymentCategoriesForCredit(): ng.IPromise<RegisterPaymentCat[]> {
            return this.getRefundItemCreditCardPayments().then((refundItemsHaveCreditCardPayments) => this.loadPaymentCategories().then((paymentCategories) => {
                    let paymentCategoriesCreditMode = angular.copy(paymentCategories);

                    let giftCard = _(paymentCategoriesCreditMode).findWhere({ paymentCategory: Model.PaymentCategoryEnum.GiftCard });
                    if (giftCard) {
                        giftCard.sectionType = RegisterSectionTypeEnum.GiftCard;
                    }

                const restrictCash = this.restrictCashRefundsWhenCreditCardPaymentExists && refundItemsHaveCreditCardPayments;

                    paymentCategoriesCreditMode = _(paymentCategoriesCreditMode).filter((paymentCategory: RegisterPaymentCat) =>
                        (!restrictCash && paymentCategory.paymentCategory === Model.PaymentCategoryEnum.Cash) ||
                        paymentCategory.paymentCategory === Model.PaymentCategoryEnum.CreditDebit ||
                        paymentCategory.paymentCategory === Model.PaymentCategoryEnum.CareCredit ||
                        paymentCategory.paymentCategory === Model.PaymentCategoryEnum.Check ||
                        paymentCategory.paymentCategory === Model.PaymentCategoryEnum.GiftCard ||
                        paymentCategory.paymentCategory === Model.PaymentCategoryEnum.ClientAccount ||
                        paymentCategory.paymentCategory === Model.PaymentCategoryEnum.Other
                    );

                    paymentCategoriesCreditMode = _(paymentCategoriesCreditMode).filter((paymentCategory: RegisterPaymentCat) =>
                        paymentCategory.sectionType !== RegisterSectionTypeEnum.CreditSingleCard &&
                        paymentCategory.sectionType !== RegisterSectionTypeEnum.Self
                    );

                    if (!this.getMerchantAccountHasCardOnFileUnlinkedRefundSupport() || !this.creditCardProcessingEnabled) {
                        paymentCategoriesCreditMode = _(paymentCategoriesCreditMode).filter((paymentCategory: RegisterPaymentCat) =>
                            paymentCategory.sectionType !== RegisterSectionTypeEnum.CardOnFile
                        );
                    }

                    _(paymentCategoriesCreditMode).each((paymentCategory: RegisterPaymentCat) => {
                        paymentCategory.securityKey = 'REGISTER:REGISTER:ACTION:PAYMENTCAT' + paymentCategory.paymentCategory;
                    });

                    let multiCard = _(paymentCategoriesCreditMode).findWhere({ sectionType: RegisterSectionTypeEnum.CreditMultiCard });
                    if (multiCard) {
                        multiCard.displayName = multiCard.originalDisplayName;
                        this.getCreditCardRefundSecurityKey().then((response) => {
                            multiCard.securityKey = response;
                        });
                    }

                    let cardOnFile = _(paymentCategoriesCreditMode).findWhere({ sectionType: RegisterSectionTypeEnum.CardOnFile });
                    if (cardOnFile) {
                        cardOnFile.securityKey = this.meevoSecurityKeys.REGISTER_REGISTER_ACTION_PAYMENTCATCARDONFILE;
                    }

                    let clientAccount = _(paymentCategoriesCreditMode).findWhere({ paymentCategory: Model.PaymentCategoryEnum.ClientAccount });
                    if (clientAccount) {
                        clientAccount.displayName = this.$translate.instant('LABEL_CLIENT_ACCOUNT');
                    }

                    return paymentCategoriesCreditMode;
            }));
        }

        getChangeDue(isCash: boolean = false, sale: Model.Sale = null): number {
            sale = sale || this.sale;

            if (!sale) {
                return 0;
            }

            if (isCash) {
                var cashPaymentTotal: number = 0;
                _(sale.paymentLines)
                    .filter(paymentLine => paymentLine.paymentCategory === Model.PaymentCategoryEnum.Cash)
                    .forEach(paymentLine => cashPaymentTotal = this.addNormalizedNumbers(cashPaymentTotal, paymentLine.amount));

                return this.addNormalizedNumbers(
                    this.roundingService.cashRoundingInterval(
                        this.financialInfo,
                        this.subtractNormalizedNumbers(sale.changeDue, cashPaymentTotal)
                    ), cashPaymentTotal);
            }

            return sale.changeDue;
        }

        hasExternalTipAmountDue(sale: Model.Sale = null): boolean {
            if (!this.hasMeevoPaySplitFunding()) {
                return false;
            }

            return this.getExternalTipAmountDue(sale) > 0;
        }

        hasExternalTipRefundDue(sale: Model.Sale = null): boolean {
            return this.getExternalTipRefundDue(sale) < 0;
        }

        isMeevoPayProvider() {
            if (!this.selectedDrawer) { 
                return false;
            }

            return this.selectedDrawer.merchantProviderId === Meevo.Model.MerchantAccountProviderEnum.Adyen ||
                   this.selectedDrawer.merchantProviderId === Meevo.Model.MerchantAccountProviderEnum.AdyenCanada;
        }

        hasMeevoPaySplitFunding() {
            return this.hasMeevoPaySplitFundingEnabled && this.isMeevoPayProvider();
        }

        getExternalTipAmountDue(sale: Model.Sale = null): number {
            sale = sale || this.sale;

            if (!sale) {
                return 0;
            }

            if (this.hasPaymentAuthorization(sale)) {
                return 0;
            }

            const eligibleTipLines = sale.tipLines.filter(tipLine => !tipLine.isRefund && tipLine.externalTipTransactionId);
            const totalExternalTipAmount = eligibleTipLines.reduce((total, tipLine) => this.addNormalizedNumbers(total, tipLine.externalAmount || 0), 0);
            const totalExternalTipFee = sale.tipConvenienceFee;

            return this.addNormalizedNumbers(totalExternalTipAmount, totalExternalTipFee);
        }

        getCreditBackToClient() {
            return Math.max(-this.getExternalTipRefundDue(), this.getChangeDue());
        }

        private isRefundSplitFunded() {
            if (!this.paymentRequestsBasedOnRefundItems) {
                return false;
            }
            for (const card of this.paymentRequestsBasedOnRefundItems) {
                if (card.paymentRequestList && card.paymentRequestList.some(paymentRequest => paymentRequest.isAuthorization)) {
                    return true;
                }
            }
            return false;
        }

        getExternalTipRefundDue(sale: Model.Sale = null): number {
            sale = sale || this.sale;

            if (!sale) {
                return 0;
            }

            if (!this.isRefundSplitFunded()) {
                return 0;
            }

            if (this.hasProjectedRefund(sale)) {
                return 0;
            }

            const eligibleSaleLines = sale.saleLines.filter(saleLine => saleLine.isRefund && saleLine.externalTipTransactionId);
            const externalTipChargeAmount = -eligibleSaleLines.reduce((total, saleLine) => 
                this.addNormalizedNumbers(total, saleLine.charges.filter(charge => charge.chargeType === Model.ChargeTypeEnum.EmployeeTip).reduce((chargeTotal, charge) =>
                    this.addNormalizedNumbers(chargeTotal, charge.chargeAmount || 0), 0)), 0);

            const eligibleTipLines = sale.tipLines.filter(tipLine => tipLine.isRefund && tipLine.externalTipTransactionId);
            const externalTipAmount = eligibleTipLines.reduce((total, tipLine) => this.addNormalizedNumbers(total, (tipLine.amount || 0) - (tipLine.prepaidTipMinimum || 0)), 0);
            const externalTipFee = sale.tipConvenienceFeeRefund;

            const externalTipRefund = this.addNormalizedNumbers(externalTipAmount, externalTipFee);

            return this.addNormalizedNumbers(externalTipRefund, externalTipChargeAmount);
        }

        getCashChangeDue(): number {
            return this.addNormalizedNumbers(this.getChangeDue(), this.getCashRounding());
        }

        getCashRounding(): number {
            if (!this.sale) {
                return 0;
            }

            return this.sale.cashRounding || 0;
        }

        hasChangeDueWithRefunds(): boolean {
            return this.hasRefundsInSale() && this.getCashChangeDue() > 0;
        }

        hasCreditWithRefunds(): boolean {
            if (this.hasExternalTipRefundDue()) {
                return true;
            }            

            if (this.hasExternalTipAmountDue()) {
                return false;
            }

            return this.hasChangeDueWithRefunds() && this.getTotalFinalSales() <= Math.abs(this.getTotalFinalRefunds());
        }

        isFinalizeSaleVisible(): boolean {
            return !this.isRefundReason() && !this.hasCreditWithRefunds() && this.isFinalize();
        }

        hasRefundsInSale(): boolean {
            if (!this.sale) {
                return false;
            }

            return _(this.sale.saleLines).any(saleLine => saleLine.isRefund) || _(this.sale.tipLines).any(tipLine => tipLine.isRefund);
        }

        isGiftCard(saleLine: Model.SaleLine, excludeBulkGiftCards: boolean = false): boolean {
            return saleLine.saleType === Model.SalesTypeEnum.GiftCard || saleLine.saleType === Model.SalesTypeEnum.ReloadGiftCard ||
                (saleLine.saleType === Model.SalesTypeEnum.BulkGiftCard && !excludeBulkGiftCards);
        }

        isReloadGiftCardRefund(saleLine: Model.SaleLine) {
            return saleLine.isRefund && saleLine.saleType === Model.SalesTypeEnum.ReloadGiftCard;
        }

        getGiftCardNumberDisplay(saleLine: Model.SaleLine): string {
            if (saleLine.saleType === Model.SalesTypeEnum.BulkGiftCard) {
                const bulkGiftCardSaleLineItem = (saleLine.item as Model.GiftCardBulkSaleLineItem);
                return `#${bulkGiftCardSaleLineItem.giftCardNumberStarting} - #${bulkGiftCardSaleLineItem.giftCardNumberEnding}`;
            }

            return (saleLine.item as Model.GiftCardSaleLineItem).clientGiftCard.giftCardNumber;
        }

        isMembership(saleLine: Model.SaleLine): boolean {
            return saleLine.saleType === Model.SalesTypeEnum.Membership;
        }

        isMembershipUpgrade(saleLine: Model.SaleLine): boolean {
            return saleLine.saleType === Model.SalesTypeEnum.Membership &&
                !!(<MembershipUpgradeSaleLineItem>saleLine.item).originalMembershipId;
        }

        isPackage(saleLine: Model.SaleLine): boolean {
            return saleLine.saleType === Model.SalesTypeEnum.Package || saleLine.saleType === Model.SalesTypeEnum.PackageRefund;
        }

        isCustomPackage(saleLine: Model.SaleLine): boolean {
            if (!this.isPackage(saleLine)) {
                return false;
            }

            var packageSaleLineItem = saleLine.item as Model.PackageSaleLineItem;

            if (!packageSaleLineItem) {
                return false;
            }

            return packageSaleLineItem.clientPackage.packageCreationType === Meevo.Model.PackageCreationTypeEnum.Custom;
        }

        isPackageRefund(saleLine: Model.SaleLine): boolean {
            return saleLine.isRefund && this.isPackage(saleLine);
        }

        public displayNotification = (isRefundedItem) => {
            this.showTicketStatus = true;
            if (isRefundedItem) {
                this.showRefundStatus = true;
            }


            this.$timeout(5000).then(() => {
                this.showTicketStatus = false;
                this.showRefundStatus = false;
            });

        }

        isLayoutCollapsed(): boolean {
            return !this.selectedSection || this.selectedSection.sectionCatType !== RegisterSectionCatTypeEnum.Sale || this.showDrawerManager || this.isRefundMode;
        }

        isSaleDiscountable(): boolean {
            return this.registerDiscountService.isSaleDiscountable(this.sale.saleLines);
        }

        goToManualPredefinedDiscounts() {
            this.selectSection(RegisterSectionTypeEnum.Discounts).then(() => {
                (this.selectedSection as DiscountsSection).switchDiscountType(0);
            });
        }

        searchAndApplyScannedDiscountId(discountBarCode: string): ng.IPromise<any> {
            this.sale.discountBarCodeToBeApplied = discountBarCode;
            return this.recalculateSale().finally(() => {
                this.sale.discountBarCodeToBeApplied = "";
            });
        }

        getTaxListText(sale: Model.Sale) {
            if (!sale || !sale.saleLines || sale.saleLines.length === 0) {
                return "";
            }

            const taxList = _(sale.taxes).filter(tax => tax.isIncludedInPrice);
            if (taxList.length === 0) {
                return "";
            }

            const taxNameList = _(_.mapObject(_(taxList).groupBy((tax) => tax.taxTypeId), (values, taxTypeId) => values[0].taxTypeDisplayName)).values();
            const includingTax = this.$translate.instant("LABEL_INCLUDING_TAX");

            return `(${includingTax} ${taxNameList.join(', ')})`;
        }

        getTaxListNotIncludedInPrice(sale: Model.Sale) {
            if (!sale || !sale.taxes) {
                return null;
            }

            return _(sale.taxes).filter(tax => !tax.isIncludedInPrice);
        }

        private _reversePaymentRequest: Model.PaymentRequest = null;
        startReversePaymentRequest(amountToReverse: number, offsetIds: string[] = null, parentRequestId: string = null, forceManualEntry: boolean = false): ng.IPromise<boolean> {
            let deferred = this.$q.defer<boolean>();

            this._reversePaymentRequest = {
                amount: Math.abs(amountToReverse) * ((amountToReverse > 0) ? -1 : 1),
                requestedAmount: Math.abs(amountToReverse) * ((amountToReverse > 0) ? -1 : 1),
                paymentCategory: Model.PaymentCategoryEnum.CreditDebit,
            };
            if (parentRequestId != null) {
                this._reversePaymentRequest.parentId = parentRequestId;
            }
            let request = {
                paymentRequest: this._reversePaymentRequest,
                merchantTerminalId: this.selectedTerminal.id,
                externalTerminalId: this.selectedTerminal.externalTerminalId,
                merchantAccountId: this.selectedDrawer.merchantAccountId,
                sale: this.sale,
                paymentAccountId: null,
                forceManualEntry: forceManualEntry,
                isReversal: true,
                offsetIds: offsetIds
            };

            this.busyService.start("LABEL_CREDIT_DEBIT_PENDING_PROCESSING", true);
            let promise = this.dataService
                .customMethodData(`api/Drawer/${this.selectedDrawer.id}/PaymentRequest`, "POST", request)
                .then(this.processPaymentSuccessCallback)
                .catch((response) => {
                    return false;
                })
                .finally(() => {
                    this._reversePaymentRequest = null;
                    this.busyService.stop();
                });

            this.sale.paymentLines.forEach((paymentLine) => {
                if (paymentLine.paymentCategory === Model.PaymentCategoryEnum.CreditDebit) {
                    (<Model.SaleCreditCardPayment>paymentLine).reverse = false;
                }
            });

            deferred.resolve(promise);

            return deferred.promise;
        }

        processPaymentSuccessCallback = (response): ng.IPromise<boolean> | boolean => {
            if (response.status == 409) { // conflict
                return false;
            }

            // need to get the paymentTypeId/paymentType
            var processedPayment: Model.PaymentRequest = response.data;
            if (processedPayment.paymentRequestStatus === Model.PaymentRequestStatusEnum.SignatureVerificationPending) {
                // auto-accept reversals
                let signatureRequest = {
                    parentId: processedPayment.parentId,
                    merchantTerminalId: processedPayment.merchantTerminalId,
                    externalTerminalId: processedPayment.externalTerminalId,
                    sale: this.sale,
                    onHoldId: processedPayment.onHoldId,
                    accepted: true
                };
                let url = `api/Drawer/${this.selectedDrawer.id}/PaymentRequest/${processedPayment.id}/Signature`;
                return this.dataService.customMethodData(url, "POST", signatureRequest)
                    .then((signatureResponse) => {
                        var processedPayment: Model.PaymentRequest = signatureResponse.data;
                        this.sale.onHoldIds = {};
                        if (processedPayment.onHoldId) {
                            this.sale.onHoldIds[processedPayment.onHoldId] = Meevo.Model.HoldTypeEnum.Recovery;
                        }
                        if (processedPayment.processorResponseCode != Model.ProcessorResponseCodeEnum.SignatureRejected) {
                            return this.processPaymentSuccessCallback(signatureResponse);
                        }
                        else {
                            return false;
                        }
                    }, (errorResponse) => {
                        return false;
                    });

            }
            else {
                this.sale.onHoldIds = {};
                if (processedPayment.onHoldId) {
                    this.sale.onHoldIds[processedPayment.onHoldId] = Meevo.Model.HoldTypeEnum.Recovery;
                }
                if (processedPayment.paymentRequestStatus === Model.PaymentRequestStatusEnum.Approved) {
                    this.printCreditCardReceiptsForReversal(processedPayment);
                    return true;
                }
                else {
                    if (processedPayment.creditCardProcessorStatus) {
                        let message = this.$translate.instant(processedPayment.creditCardProcessorStatus.message);
                        if (message === processedPayment.creditCardProcessorStatus.message) {
                            message = this.$translate.instant("MESSAGE_CC_STATUS_UNKNOWN") + ` (${processedPayment.creditCardProcessorStatus.message})`;
                        }
                        if (processedPayment.creditCardProcessorStatus.processorMessage) {
                            let processorDetailsHeading = this.$translate.instant('LABEL_PROCESSOR_DETAILS');
                            // add translated heading and detail
                            message = message + '<br/><b>' + processorDetailsHeading + ':</b> ' + processedPayment.creditCardProcessorStatus.processorMessage.replace("\n", "<br/>");
                        }
                        this.busyService.stop();
                        return this.modalService.alert(message, Components.Modal.ModalTranslationModes.DoNotTranslate).then(() => {
                            this.busyService.start();
                            if (processedPayment.paymentRequestStatus === Model.PaymentRequestStatusEnum.Failed
                                && processedPayment.creditCardProcessorStatus.code === Model.ProcessingStatusEnum.Declined) {
                                this.printCreditCardReceipts([processedPayment], false, true);
                            }
                            return false;
                        });
                    }
                    return false;
                }
            }
        };

        printCreditCardReceiptsForReversal(reversalPayment) {
            let paymentRequestIds = [];
            // reversing just one payment which is the parent
            if (reversalPayment.parentId) {
                paymentRequestIds.push(reversalPayment.parentId);
            }
            // reversing all credit card payments via no sale
            else {
                paymentRequestIds.push(..._(this.sale.paymentLines.filter((payment) => {
                    return payment.paymentCategory === Model.PaymentCategoryEnum.CreditDebit &&
                        (payment as Model.SaleCreditCardPayment).paymentRequestId;
                })).pluck("paymentRequestId"));
            }
            let urlWithDataList: Components.Common.IHttpRequestObject[] = [];
            paymentRequestIds.forEach(paymentRequestId => {
                this.generateClientCreditCardReceiptRequest(urlWithDataList, paymentRequestId);
            });
            this.printCreditCardReceipts([reversalPayment], false, true, urlWithDataList);
        }

        requestForSignature() {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/modals/signatureModal.template.html",
                controller: "meevo.plugins.register.SignatureModalController",
                controllerAs: "vm",
                bindToController: true
            }
            this.modalService.showCustom(options);
        }

        reverseCreditDebitPayments(): ng.IPromise<any> {
            var amountToReverse: number = 0;
            var offsetIds: string[] = [];
            this.sale.paymentLines.forEach((pl) => {
                if (pl.paymentCategory == Model.PaymentCategoryEnum.CreditDebit) {
                    (<Model.SaleCreditCardPayment>pl).reverse = true;
                    amountToReverse = this.addNormalizedNumbers(amountToReverse, pl.amount);
                    offsetIds.push((pl as Model.SaleCreditCardPayment).paymentRequestId);
                }
            });
            return this.startReversePaymentRequest(amountToReverse, offsetIds)
                .then((succeeded) => {
                    if (succeeded) {
                        // remove all credit/debit payments
                        for (var i = this.sale.paymentLines.length - 1; i >= 0; i--) {
                            let pl = this.sale.paymentLines[i];
                            if (pl.paymentCategory == Model.PaymentCategoryEnum.CreditDebit) {
                                this.sale.paymentLines.splice(i, 1);
                            }
                        }
                    }
                    return succeeded;
                });
        }

        getAllCreditCardPaymentTypesNotActive() {
            let request: any = {
                itemsPerPage: 1000,
                pageNumber: 0,
                criteria: {
                    includeActive: false,
                    includeDeleted: true,
                    includeInactive: true,
                    paymentCategory: Meevo.Model.PaymentCategoryEnum.CreditDebit
                }
            };
            return this.dataService.customMethodData("api/PaymentType/List", "POST", request)
                .then((response) => {
                    if (response && response.data) {
                        return response.data;
                    }
                    return [];
                });
        }

        hasInvalidPaymentTypesForSelfPay() {
            return _(this.sale.paymentLines).any(paymentLine =>
                paymentLine.paymentCategory === Model.PaymentCategoryEnum.Cash ||
                paymentLine.paymentCategory === Model.PaymentCategoryEnum.Check);
        }

        selectPaymentSection(sectionType: RegisterSectionTypeEnum, reset?: boolean) {
            if (sectionType === RegisterSectionTypeEnum.Self && this.hasInvalidPaymentTypesForSelfPay()) {
                this.modalService.alert("MESSAGE_UNABLE_SELF_PAY");
                return;
            }

            if (sectionType === RegisterSectionTypeEnum.PaymentPlan) {
                this.sale.saleLines.forEach((saleLine: Model.SaleLine) => {
                    if (this.paymentPlanService.canBeAddedToPaymentPlan(saleLine)) {
                        saleLine.hasPaymentPlan = true;
                    }
                });
            }

            this.updatePoleDisplayCashRounding(sectionType);

            return this.selectSection(sectionType, reset);
        }

        checkMembershipOrigination() {
            let client = this.returnStateClient;
            if (client) {
                let section = this.returnStateSection ? this.returnStateSection : "SECTION_MEMBERSHIPMANAGER_MAIN";
                this.goToState("membershipManager", Meevo.Model.MaintenanceFormState.Readonly, client.clientMembershipId, section, undefined, undefined, undefined, undefined, true);
                this.returnStateClient = undefined;
            }
        }

        //Sale Notes section
        //NOTE: Discount and Transaction Notes are treated by UI as same Note with different look features, though saved as separate notes with types. Other Sale Notes are taken care as per other Types
        showAddSaleNoteModal(saleNoteDisplayInDiscountChecked: boolean) {
            return this.registerNotesService.showAddSaleNoteModal(this, saleNoteDisplayInDiscountChecked);
        }

        saveSaleNote(noteText: string, isChecked: boolean) {
            if (this.selectedSection.sectionType === RegisterSectionTypeEnum.PaymentPlan) {
                this.paymentPlanService.updateNote(noteText, this);
                return;
            }
            return this.registerNotesService.saveSaleNote(this, noteText, isChecked);
        }

        setSaleNote(noteText: string, noteType: Model.SaleNoteTypeEnum) {
            return this.registerNotesService.setSaleNote(this.sale, noteText, noteType);
        }

        saleNotesMerge(additionalSaleNotes: Model.saleNote[], sale: Model.Sale = null) {
            sale = sale || this.sale;
            return this.registerNotesService.saleNotesMerge(sale, additionalSaleNotes);
        }

        saleNoteCanOpen(): boolean {
            return (this.allUniqueClients.length > 0);
        }
        //END Sale Notes section

        addClientFamily(clientId) {
            if (!clientId || clientId.length === 0) {
                return;
            }

            if (this.allowSharedRedemptionOfPointsWithinFamily) {
                this.dataService.getItem("client", clientId, "family").then(
                    (response: any) => {
                        let familyMembers = _(response.familyMembers).reject(member => member.id === clientId);
                        this.clientFamilyMembers.push({ clientId: clientId, familyMembers: familyMembers });
                    });
            }
        }

        removeClientFamily(clientId) {
            let client = _(this.clientFamilyMembers).where({ clientId: clientId });
            this.clientFamilyMembers.splice(_.indexOf(this.clientFamilyMembers, client), 1);
        }

        getDisplayName(saleLine: Model.SaleLine) {
            // TODO: needs internationalization
            // this should eventually converge with transactionEditor.context - getItemDisplayName

            if (!saleLine || !saleLine.item) {
                return "";
            }

            switch (saleLine.saleType) {
                case Model.SalesTypeEnum.DepositCredit:
                    let item = saleLine.item as Model.ClientAccountSaleLineItem;
                    let clientAccountCreditText = this.$translate.instant("LABEL_DEPOSIT_CREDIT_FOR", { serviceShortcut: item.serviceShortcut, clientDisplayName: item.clientDisplayName });
                    return clientAccountCreditText;
                case Model.SalesTypeEnum.PaymentSurcharge:
                    return `${this.$translate.instant("LABEL_SURCHARGE")} (${saleLine.refundTransactionId})`;
            }

            return saleLine.item.displayName;
        }

        selfCheckout() {
            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/modals/selfCheckoutModal.template.html",
                controller: "meevo.plugins.register.SelfCheckoutController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                }
            };
            this.modalService.showCustom(modalOptions).then((response) => {
                if (response) {
                    this.sale.selfCheckoutClientId = response.id;
                    this.onHold();
                }
            })
        }

        getRefundLines(saleLine: Model.SaleLine) {
            if (saleLine.isRefund &&
                saleLine.saleType === Meevo.Model.SalesTypeEnum.ReloadGiftCard) {
                return this.sale.saleLines.filter(existingSaleLine =>
                    existingSaleLine.isRefund &&
                    existingSaleLine.item.id === saleLine.item.id
                );
            }

            return this.sale.saleLines.filter(existingSaleLine =>
                existingSaleLine.refundSaleId == (saleLine.refundSaleId || saleLine.saleId) &&
                existingSaleLine.refundSaleLineId == (saleLine.refundSaleLineId || saleLine.id) &&
                existingSaleLine.refundLocationId == (saleLine.refundLocationId || saleLine.locationId) &&
                existingSaleLine.refundTransactionId == (saleLine.refundTransactionId || saleLine.transactionId)
            );
        }
        getExistingSaleLineForRefund(saleLine: Model.SaleLine): Model.SaleLine {
            let existingSaleLines = this.getRefundLines(saleLine);

            if (existingSaleLines.length === 0) {
                return undefined;
            }

            if (this.isSaleLineItemRedeemableWithPackage(saleLine) && saleLine.redeemedPackageItems) {
                let packageItemIds = _(saleLine.redeemedPackageItems).pluck("id");

                return _(existingSaleLines).find(existingSaleLine => {
                    var existingSaleLinePackageItemIds = _(existingSaleLine.redeemedPackageItems).pluck("id");
                    return _(existingSaleLinePackageItemIds).any(id => packageItemIds.indexOf(id) > -1);
                });
            }

            switch (saleLine.saleType) {
                case Model.SalesTypeEnum.Package:
                    var packageId = (<Model.PackageSaleLineItem>saleLine.item)
                        .clientPackage.id;
                    return _(existingSaleLines).find(existingSaleLine => {
                        var existingSaleLineItem = existingSaleLine.item as Model.PackageSaleLineItem;
                        return existingSaleLineItem &&
                            existingSaleLineItem.clientPackage &&
                            existingSaleLineItem.clientPackage.id === packageId
                    });
                case Model.SalesTypeEnum.ReloadGiftCard:
                    var giftCardId = (<Model.GiftCardSaleLineItem> saleLine.item)
                        .clientGiftCard.id;
                    return _(existingSaleLines).find(existingSaleLine =>
                        (<Model.GiftCardSaleLineItem>existingSaleLine.item)
                        .clientGiftCard.id === giftCardId);
                case Model.SalesTypeEnum.Membership:
                    var clientMembershipId = saleLine.item.id;
                    return _(existingSaleLines).find(existingSaleLine => existingSaleLine.item.id === clientMembershipId);
                default:
                    return existingSaleLines[0];
            }
        }

        public isSingleLocation(): boolean {
            if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                return this.identityService.current().isSingleLocation;
            else
                return false;
        }

        showClientReferralModal(clients: any = undefined): angular.IPromise<boolean> {
            let defer = this.$q.defer<boolean>();
            clients = this.getClientsForReferralModal(clients ? clients : _(this.allUniqueClients)
                .pluck('client').filter(registerClient => !!registerClient && !!registerClient.id));
            if (clients.length > 0) {
                return this.registerController.referralService.displayReferralsSinceClientLastVisit(clients);
            } else {
                defer.resolve(true);
                return defer.promise;
            }
        }

        private getClientsForReferralModal(clients) {
            let retClients: any[] = [];
            _(clients).each(client => {
                if (!_(this.clientsForReferralExclude).contains(client.id)) {
                    retClients.push(client);
                    this.clientsForReferralExclude.push(client.id);
                }
            });
            return retClients;
        }

        getClientCombinedAfterActions(clients: any[] = undefined, sale: Model.Sale = undefined): angular.IPromise<boolean> {
            const showAggregatedNotes = () => {
                let clientObj: any[] = clients
                    ? [{ client: clients[0] }]
                    : undefined;

                return this.registerNotesService.showAggregatedNotes(this, clientObj, sale)
                    .finally(() => this.isPopulatingTicketFromAppointmentServices = false);
            };

            // don't show client referral modal in history mode
            if (this.registerTicketService.isPastTransactionMode) {
                return showAggregatedNotes();
            } else {
                return this.showClientReferralModal(clients).then(() => {
                    return showAggregatedNotes();
                });
            }
        }

        selectPaymentLine(paymentLine: Model.SalePayment): angular.IPromise<void> {
            if (paymentLine.paymentCategory === Model.PaymentCategoryEnum.PaymentPlan) {
                this.isRefundMode = false;
                if (paymentLine.amount < 0) {
                    this.isRefundMode = true;
                    this.paymentPlanPaymentsSection.calculateReduction = false;
                }
                return this.selectSection(RegisterSectionTypeEnum.PaymentPlan, false, false).then(() => {
                    if (!this.isRefundMode) {
                        this.selectedSection.edit(paymentLine);
                    }
                });
            }
            return this.$q.resolve();
        }

        selectSaleLine(saleLine: Model.SaleLine) {
            if (saleLine.saleType === Model.SalesTypeEnum.PaymentPlanReduction ||
                (saleLine.isRefund && this.paymentPlanService.paymentPlanHasRemainingBalance(saleLine.paymentPlanId))) {
                this.isRefundMode = true;
                this.paymentPlanPaymentsSection.calculateReduction = false;
                this.selectSection(RegisterSectionTypeEnum.PaymentPlan);
            }
        }

        setSaleOnHoldId(onHoldId, holdType?) {
            if (!onHoldId) {
                return;
            }
            this.sale.onHoldIds = {};
            this.sale.onHoldIds[onHoldId] = holdType || Meevo.Model.HoldTypeEnum.Recovery;
        }

        updatePaymentLineWithPaymentRequest(paymentRequest: Model.PaymentRequest, paymentLine: Model.SaleCreditCardPayment) {
            if (paymentLine) {
                paymentLine.paymentRequest = paymentRequest;
                paymentLine.paymentRequestId = paymentRequest.id;
                paymentLine.creditCardNumber = paymentRequest.creditCardNumber;
                paymentLine.creditCardType = paymentRequest.creditCardType;
                paymentLine.creditCardExpirationDate = paymentRequest.creditCardExpirationDate;
                paymentLine.cardEntryType = paymentRequest.emvEntryMode;
                paymentLine.paymentTypeId = paymentRequest.paymentTypeId;
                paymentLine.paymentTypeDisplayName = paymentRequest.paymentTypeDisplayName;
                paymentLine.isPending = false;
                paymentLine.amount = paymentRequest.approvedAmount;
                paymentLine.approvedAmount = paymentRequest.approvedAmount;
                paymentLine.tipAmount = paymentRequest.tipAmount;
                paymentLine.surcharge = paymentRequest.surcharge;
            }

            this.setSaleOnHoldId(paymentRequest.onHoldId, paymentRequest.holdType);
            this.updateSelfPaymentWithOnHoldId(paymentRequest.onHoldId, false);
        }

        getLinkedRefundSaleLine(saleLine: Model.SaleLine, allSaleLines: Model.SaleLine[]): Model.SaleLine {
            if (!this.saleLineHasLinkedIds(saleLine)) {
                return;
            }

            let linkedRefundSaleLine = allSaleLines
                .find(saleLineCandidate =>
                    saleLineCandidate.refundLocationId === saleLine.refundLocationId &&
                    moment(saleLineCandidate.refundSaleDate).isSame(saleLine.refundSaleDate) &&
                    saleLineCandidate.refundSaleId === saleLine.refundSaleId &&
                    saleLineCandidate.refundSaleLineId === saleLine.linkedSaleLineIds[0]);

            return linkedRefundSaleLine;
        }

        updateRefundLineLink(saleLine: Model.SaleLine) {
            if (this.isSaleLineServiceOrSwapFee(saleLine) && saleLine.linkedSaleLineIds) {
                var linkedSaleLine = this.getLinkedRefundSaleLine(saleLine, this.sale.saleLines);
                if (linkedSaleLine) {
                    saleLine.isLinkedRefundLine = true;
                    linkedSaleLine.isLinkedRefundLine = true;
                    linkedSaleLine.linkedSaleLineIds = [+saleLine.refundSaleLineId];
                }
            }
        }

        saleLineHasLinkedIds(saleLine: Model.SaleLine) {
            return saleLine.linkedSaleLineIds && saleLine.linkedSaleLineIds.length > 0;
        }

        updateLinkedSwapFeeSaleLine(saleLine: Model.SaleLine) {
            let feeSaleLine = this.getLinkedSwapFeeSaleLine(saleLine);
            if (feeSaleLine) {
                feeSaleLine.employee = saleLine.employee;
                feeSaleLine.employeeId = saleLine.employee.id ? saleLine.employee.id : Guid.empty.toString();
            }
        }

        getLinkedSwapFeeSaleLine(saleLine: Model.SaleLine) {
            if (this.saleLineHasLinkedIds(saleLine)) {
                return _.find(this.sale.saleLines, (sl) => sl.id === saleLine.linkedSaleLineIds[0]);
            } else {
                if (saleLine.packageRedemptionPath && saleLine.packageRedemptionPath.totalSwapFee > 0) {
                    return _.find(this.sale.saleLines, (sl) => {
                        return sl.saleType === Model.SalesTypeEnum.PackageServiceSwapFee && _.find(saleLine.redeemedPackages, (cp) => {
                            return _.findWhere(cp.packageServices, { id: (sl.item as Model.PackageServiceSwapFeeSaleLineItem).clientPackageServiceId }) != null;
                        });
                    });
                }
            }
        }

        getSmallestAmountForCurrency() {
            return this.roundingService.normalizeDecimalPlaces(
                Math.pow(1 / 10, this.identityService.current().decimalPositions));
        }

        clearSaleSyncAppointmentUpdates() {
            if (this.sale) {
                this.sale.syncAppointmentUpdates = null;
            }
        }

        getRefundSaleKeys() {
            return _.chain(this.sale.saleLines)
                .filter((sl: Model.SaleLine) => {
                    return (sl.isRefund
                        && Model.Guard.isSomething(sl.refundSaleDate)
                        && Model.Guard.isSomething(sl.refundSaleId));
                })
                .map((sl: Model.SaleLine) => {
                    return {
                        locationId: sl.refundLocationId,
                        saleDate: sl.refundSaleDate,
                        saleId: sl.refundSaleId,
                        saleLineId: sl.refundSaleLineId
                    };
                })
                .uniq((sl) => `${sl.locationId}_${sl.saleDate}_${sl.saleId}_${sl.saleLineId}`)
                .value();
        }

        getRefundTipKeys() {
            return _.chain(this.sale.tipLines)
                .filter((tl: Model.TipLine) => {
                    return (tl.isRefund
                        && Model.Guard.isSomething(tl.refundSaleDate)
                        && Model.Guard.isSomething(tl.refundSaleId));
                })
                .map((tl: Model.TipLine) => {
                    return {
                        locationId: tl.refundLocationId,
                        saleDate: tl.refundSaleDate,
                        saleId: tl.refundSaleId,
                        saleTipId: tl.refundTipLineId,
                        convenienceFee: tl.convenienceFee,
                        externalTipTransactionId: tl.externalTipTransactionId,
                    };
                })
                .value();
        }

        getPaymentRequestBasedOnRefundItems(includeZeroBalance = false) {
            const refundSaleKeys = this.getRefundSaleKeys();
            const refundTipKeys = this.getRefundTipKeys();

            if ((refundSaleKeys && refundSaleKeys.length > 0) ||
                (refundTipKeys && refundTipKeys.length > 0)) {
                let request = {
                    paymentCategory: Meevo.Model.PaymentCategoryEnum.CreditDebit,
                    saleKeys: refundSaleKeys,
                    saleTipKeys: refundTipKeys,
                    includeZeroBalance
                };

                return this.dataService.customMethodData(`/api/Drawer/${this.selectedDrawer.id}/RefundablePaymentRequest/List`, "POST", request)
                    .then((response) => {
                        if (!response.data) {
                            return [];
                        }

                        response.data.forEach((item) => {
                            item.amountToRefund = 0;
                        });

                        return response.data;
                    });
            }
            else {
                return this.$q.resolve([]);
            }
        }

        public isTippyKioskMode() {
            return this.tippyService.getTippyMode(this.selectedDrawer.id).then(tippyMode => {
                this.sale.isTippyKioskMode = tippyMode === Plugins.Tippy.TippyMode.Kiosk;
                return this.sale.isTippyKioskMode;
            });
        }

        public saleHasExternalTips(excludeRefund: boolean = false): boolean {
            return this.tippyService.hasExternalTip(this.sale, excludeRefund);
        }

        public getSelfPayTippyEligibility(unauthorizedConfig: Meevo.Plugins.Tippy.IUnauthorizedConfig): ng.IPromise<any> {
            let defer = this.$q.defer();
            this.tippyService.isSaleTippyEligible(this.sale, unauthorizedConfig)
                .then(resp => {
                    defer.resolve({ pre: resp, post: resp, continueWithSelfPay: true });
                })
                .catch((ex) => {
                    if (!ex.data || !ex.data.skipInterceptor) {
                        defer.reject(ex);
                        return;
                    }
                    //Unauthorized
                    this.modalService.confirmHandler(ex.message, Components.Modal.ModalTranslationModes.AsHtml).then((resp) => {
                        if (resp) { //Keeping as self pay
                            defer.resolve({ pre: false, post: false, isUnauthorized: true, continueWithSelfPay: true });
                        }
                        else { //Keeping as register hold
                            defer.resolve({ pre: false, post: true, isUnauthorized: true, continueWithSelfPay: false });
                        }
                    })

                });

            return defer.promise;
        }

        public isPaymentCatDisabled(paymentCat: RegisterPaymentCat): boolean {
            return paymentCat.isDisabled || (paymentCat.sectionType === RegisterSectionTypeEnum.Self && this.saleHasExternalTips());
        }

        private saleLineHasTippyServiceCharge(saleLine: Model.SaleLine): boolean {
            return saleLine && saleLine.isRefund && !!saleLine.externalTipTransactionId;
        }

        getHasHsaFsaMerchantAccounts(): ng.IPromise<boolean> {
            return this.dataService.customMethodData('api/MerchantAccount/List', 'POST', {
                pageNumber: 0,
                itemsPerPage: 999,
                criteria: {
                    merchantAccountProvider: this.getMerchantProviderId(),
                    getDefaultAccountOnly: false
                }
            }).then(response => {
                return response.data &&
                    response.data.some(merchantAccount => merchantAccount.isHsaFsa);
            });
        }

        public showSurcharge() {
            return this.sale && this.sale.surchargeTotal;
        }

        getRedeemedPUTPackages(saleLine?: Model.SaleLine): Array<any> {
            const redeemedPUTPackages = saleLine
                && saleLine.redeemedPackages
                && saleLine.redeemedPackages.filter(pkg => {
                    return pkg.category === Model.PackageTypeCategoryEnum.ProductUsageTracking;
                });
            return redeemedPUTPackages || [];
        }

        private isPartialRedemptionRemainder(saleLine: Model.SaleLine) {
            return saleLine.item && saleLine.item.productUsage && saleLine.item.productUsage.isPartialRedemptionRemainder;
        }
    }
}
